export const races = {
    "1": "娜歐",
    "2": "女神茉麗安",
    "3": "新錫古",
    "4": "棕熊",
    "5": "魅魔 克莉絲",
    "6": "格里斯貝恩",
    "7": "黑暗領主",
    "8": "黑暗領主",
    "9": "闇黑騎士",
    "10": "魯艾利",
    "11": "特里歐納",
    "12": "聖騎士見習生",
    "13": "瑞達爾",
    "14": "艾斯拉",
    "15": "塔巴勒塔斯",
    "16": "露雅",
    "17": "塔巴勒塔斯",
    "18": "巨大白狼",
    "19": "雅戈",
    "20": "拉不拉多拾獵犬",
    "21": "科隆克斯亞",
    "22": "科隆克斯亞",
    "23": "魯艾利",
    "24": "莫克",
    "25": "人類",
    "26": "闇黑巫師",
    "27": "姬琳",
    "28": "庫魯格",
    "29": "維伊德",
    "30": "瓦安特",
    "31": "陶恩斯",
    "32": "洛瓦伊",
    "33": "娜歐",
    "34": "洛瓦伊",
    "35": "娜歐",
    "36": "雅拉塔",
    "37": "藍色巨龍",
    "38": "科隆 克斯亞",
    "39": "亞多利爾",
    "40": "弩炮(畫面)",
    "41": "佛格斯",
    "42": "派瑞克",
    "43": "牧羊犬",
    "44": "卡芬",
    "45": "德比",
    "46": "艾爾拉哈",
    "47": "派瑞克",
    "48": "多琳",
    "49": "闇黑戰士",
    "50": "司令部士兵",
    "51": "司令部弓箭手",
    "52": "倖存的士兵",
    "53": "法隆的士兵",
    "54": "魯",
    "55": "格里斯貝恩",
    "56": "格拉納特",
    "57": "安德拉絲",
    "58": "卡芬",
    "59": "分身幻像",
    "60": "分身幻像",
    "61": "分身幻像",
    "62": "分身幻像",
    "63": "分身幻像",
    "64": "惡翅魅魔",
    "65": "女神妮潘",
    "66": "被俘士兵",
    "67": "庫魯格",
    "68": "마네키네코",
    "69": "마네키네코",
    "70": "신묘한 고양이",
    "71": "신묘한 고양이",
    "72": "女神茉麗安",
    "73": "新錫古",
    "74": "女神妮潘",
    "75": "格里斯貝恩",
    "76": "女神茉麗安",
    "77": "女神茉麗安",
    "78": "諾亞達",
    "79": "諾亞達",
    "80": "諾亞達",
    "81": "達爾",
    "82": "達爾",
    "83": "女神妮潘",
    "84": "女神茉麗安",
    "85": "諾亞達",
    "86": "達爾",
    "87": "王城鍊金術師",
    "88": "王城鍊金術師",
    "89": "王城鍊金術師",
    "90": "王城鍊金術師",
    "91": "王城鍊金術師",
    "92": "王城鍊金術師",
    "93": "王城鍊金術師",
    "94": "王城鍊金術師",
    "95": "達爾",
    "96": "諾亞達",
    "97": "女神妮潘",
    "98": "諾亞達",
    "99": "女神茉麗安",
    "100": "惡魔貓",
    "101": "諾亞達",
    "102": "達爾",
    "103": "雷諾斯",
    "104": "雷諾斯",
    "105": "諾亞達",
    "106": "翼之狂暴",
    "107": "魯",
    "108": "C4 NPC前任騎士",
    "109": "C4 NPC前任騎士02",
    "110": "畫中死神",
    "111": "畫中死神",
    "112": "人類",
    "113": "畫中死神",
    "114": "勃蘭登堡",
    "115": "勃蘭登堡",
    "116": "各耳板",
    "117": "艾絲琳",
    "118": "艾絲琳",
    "119": "艾絲琳",
    "120": "人類",
    "121": "勃蘭登堡",
    "122": "魅魔",
    "123": "工人",
    "124": "羅尼",
    "125": "海賊船員",
    "126": "幼小的比利",
    "127": "貪婪的 莫里斯",
    "128": "托曼",
    "129": "海賊船員",
    "130": "裝蒜的露西",
    "131": "陰沉的珠莉",
    "132": "拖油瓶莫里斯",
    "133": "背叛者比利",
    "134": "貝拉",
    "135": "勃蘭登堡",
    "136": "勃蘭登堡",
    "137": "勃蘭登堡",
    "138": "畫中死神",
    "139": "蒙特",
    "140": "貝爾法斯特警衛隊員",
    "141": "貝爾法斯特警衛隊員",
    "142": "工人",
    "143": "工人",
    "144": "堵",
    "145": "珍娜",
    "146": "蒂尼",
    "147": "奇斯",
    "148": "暗殺者",
    "149": "暗殺者",
    "150": "暗殺者",
    "151": "偽裝怪",
    "152": "鬼魂偽裝怪",
    "153": "鬼怪",
    "154": "藍色鬼怪",
    "155": "紅色鬼怪",
    "156": "締下契約的 虛無騎士",
    "157": "食屍鬼",
    "158": "食屍鬼",
    "159": "巨大飛蛾",
    "160": "半巫妖",
    "161": "大師巫妖",
    "162": "魯 羅巴達",
    "163": "赤茉麗安",
    "164": "安德拉絲",
    "165": "佩丹",
    "166": "錫妮",
    "167": "歐文提督",
    "168": "歐蘭",
    "169": "撒拉布蘭道馬",
    "170": "巨人士兵",
    "171": "巨人士兵",
    "172": "精靈士兵",
    "173": "精靈士兵",
    "174": "人類士兵",
    "175": "人類士兵",
    "176": "偵查員",
    "177": "偵查員",
    "178": "王城鍊金術師",
    "179": "王城鍊金術師",
    "180": "墮落的安巴爾",
    "181": "墮落的安巴爾",
    "182": "鎧甲骷髏",
    "183": "鎧甲骷髏",
    "184": "洞穴沙華魚人魔法師",
    "185": "洞穴沙華魚人戰士",
    "186": "莎士比亞",
    "187": "殭屍",
    "188": "殭屍",
    "189": "締下契約的 虛無騎士",
    "190": "食屍鬼",
    "191": "食屍鬼",
    "192": "偽裝怪",
    "193": "鬼魂偽裝怪",
    "194": "梅魯",
    "195": "梅魯",
    "196": "梅魯",
    "197": "馬納南巨魔像",
    "198": "王城警衛",
    "199": "王城警衛",
    "200": "鬼魂",
    "201": "蘇俄牧羊犬",
    "202": "哈士奇",
    "203": "하우징 npc 악사 - 류트 (임시)",
    "204": "하우징 npc 악사 - 피리 (임시)",
    "205": "하우징 npc 악사 - 플룻 (임시)",
    "206": "斷手的棕色老鼠",
    "207": "斷手的灰色老鼠",
    "208": "斷手的黑老鼠",
    "209": "斷手的黃金老鼠",
    "210": "斷手的紅老鼠",
    "211": "斷手的毛毛老鼠",
    "212": "斷手的巨大毛毛老鼠",
    "213": "斷手的洞窟老鼠",
    "214": "斷手的洞窟老鼠",
    "215": "斷手的溝鼠",
    "216": "卡爾汀",
    "217": "艾蕾蒙",
    "218": "錫古手下",
    "219": "錫古手下",
    "220": "歐文提督",
    "221": "王城鍊金術師",
    "222": "王城鍊金術師",
    "223": "班卡特",
    "224": "偵查員",
    "225": "偵查員",
    "226": "烏垃蒙",
    "227": "巨大白色雪原熊",
    "228": "巨大棕鷹",
    "229": "薛希爾",
    "230": "優依",
    "231": "米娜",
    "232": "凱",
    "233": "薛希爾",
    "234": "優依",
    "235": "米娜",
    "236": "凱",
    "237": "掠奪團哥布林",
    "238": "掠奪團哥布林弓箭手",
    "239": "掠奪團妖魔",
    "240": "掠奪團人類",
    "241": "掠奪團巨人",
    "242": "掠奪團頭目",
    "243": "劇毒的 奇蘭",
    "244": "吝嗇鬼 斯可路",
    "245": "掠奪少女 德路比",
    "246": "凶惡的 華拉杜魯",
    "247": "凶惡的 華拉杜魯",
    "248": "掠奪團哥布林",
    "249": "掠奪團哥布林弓箭手",
    "250": "掠奪團妖魔",
    "251": "掠奪團人類",
    "252": "掠奪團巨人",
    "253": "掠奪少女 德路比",
    "254": "掠奪團頭目",
    "255": "凱",
    "256": "凱",
    "257": "凱",
    "258": "凱",
    "259": "搜刮一通的 克萊傑",
    "260": "安德拉絲",
    "261": "佩丹",
    "262": "錫妮",
    "263": "歐蘭",
    "264": "巨大獅子",
    "265": "夏瑪拉",
    "266": "SAO管理者",
    "301": "<mini>NPC</mini> 堤洛",
    "311": "陶恩斯",
    "312": "陶恩斯",
    "313": "雅拉塔",
    "314": "一般市民",
    "315": "一般市民",
    "316": "一般市民",
    "317": "一般市民",
    "318": "娜歐",
    "319": "寶箱",
    "320": "狂暴化的 哈樂德",
    "321": "貿易團妖魔",
    "322": "貿易團哥布林",
    "323": "貿易團食人魔",
    "324": "見習掠奪者哥布林",
    "325": "見習掠奪者哥布林弓箭手",
    "327": "見習掠奪者妖魔",
    "328": "見習掠奪者人類",
    "329": "見習掠奪者巨人",
    "330": "見習掠奪團頭目",
    "331": "見習掠奪團頭目",
    "332": "掠奪者哥布林 無限斬擊",
    "333": "掠奪者哥布林 旋風箭",
    "334": "掠奪者哥布林 毒雲箭",
    "335": "掠奪者哥布林 爆裂箭",
    "336": "掠奪者巨人 騎槍",
    "337": "掠奪者巨人 投擲攻擊",
    "338": "掠奪者妖魔 雷擊",
    "339": "掠奪者妖魔 火球",
    "340": "掠奪者妖魔 冰刃",
    "341": "掠奪者人類 躍擊",
    "342": "掠奪者人類 冰風暴",
    "343": "掠奪者人類 火焰噴射",
    "344": "掠奪者人類 吸取生命",
    "345": "掠奪者食人魔 自然防護",
    "346": "掠奪者食人魔 抵抗",
    "347": "掠奪者食人魔 魔法反射",
    "348": "貿易團哥布林",
    "349": "2年資歷的掠奪者哥布林",
    "350": "2年資歷的掠奪者哥布林弓箭手",
    "351": "2年資歷的掠奪者妖魔",
    "352": "2年資歷的掠奪者人類",
    "353": "2年資歷的掠奪者巨人",
    "354": "2年資歷的掠奪團頭目",
    "355": "2年資歷的掠奪團頭目",
    "356": "熟能生巧的掠奪者哥布林",
    "357": "熟能生巧的掠奪者哥布林弓箭手",
    "358": "熟能生巧的掠奪者妖魔",
    "359": "熟能生巧的掠奪者人類",
    "360": "熟能生巧的掠奪者巨人",
    "361": "熟能生巧的掠奪團頭目",
    "362": "熟能生巧的掠奪團頭目",
    "363": "老練的掠奪者哥布林",
    "364": "老練的掠奪者哥布林弓箭手",
    "365": "老練的掠奪者妖魔",
    "366": "老練的掠奪者人類",
    "367": "老練的掠奪者巨人",
    "368": "老練的掠奪團頭目",
    "369": "老練的掠奪團頭目",
    "370": "一流掠奪者哥布林",
    "371": "一流掠奪者哥布林弓箭手",
    "372": "一流掠奪者妖魔",
    "373": "一流掠奪者人類",
    "374": "一流掠奪者巨人",
    "375": "一流掠奪團頭目",
    "376": "一流掠奪團頭目",
    "377": "貿易所的大象",
    "378": "貿易所的馬",
    "379": "生疏的 掠奪團妖魔",
    "380": "使用道具的 掠奪團哥布林",
    "381": "使用道具的 掠奪團妖魔",
    "382": "使用道具的 掠奪團人類",
    "383": "使用道具的 掠奪團巨人",
    "384": "使用道具的 掠奪團頭目",
    "385": "掠奪團哥布林",
    "386": "掠奪團哥布林弓箭手",
    "387": "掠奪團妖魔",
    "388": "掠奪團人類",
    "389": "掠奪團巨人",
    "390": "掠奪團頭目",
    "391": "娜歐",
    "392": "走私商人的大象",
    "393": "獨眼 佩勒斯",
    "394": "身分不明的 葛魯奇",
    "395": "劇毒的 奇蘭",
    "396": "搜刮一通的 克萊傑",
    "397": "掠奪少女 德路比",
    "398": "凶惡的 華拉杜魯",
    "399": "吝嗇鬼 斯可路",
    "400": "老練的 掠奪團哥布林",
    "401": "老練的 掠奪團哥布林弓箭手",
    "402": "老練的 掠奪團妖魔",
    "403": "老練的 掠奪團人類",
    "404": "老練的 掠奪團巨人",
    "405": "一流 掠奪團哥布林",
    "406": "一流 掠奪團哥布林弓箭手",
    "407": "一流 掠奪團妖魔",
    "408": "一流 掠奪團人類",
    "409": "一流 掠奪團巨人",
    "410": "獨眼 佩勒斯",
    "411": "身分不明的 葛魯奇",
    "412": "劇毒的 奇蘭",
    "413": "搜刮一通的 克萊傑",
    "414": "掠奪少女 德路比",
    "415": "凶惡的 華拉杜魯",
    "416": "吝嗇鬼 斯可路",
    "417": "哥布林守衛",
    "418": "哥布林守衛弓箭手",
    "419": "採集農場石的妖魔",
    "420": "耕田的人類",
    "421": "劈柴的巨人",
    "422": "執事用馬",
    "423": "掠奪團哥布林",
    "424": "掠奪團妖魔",
    "425": "掠奪團人類",
    "426": "掠奪團巨人",
    "427": "格里斯貝恩炸彈娃娃",
    "428": "記憶中的藥草豬",
    "430": "賞金獵人",
    "431": "小鬼頭 修",
    "432": "小鬼頭",
    "433": "朋友",
    "434": "木頭人",
    "435": "棕熊",
    "436": "紅熊",
    "437": "迷你可卡獵犬",
    "438": "青苔團",
    "439": "巨大青苔塊",
    "440": "被救出的人質",
    "441": "恐怖份子 哥布林",
    "442": "恐怖份子 哥布林弓箭手",
    "443": "恐怖份子 妖魔",
    "444": "恐怖份子 食人魔",
    "445": "初音未來",
    "446": "聖誕妖精",
    "447": "聖誕搗蛋鬼",
    "448": "聖誕馴鹿",
    "501": "蜜莉亞",
    "502": "黑龍騎士",
    "503": "夏瑪拉",
    "504": "阿庫垃",
    "505": "凱薩",
    "506": "白龍",
    "507": "黑龍",
    "521": "巨大惡靈",
    "522": "黑尾貓鼬",
    "523": "微微發光的石頭翼魔",
    "524": "夏瑪拉",
    "525": "阿庫垃",
    "526": "黑龍騎士",
    "527": "白龍",
    "528": "刀鋒飛龍",
    "529": "雪原殺手",
    "530": "柯西克雷德",
    "531": "雪原殺手",
    "532": "黑龍",
    "533": "惡靈 伊莉莎白",
    "534": "黑龍騎士",
    "535": "莎士比亞",
    "536": "人類",
    "537": "人類",
    "1000": "行人",
    "1001": "行人",
    "1002": "<mini>NPC</mini> 迷路的村民",
    "1003": "<mini>NPC</mini> 迷路的淘氣小朋友",
    "1004": "蝙蝠",
    "1005": "無眼惡狼",
    "1006": "黑狼蛛",
    "1007": "黑蜘蛛",
    "1008": "吸血蝙蝠",
    "1009": "迅速的 吸血蝙蝠",
    "1010": "藍惡狼",
    "1011": "藍色鬼魂",
    "1012": "藍灰熊",
    "1013": "青毒蛇",
    "1014": "青蛇",
    "1015": "藍狼人",
    "1016": "棕蛇",
    "1017": "圓滾滾老鼠",
    "1018": "偽裝怪",
    "1019": "棺材寶箱怪",
    "1020": "毀壞的 棺材寶箱怪",
    "1021": "鄉村老鼠",
    "1022": "緋紅惡狼",
    "1023": "緋紅灰熊",
    "1024": "緋紅蜘蛛",
    "1025": "紅色鬼怪",
    "1026": "鬼魂之王",
    "1027": "鬼魂偽裝怪",
    "1028": "食屍鬼",
    "1029": "巨大棕熊",
    "1030": "巨大豺狼",
    "1031": "巨大蜘蛛",
    "1032": "巨大狼人",
    "1033": "巨大山豬",
    "1034": "巨大森林豺狼",
    "1035": "黃金地靈",
    "1036": "戈耳戈",
    "1037": "灰鼠",
    "1038": "灰狼人",
    "1039": "巨大野鼠",
    "1040": "冰雪之魂",
    "1041": "豺狼",
    "1042": "地靈",
    "1043": "地靈弓箭手",
    "1044": "小田鼠",
    "1045": "小白蜘蛛",
    "1046": "溫馴的 蝙蝠",
    "1047": "寶箱怪",
    "1048": "古老的 寶箱怪",
    "1049": "劇毒地靈",
    "1050": "紅色鬼魂",
    "1051": "紅地靈",
    "1052": "紅地靈弓箭手",
    "1053": "紅蜘蛛",
    "1054": "紅蜘蛛黃蜂",
    "1055": "骷髏地獄犬",
    "1056": "蜘蛛弓箭手",
    "1057": "蜘蛛鬥士",
    "1058": "白蜘蛛",
    "1059": "白蜘蛛黃蜂",
    "1060": "屍妖",
    "1061": "小精靈",
    "1062": "山豬",
    "1063": "森林豺狼",
    "1064": "奧拉克妮",
    "1065": "鎧甲熊",
    "1066": "報喪女妖",
    "1067": "骷髏吟遊詩人",
    "1068": "巨大黑蜘蛛",
    "1069": "巨大黑蜘蛛",
    "1070": "黑梨鼠",
    "1071": "緋紅蜘蛛",
    "1072": "半巫妖",
    "1073": "藍色鬼怪",
    "1074": "藍色鬼怪",
    "1075": "巨大火焰之魂",
    "1076": "巨大黃金蜘蛛",
    "1077": "巨大無頭怪",
    "1078": "巨大妖魔",
    "1079": "巨大骷髏地獄犬",
    "1080": "巨大蜘蛛",
    "1081": "綠色搗蛋鬼",
    "1082": "地獄貓",
    "1083": "地獄犬",
    "1084": "大師巫妖",
    "1085": "巨大紅蜘蛛",
    "1086": "小巨魔像",
    "1087": "巨大白蜘蛛",
    "1088": "百眼巨人",
    "1089": "無眼惡狼",
    "1090": "黑毒蛇",
    "1091": "藍色鬼魂",
    "1092": "巨大女王飛蛾",
    "1093": "綠色搗蛋鬼",
    "1094": "虛無騎士",
    "1095": "幼蟲",
    "1096": "幼蟲",
    "1097": "巨大紅蜘蛛",
    "1098": "紅灰熊",
    "1099": "小巨魔",
    "1100": "升段考官",
    "1101": "升段考官",
    "1102": "聖誕老公公",
    "1103": "聖誕老公公",
    "1104": "聖誕老公公",
    "1105": "聖誕老公公",
    "1106": "聖誕老公公",
    "1107": "占星術師",
    "1108": "廟會商人",
    "1109": "蜘蛛遊俠",
    "1110": "蜘蛛士兵",
    "1111": "蜘蛛戰士",
    "1112": "狼人",
    "1113": "巨大白蜘蛛",
    "1114": "白毒蛇",
    "1115": "白蛇",
    "1116": "希茲克利夫",
    "1117": "血盟騎士團騎士",
    "1119": "露娜",
    "1120": "黑羊潘",
    "1121": "露娜",
    "1122": "黑羊潘",
    "1123": "香氛熊熊(蜘蛛)",
    "2000": "被侵蝕的 那伊德",
    "2001": "肉質鮮美的 野豬",
    "2002": "肉質頂級的 野豬",
    "2003": "被侵蝕的 科魯米納",
    "2004": "見習 海賊",
    "2005": "新手 海賊",
    "2006": "巨大棕熊",
    "2007": "黑鬍子",
    "2008": "黑巴特",
    "2009": "艾德拉克",
    "2010": "梅林",
    "2011": "教授J",
    "2012": "巨大棕熊",
    "2013": "巨大棕熊",
    "2014": "巨大棕熊",
    "2015": "巨大棕熊",
    "2016": "巨大棕熊",
    "2017": "紅狐狸",
    "2018": "黑色惡狼",
    "2019": "3年資歷的 海盜",
    "2020": "5年資歷的 海盜",
    "2021": "寶藏獵人",
    "2022": "紅色遺跡翼魔",
    "2023": "格里斯貝恩",
    "2024": "僵屍",
    "2025": "僵屍",
    "2026": "被侵蝕的 飛龍",
    "2027": "綁匪的熱氣球",
    "2028": "怪異生物",
    "2029": "吞食地圖的 怪異生物",
    "2030": "被侵蝕的 伊弗烈特",
    "2031": "被侵蝕的 火蜥蜴",
    "2032": "古代巫妖",
    "2033": "盜賊團員",
    "2034": "膽怯的 盜賊團員",
    "2035": "石碑",
    "2036": "被侵蝕的 強壯的飛龍",
    "2037": "盤起來的蛇",
    "2038": "流浪的蠍子",
    "2039": "碎石犀牛",
    "2040": "結果的 蜥蜴",
    "2041": "盜賊團員的屍體",
    "2042": "黑色沙漠蠍",
    "2043": "毒刺岩石蠍",
    "2044": "綁匪的狗雪橇",
    "2045": "凱薩",
    "2046": "浮空水晶",
    "2047": "承載記憶的水晶",
    "2048": "綁匪的狗雪橇",
    "2049": "堤安卡特",
    "2050": "堤安卡特",
    "2051": "堤安卡特",
    "2052": "惡靈弓箭手",
    "2053": "惡靈戰士",
    "2054": "凱薩",
    "2055": "猩猩",
    "2056": "猩猩",
    "2057": "魯艾利",
    "2058": "梅林",
    "2059": "凱薩",
    "2060": "魯艾利",
    "2061": "教授J",
    "2062": "DIVA",
    "2063": "DIVA",
    "2064": "伊利尼德的幻影",
    "2065": "凱薩",
    "2066": "凱薩",
    "2067": "變裝的梅林",
    "2068": "變裝的寶藏獵人",
    "2069": "堤安卡特的水晶",
    "2070": "凱薩",
    "2071": "凱薩(魔法型)",
    "2072": "凱薩(支援型)",
    "2073": "凱薩",
    "2074": "凱薩",
    "2075": "巨大白兔",
    "2076": "巨大棕兔",
    "2077": "黑兔",
    "2078": "基因突變兔子",
    "2079": "魯艾利",
    "2080": "凱薩",
    "2081": "魯艾利的幻影",
    "2082": "凱薩首領",
    "2083": "異變凱薩",
    "2084": "最上位凱薩",
    "2085": "最上位凱薩",
    "2086": "上位凱薩",
    "2087": "上位凱薩",
    "2088": "凱薩",
    "2089": "凱薩",
    "2090": "最上位凱薩",
    "2091": "特拉克",
    "2092": "警戒水晶",
    "2093": "金龍",
    "2094": "結界",
    "2095": "魯艾利的幻影",
    "2096": "黑色沙漠狐狸",
    "2097": "小貓熊",
    "3000": "吉爾迦斯",
    "3001": "吉爾迦斯",
    "3002": "吉爾迦斯",
    "3003": "吉爾迦斯",
    "3004": "吉爾迦斯",
    "3005": "吉爾迦斯",
    "3006": "吉爾迦斯",
    "3007": "殞石",
    "3008": "魔杖測試",
    "3009": "神聖侵蝕測試",
    "3010": "神聖禁錮測試",
    "3011": "파나티시즘 테스트",
    "3012": "靈魂吸收測試",
    "3013": "殞石流星雨測試",
    "3014": "莫爾坎",
    "3015": "斐埃爾",
    "3016": "布莉恩",
    "3017": "亞特",
    "3018": "艾薇琳",
    "3019": "托爾維斯",
    "3020": "白惡狼",
    "3021": "千年的 白惡狼",
    "3022": "黑色異變的熊",
    "3023": "紅色異變的熊",
    "3024": "黃色異變的熊",
    "3025": "藍色異變的熊",
    "3026": "白色異變的熊",
    "3027": "黑色異變的狼",
    "3028": "紅色異變的狼",
    "3029": "黃色異變的狼",
    "3030": "藍色異變的狼",
    "3031": "白色異變的狼",
    "3032": "黑色異變的野豬",
    "3033": "紅色異變的野豬",
    "3034": "黃色異變的野豬",
    "3035": "藍色異變的野豬",
    "3036": "白色異變的野豬",
    "3037": "莫爾坎",
    "3038": "斐埃爾",
    "3039": "布莉恩",
    "3040": "人類士兵",
    "3041": "人類士兵",
    "3042": "人類士兵",
    "3043": "人類士兵",
    "3044": "人類士兵",
    "3045": "人類士兵",
    "3046": "人類士兵",
    "3047": "人類士兵",
    "3048": "人類士兵",
    "3049": "人類士兵",
    "3050": "王城警衛",
    "3051": "王城警衛",
    "3052": "艾蕾蒙",
    "3053": "麗莎",
    "3054": "乳牛",
    "3055": "亞特",
    "3056": "艾薇琳",
    "3057": "托爾維斯",
    "3058": "千年的 黃色異變的熊",
    "3059": "千年的 黃色異變的狼",
    "3060": "千年的 黃色異變的野豬",
    "3061": "吉爾迦斯",
    "3062": "黃色異變的熊",
    "3063": "黃色異變的狼",
    "3064": "黃色異變的野豬",
    "3065": "吉爾迦斯",
    "3066": "吉爾迦斯",
    "3067": "吉爾迦斯",
    "3068": "吉爾迦斯",
    "3069": "吉爾迦斯",
    "3070": "流星雨狼",
    "3071": "流星雨野豬",
    "3072": "初期型吉爾迦斯",
    "3073": "吉爾迦斯",
    "3074": "人類士兵",
    "3100": "亞特",
    "3101": "艾薇琳",
    "3102": "托爾維斯",
    "3103": "卡茲遠",
    "3104": "畢奈",
    "3105": "艾薇琳",
    "3106": "托爾維斯",
    "3107": "卡茲遠",
    "3108": "畢奈",
    "3109": "初代團長",
    "3110": "冬至組組長",
    "3111": "秋收組組長",
    "3112": "立夏組組長",
    "3113": "春分組組長",
    "3114": "冬至組組長",
    "3115": "秋收組組長",
    "3116": "立夏組組長",
    "3117": "春分組組長",
    "3118": "冬至組團員",
    "3119": "冬至組團員",
    "3120": "秋收組團員",
    "3121": "秋收組團員",
    "3122": "立夏組團員",
    "3123": "立夏組團員",
    "3124": "春分組團員",
    "3125": "春分組團員",
    "3126": "斐埃爾",
    "3127": "布莉恩",
    "3128": "莫爾坎",
    "3129": "闇黑巫師",
    "3131": "傑巴赫",
    "3132": "傑巴赫",
    "3133": "傑巴赫",
    "3134": "異變的狼",
    "3135": "異變的野豬",
    "3136": "異變的熊",
    "3137": "看不見的人",
    "3138": "詭異的屍體",
    "3139": "異教徒",
    "3140": "異教徒",
    "3141": "異教徒的意念",
    "3142": "異教徒的意念",
    "3143": "復活的屍體",
    "3144": "復活的屍體",
    "3145": "復活的屍體",
    "3146": "復活的屍體",
    "3147": "復活的屍體",
    "3148": "復活的屍體",
    "3149": "復活的屍體",
    "3150": "復活的屍體",
    "3151": "復活的屍體",
    "3152": "卡茲遠",
    "3153": "托爾維斯",
    "3154": "卡茲遠",
    "3155": "受汙染的畢奈意念",
    "3156": "受汙染的畢奈意念",
    "3157": "藍螃蟹",
    "3158": "紅蟹",
    "3159": "白蟹",
    "3160": "靈魂",
    "3161": "畢奈",
    "3162": "警戒裝置",
    "3163": "火山犄角野豬",
    "3180": "亞特",
    "3181": "艾薇琳",
    "3182": "托爾維斯",
    "3183": "卡茲遠",
    "3184": "畢奈",
    "3200": "可娜",
    "3201": "艾樂莉絲",
    "3202": "艾希",
    "3203": "洛根",
    "3204": "寇爾",
    "3205": "戴伊",
    "3206": "可娜",
    "3207": "艾樂莉絲",
    "3208": "艾希",
    "3209": "洛根",
    "3210": "寇爾",
    "3211": "戴伊",
    "3212": "修安",
    "3213": "可娜",
    "3214": "艾樂莉絲",
    "3215": "艾希",
    "3216": "洛根",
    "3217": "寇爾",
    "3218": "戴伊",
    "3219": "可娜",
    "3220": "艾樂莉絲",
    "3221": "艾樂莉絲",
    "3222": "蓋爾人",
    "3223": "流氓",
    "3224": "流氓",
    "3225": "流氓",
    "3226": "修安",
    "3227": "可娜",
    "3228": "艾樂莉絲",
    "3229": "艾希",
    "3230": "洛根",
    "3231": "寇爾",
    "3232": "戴伊",
    "3233": "可娜",
    "3234": "艾樂莉絲",
    "3235": "艾希",
    "3236": "洛根",
    "3237": "寇爾",
    "3238": "戴伊",
    "3239": "吉爾迦斯",
    "3241": "哈西汀",
    "3242": "哈西汀",
    "3243": "哈西汀",
    "3246": "哈西汀",
    "3247": "白色礦物",
    "3248": "哈西汀",
    "3249": "哈西汀",
    "3250": "傑巴赫",
    "3251": "傑巴赫",
    "3252": "傑巴赫的幻影",
    "3253": "傑巴赫的幻影",
    "3254": "復活的屍體",
    "3255": "復活的屍體",
    "3256": "復活的屍體",
    "3257": "復活的屍體",
    "3300": "可娜",
    "3301": "艾樂莉絲",
    "3302": "艾希",
    "3303": "洛根",
    "3304": "寇爾",
    "3305": "戴伊",
    "3306": "黃色異變的巨熊",
    "3307": "黃色異變的巨狼",
    "3308": "黃色異變的巨大山豬",
    "3309": "異變的狼",
    "3310": "異變的野豬",
    "3311": "異變的熊",
    "3312": "復活的屍體",
    "3313": "復活的屍體",
    "3314": "復活的屍體",
    "3315": "復活的屍體",
    "3316": "復活的屍體",
    "3317": "復活的屍體",
    "3318": "復活的屍體",
    "3319": "復活的屍體",
    "3320": "慶典搗蛋鬼 艾蘿",
    "3321": "慶典搗蛋鬼 殭屍寶寶",
    "3322": "慶典搗蛋鬼 九尾狐",
    "3323": "可娜",
    "3324": "艾樂莉絲",
    "3325": "艾希",
    "3326": "洛根",
    "3327": "寇爾",
    "3328": "戴伊",
    "3329": "黃色異變的巨熊",
    "3330": "黃色異變的巨狼",
    "3331": "黃色異變的巨大山豬",
    "3332": "異變的狼",
    "3333": "異變的野豬",
    "3334": "異變的熊",
    "3335": "復活的屍體",
    "3336": "復活的屍體",
    "3337": "復活的屍體",
    "3338": "復活的屍體",
    "3339": "復活的屍體",
    "3340": "復活的屍體",
    "3341": "復活的屍體",
    "3342": "復活的屍體",
    "3343": "黃色異變的巨熊",
    "3344": "黃色異變的巨狼",
    "3345": "黃色異變的巨大山豬",
    "3346": "異變的狼",
    "3347": "異變的野豬",
    "3348": "異變的熊",
    "3349": "復活的屍體",
    "3350": "復活的屍體",
    "3351": "復活的屍體",
    "3352": "復活的屍體",
    "3353": "復活的屍體",
    "3354": "復活的屍體",
    "3355": "復活的屍體",
    "3356": "復活的屍體",
    "3357": "黃色異變的巨熊",
    "3358": "黃色異變的巨狼",
    "3359": "黃色異變的巨大山豬",
    "3360": "異變的狼",
    "3361": "異變的野豬",
    "3362": "異變的熊",
    "3363": "復活的屍體",
    "3364": "復活的屍體",
    "3365": "復活的屍體",
    "3366": "復活的屍體",
    "3367": "復活的屍體",
    "3368": "復活的屍體",
    "3369": "復活的屍體",
    "3370": "復活的屍體",
    "3371": "修安",
    "3372": "先知者們的追隨者",
    "3373": "異變的狼",
    "3374": "異變的狼",
    "3375": "異變的狼",
    "3376": "復活的屍體",
    "3377": "復活的屍體",
    "3378": "復活的屍體",
    "3379": "艾樂莉絲",
    "3380": "寇爾",
    "3381": "復活的屍體",
    "3382": "異變的野豬",
    "3383": "異變的狼",
    "3384": "復活的屍體",
    "3385": "黃色異變的巨狼",
    "3386": "黃色異變的巨大山豬",
    "3387": "黃色異變的巨熊",
    "3388": "復活的屍體",
    "3389": "洛根",
    "3390": "艾樂莉絲",
    "3391": "寇爾",
    "3392": "戴伊",
    "3393": "黃色異變的巨熊",
    "3394": "隱藏某事的先知者們的追隨者",
    "3395": "先知者們的追隨者",
    "3396": "先知者們的追隨者",
    "3397": "先知者們的追隨者",
    "3398": "先知者們的追隨者",
    "3399": "烈焰見習騎士支援軍",
    "3400": "烈焰見習騎士支援軍",
    "3401": "烈焰見習騎士支援軍",
    "3402": "烈焰見習騎士支援軍",
    "3403": "烈焰見習騎士支援軍",
    "3404": "烈焰見習騎士支援軍",
    "3405": "烈焰見習騎士支援軍",
    "3406": "烈焰見習騎士支援軍",
    "3407": "烈焰見習騎士支援軍",
    "3408": "烈焰見習騎士支援軍",
    "3409": "吉爾迦斯",
    "3410": "復活的屍體",
    "3411": "復活的屍體",
    "3450": "復活的屍體",
    "3451": "復活的屍體",
    "3452": "復活的屍體",
    "3453": "復活的屍體",
    "3454": "復活的屍體",
    "3455": "復活的屍體",
    "3456": "復活的屍體",
    "3457": "復活的屍體",
    "3458": "復活的屍體",
    "3459": "復活的屍體",
    "3460": "復活的屍體",
    "3461": "復活的屍體",
    "3462": "復活的屍體",
    "3463": "復活的屍體",
    "3464": "復活的屍體",
    "3465": "復活的屍體",
    "3466": "復活的屍體",
    "3467": "復活的屍體",
    "3468": "復活的屍體",
    "3469": "復活的屍體",
    "3470": "復活的屍體",
    "3471": "復活的屍體",
    "3472": "復活的屍體",
    "3473": "復活的屍體",
    "3474": "異變的熊",
    "3475": "黃色異變的巨大山豬",
    "3476": "黃色異變的巨狼",
    "3477": "黃色異變的巨熊",
    "3478": "先知者們的追隨者",
    "3479": "異變的狼",
    "3480": "復活的屍體",
    "3481": "復活的屍體",
    "3482": "復活的屍體",
    "3483": "復活的屍體",
    "3484": "復活的屍體",
    "3485": "黃色異變的巨熊",
    "3486": "黃色異變的巨熊",
    "3487": "復活的屍體",
    "3488": "復活的屍體",
    "3489": "復活的屍體",
    "3490": "異變的狼",
    "3491": "異變的狼",
    "3492": "異變的狼",
    "3493": "復活的屍體",
    "3494": "復活的屍體",
    "3495": "復活的屍體",
    "3496": "異變的野豬",
    "3497": "異變的狼",
    "3498": "黃色異變的巨狼",
    "3499": "黃色異變的巨大山豬",
    "3500": "黃色異變的巨熊",
    "3501": "復活的屍體",
    "3502": "復活的屍體",
    "3503": "黃色異變的巨熊",
    "3504": "黃色異變的巨狼",
    "3505": "黃色異變的巨大山豬",
    "3506": "隱藏某事的先知者們的追隨者",
    "3507": "先知者們的追隨者",
    "3508": "先知者們的追隨者",
    "3509": "先知者們的追隨者",
    "3510": "先知者們的追隨者",
    "3511": "異變的野豬",
    "3512": "異變的野豬",
    "3513": "異變的野豬",
    "3514": "異變的狼",
    "3515": "異變的狼",
    "3516": "異變的狼",
    "3517": "復活的屍體",
    "3518": "復活的屍體",
    "3519": "一流 掠奪團哥布林",
    "3520": "一流 掠奪團哥布林弓箭手",
    "3521": "一流 掠奪團妖魔",
    "3522": "一流 掠奪團人類",
    "3523": "一流 掠奪團巨人",
    "3524": "一流 掠奪團頭目",
    "3525": "一流 掠奪團頭目",
    "3526": "獨眼 佩勒斯",
    "3527": "身分不明的 葛魯奇",
    "3528": "劇毒的 奇蘭",
    "3529": "搜刮 克萊傑",
    "3530": "掠奪少女 德路比",
    "3531": "兇惡的 華拉杜魯",
    "3532": "吝嗇鬼 斯可路",
    "3540": "白色旗子",
    "3541": "灰色旗子",
    "3542": "黑色旗子",
    "3543": "紅色旗子",
    "3544": "紅色守備組人類",
    "3545": "紅色守備組妖魔",
    "3546": "紅色守備組哥布林",
    "3547": "紅色守備組哥布林弓箭手",
    "3548": "紅色守備組巨人",
    "3549": "藍色旗子",
    "3550": "藍色守備組人類",
    "3551": "藍色守備組妖魔",
    "3552": "藍色守備組哥布林",
    "3553": "藍色守備組哥布林弓箭手",
    "3554": "藍色守備組巨人",
    "3555": "綠色旗子",
    "3556": "綠色守備組人類",
    "3557": "綠色守備組妖魔",
    "3558": "綠色守備組哥布林",
    "3559": "綠色守備組哥布林弓箭手",
    "3560": "綠色守備組巨人",
    "3561": "黃色旗子",
    "3562": "黃色守備組人類",
    "3563": "黃色守備組妖魔",
    "3564": "黃色守備組哥布林",
    "3565": "黃色守備組哥布林弓箭手",
    "3566": "黃色守備組巨人",
    "3567": "秘法熊",
    "3568": "秘法熊",
    "3569": "秘法野狼",
    "3570": "秘法野狼",
    "3571": "可愛貓咪",
    "3572": "A01",
    "3573": "A02",
    "3574": "A03",
    "3575": "A04",
    "3576": "A05",
    "3577": "A06",
    "3578": "B01",
    "3579": "B02",
    "3580": "B03",
    "3581": "B04",
    "3582": "B05",
    "3583": "B06",
    "3584": "C01",
    "3585": "C02",
    "3586": "C03",
    "3587": "C04",
    "3588": "C05",
    "3589": "C06",
    "3590": "C07",
    "3591": "C08",
    "3592": "A07",
    "3593": "A08",
    "3594": "A09",
    "3595": "A10",
    "3596": "A11",
    "3597": "A12",
    "3598": "B07",
    "3599": "B08",
    "3600": "B09",
    "3601": "B10",
    "3602": "B11",
    "3603": "B12",
    "3604": "C09",
    "3605": "C10",
    "3606": "C11",
    "3607": "C12",
    "3608": "C13",
    "3609": "C14",
    "3610": "C15",
    "3611": "C16",
    "3612": "C17",
    "3613": "C18",
    "3614": "A13",
    "3615": "A14",
    "3616": "A15",
    "3617": "B13",
    "3618": "B14",
    "3619": "B15",
    "3620": "C19",
    "3621": "C20",
    "3622": "C21",
    "3623": "C22",
    "3624": "C23",
    "3625": "C24",
    "3626": "C25",
    "3627": "一流 掠奪團哥布林",
    "3628": "一流 掠奪團哥布林弓箭手",
    "3629": "一流 掠奪團妖魔",
    "3630": "一流 掠奪團人類",
    "3631": "一流 掠奪團巨人",
    "3632": "一流 掠奪團頭目",
    "3633": "一流 掠奪團頭目",
    "3634": "獨眼 佩勒斯",
    "3635": "身分不明的 葛魯奇",
    "3636": "劇毒的 奇蘭",
    "3637": "搜刮一通的 克萊傑",
    "3638": "掠奪少女 德路比",
    "3639": "凶惡的 華拉杜魯",
    "3640": "吝嗇鬼 斯可路",
    "3641": "逃跑的 鬼怪",
    "3642": "逃跑的 藍色鬼怪",
    "3643": "逃跑的 紅色鬼怪",
    "3644": "可娜",
    "3645": "艾樂莉絲",
    "3646": "艾希",
    "3647": "洛根",
    "3648": "寇爾",
    "3649": "戴伊",
    "3650": "可娜",
    "3651": "艾樂莉絲",
    "3652": "艾希",
    "3653": "洛根",
    "3654": "寇爾",
    "3655": "戴伊",
    "3656": "烈焰見習騎士",
    "3657": "烈焰見習騎士",
    "3658": "烈焰見習騎士",
    "3659": "烈焰見習騎士",
    "3660": "烈焰見習騎士",
    "3661": "烈焰見習騎士",
    "3662": "烈焰見習騎士",
    "3663": "烈焰見習騎士",
    "3664": "烈焰見習騎士",
    "3665": "烈焰見習騎士",
    "3666": "烈焰見習騎士",
    "3667": "烈焰見習騎士",
    "3668": "烈焰見習騎士",
    "3669": "烈焰見習騎士",
    "3670": "傑巴赫",
    "3671": "傑巴赫",
    "3672": "可娜",
    "3673": "艾樂莉絲",
    "3674": "艾希",
    "3675": "洛根",
    "3676": "寇爾",
    "3677": "戴伊",
    "3678": "烈焰見習騎士",
    "3679": "烈焰見習騎士",
    "3680": "烈焰見習騎士",
    "3681": "烈焰見習騎士",
    "3682": "烈焰見習騎士",
    "3683": "烈焰見習騎士",
    "3684": "烈焰見習騎士",
    "3690": "加奈芃",
    "3691": "加奈芃",
    "3692": "加奈芃",
    "3693": "稍微會打架的加奈芃",
    "3694": "魔法師加奈芃",
    "3695": "見習掠奪團人類",
    "3696": "見習掠奪團巨人",
    "3697": "見習掠奪團頭目",
    "3698": "2年資歷的掠奪團人類",
    "3699": "2年資歷的掠奪團巨人",
    "3700": "2年資歷的掠奪團頭目",
    "3701": "熟能生巧的掠奪團人類",
    "3702": "熟能生巧的掠奪團巨人",
    "3703": "熟能生巧的掠奪團頭目",
    "3704": "老練的掠奪團人類",
    "3705": "老練的掠奪團巨人",
    "3706": "老練的掠奪團頭目",
    "3707": "一流掠奪團人類",
    "3708": "一流掠奪團巨人",
    "3709": "一流掠奪團頭目",
    "3710": "見習掠奪團人類",
    "3711": "見習掠奪團巨人",
    "3712": "見習掠奪團頭目",
    "3713": "2年資歷的掠奪團人類",
    "3714": "2年資歷的掠奪團巨人",
    "3715": "2年資歷的掠奪團頭目",
    "3716": "熟能生巧的掠奪團人類",
    "3717": "熟能生巧的掠奪團巨人",
    "3718": "熟能生巧的掠奪團頭目",
    "3719": "老練的掠奪團人類",
    "3720": "老練的掠奪團巨人",
    "3721": "老練的掠奪團頭目",
    "3722": "一流掠奪團人類",
    "3723": "一流掠奪團巨人",
    "3724": "一流掠奪團頭目",
    "3730": "掠奪團頭目",
    "3731": "掠奪團",
    "3732": "掠奪團",
    "3733": "掠奪團",
    "3734": "掠奪團",
    "3735": "莉絲",
    "3736": "掠奪團",
    "3737": "掠奪團",
    "3738": "掠奪團",
    "3739": "掠奪團",
    "3740": "摩勒",
    "3741": "掠奪團頭目",
    "3742": "掠奪團",
    "3743": "掠奪團",
    "3744": "掠奪團",
    "3745": "掠奪團",
    "3746": "掠奪團",
    "3747": "掠奪團",
    "3748": "掠奪團頭目",
    "3749": "掠奪團",
    "3750": "掠奪團",
    "3751": "莉絲",
    "3752": "加奈芃",
    "3753": "加奈芃",
    "3754": "加奈芃",
    "3755": "稍微會打架的加奈芃",
    "3756": "魔法師加奈芃",
    "3800": "亞特",
    "3801": "艾薇琳",
    "3802": "托爾維斯",
    "3803": "卡茲遠",
    "3804": "畢奈",
    "3805": "洛維林",
    "3806": "梅林",
    "3807": "寶藏獵人",
    "3808": "白色異變的熊",
    "3809": "白色異變的狼",
    "3810": "白色異變的野豬",
    "3811": "受到驚嚇的男旅者",
    "3812": "受到驚嚇的女旅者",
    "3813": "沉默的男旅者",
    "3814": "吉爾迦斯",
    "3815": "白色礦物",
    "3816": "斐埃爾",
    "3817": "布莉恩",
    "3818": "莫爾坎",
    "3819": "亞特",
    "3820": "艾薇琳",
    "3821": "托爾維斯",
    "3822": "卡茲遠",
    "3823": "畢奈",
    "3824": "洛維林",
    "3825": "梅林",
    "3826": "寶藏獵人",
    "3827": "斐埃爾",
    "3828": "布莉恩",
    "3829": "莫爾坎",
    "3830": "森林巨龍",
    "3831": "白色礦物",
    "3832": "莫克爾卡爾菲",
    "3833": "巨大地蟲",
    "3834": "白色礦物",
    "3835": "阿瓦隆祭司亡靈",
    "3836": "小礦物",
    "3837": "古代巨龜",
    "3838": "魯艾利",
    "3839": "特拉克",
    "3840": "瑪麗",
    "3841": "娜歐",
    "3842": "夏洛克",
    "3843": "艾爾拉哈",
    "3844": "蜜莉亞",
    "3845": "堤安卡特",
    "3846": "凱薩首領",
    "3847": "人類",
    "3848": "亞特",
    "3849": "艾薇琳",
    "3850": "托爾維斯",
    "3851": "卡茲遠",
    "3852": "畢奈",
    "3853": "洛維林",
    "3854": "亞特",
    "3855": "亞特的師傅",
    "3856": "艾薇琳的弟弟",
    "3857": "某位女子",
    "3858": "布莉恩",
    "3859": "看不見的人",
    "3860": "看不見的人",
    "3861": "看不見的人",
    "3862": "看不見的人",
    "3863": "人類",
    "3864": "精靈",
    "3865": "精靈",
    "3866": "巨人",
    "3867": "巨人",
    "3868": "生魂",
    "3869": "托爾維斯",
    "3870": "生魂",
    "3871": "生魂分身",
    "3872": "艾薇琳",
    "3873": "闇黑巫師",
    "3874": "可娜",
    "3875": "艾樂莉絲",
    "3876": "艾希",
    "3877": "洛根",
    "3878": "寇爾",
    "3879": "戴伊",
    "3880": "復活的屍體",
    "3881": "突變的野豬",
    "3882": "突變的狼",
    "3883": "復活的屍體",
    "3884": "黃色變異巨大熊",
    "3885": "復活的屍體",
    "3886": "托爾維斯",
    "3887": "聖所的精靈",
    "3888": "結界",
    "3889": "托爾維斯",
    "3890": "白色礦物",
    "3891": "亞特",
    "3892": "艾薇琳",
    "3893": "梅林",
    "3894": "錫古",
    "3895": "寶藏獵人",
    "3896": "托爾維斯",
    "3897": "卡茲遠",
    "3898": "卡茲遠",
    "3899": "流浪者",
    "3900": "母兔",
    "3901": "公兔",
    "3902": "小兔",
    "4000": "皮魯安",
    "4001": "摩勒愛德",
    "4002": "貝仁",
    "4003": "邪眼的巴羅爾",
    "4004": "克赫蓮",
    "4005": "洛維林",
    "4006": "艾蕾蒙",
    "4007": "悲鳴的殭屍士兵",
    "4008": "徬徨的殭屍士兵",
    "4009": "記憶中的士兵",
    "4010": "記憶中的戰士",
    "4011": "記憶中的鬥士",
    "4012": "記憶中的弓手",
    "4013": "記憶中的勁敵",
    "4014": "記憶中的勁敵",
    "4015": "克赫蓮",
    "4016": "邪眼石像",
    "4017": "達斯拉姆",
    "4018": "貝演奈克",
    "4019": "皮魯安",
    "4020": "摩勒愛德",
    "4021": "貝仁",
    "4022": "克赫蓮",
    "4023": "克赫蓮",
    "4024": "貝仁",
    "4025": "精靈少年",
    "4026": "邪眼的巴羅爾",
    "4027": "邪眼的巴羅爾",
    "4028": "克赫蓮",
    "4029": "弗魔族槍騎兵",
    "4030": "弗魔族鬥士",
    "4031": "弗魔族Archer",
    "4032": "弗魔族戰士",
    "4033": "黑月教團成員",
    "4034": "黑月教團成員",
    "4035": "黑月教團成員",
    "4036": "粗暴的野狗",
    "4037": "粗暴的野狗",
    "4038": "粗暴的惡狼",
    "4039": "粗暴的那伊德",
    "4040": "巨魔",
    "4041": "德魯伊的亡靈",
    "4042": "巨大史萊姆",
    "4043": "史萊姆",
    "4044": "皮魯安",
    "4045": "摩勒愛德",
    "4046": "冰雪之魂",
    "4047": "城牆巨魔像",
    "4048": "死神",
    "4049": "食人魔",
    "4050": "雪山巨魔",
    "4051": "巨大雪山巨魔",
    "4052": "勃蘭登堡",
    "4053": "墓地的幽靈",
    "4054": "抽泣的幽靈",
    "4055": "少女幽靈",
    "4056": "巴羅爾",
    "4057": "小精靈",
    "4058": "黑灰熊",
    "4059": "地靈盜賊",
    "4060": "泰赫圖殷之門",
    "4061": "黑月教團成員",
    "4062": "黑月教團成員",
    "4063": "弗魔族槍騎兵",
    "4064": "弗魔族鬥士",
    "4065": "弗魔族Archer",
    "4066": "弗魔族戰士",
    "4067": "屍妖",
    "4068": "食屍鬼",
    "4069": "地獄貓",
    "4070": "透明目標",
    "4071": "達斯拉姆",
    "4072": "冰晶灰熊",
    "4073": "冰晶土狼",
    "4074": "透明目標",
    "4075": "紅色史萊姆",
    "4076": "藍色史萊姆",
    "4077": "黃色史萊姆",
    "4078": "火蜥蜴",
    "4079": "達斯拉姆",
    "4080": "皮魯安",
    "4081": "摩勒愛德",
    "4082": "貝仁",
    "4083": "克赫蓮",
    "4084": "克赫蓮",
    "4085": "貝演奈克",
    "4086": "貝演奈克",
    "4087": "小海怪",
    "4088": "海怪右觸角",
    "4089": "海怪左觸角",
    "4090": "海怪雷克斯",
    "4091": "左方效果怪物",
    "4092": "右方效果怪物",
    "4093": "帕迪亞露露",
    "4094": "難易度1 透明怪物",
    "4095": "狂暴化的烏龜",
    "4096": "狂暴化的螃蟹",
    "4097": "岩石",
    "4098": "狂暴化的蜈蚣",
    "4099": "水晶巨魔像",
    "4100": "珊瑚礁食蟲植物",
    "4101": "珊瑚礁亡靈",
    "4102": "岩石巨魔像",
    "4103": "結界生成者",
    "4104": "結界守護精靈",
    "4105": "結界守護精靈",
    "4106": "結界守護精靈",
    "4107": "珊瑚亡靈",
    "4108": "岩石巨魔像",
    "4109": "湧出的觸角",
    "4110": "透明設置物",
    "4111": "逃脫帕迪亞露露",
    "4112": "難易度2 透明怪物",
    "4113": "難易度3 透明怪物",
    "4114": "結界防護壁",
    "4115": "海怪 背景用觸角",
    "4116": "被墨汁噴灑的露露",
    "4117": "第1區 透明怪物",
    "4118": "寶箱怪",
    "4119": "墊腳石設置物管理怪物",
    "4120": "크라켄 왼 다리",
    "4200": "皮魯安",
    "4201": "摩勒愛德",
    "4202": "貝仁",
    "4203": "克赫蓮",
    "4204": "洛維林",
    "4205": "艾蕾蒙",
    "4206": "巴圖魯",
    "4207": "米羅舞兒",
    "4208": "塔妮莉姆",
    "4209": "莫梨彼絲",
    "4210": "達雷克",
    "4211": "寶藏獵人",
    "4212": "粉紅",
    "4213": "巨大白蛇",
    "4214": "巨大黑蛇",
    "4215": "非常巨大的黑蛇",
    "4216": "紅熊",
    "4217": "野豬",
    "4218": "野生馬",
    "4219": "白色山羊",
    "4220": "公鹿",
    "4221": "綁匪",
    "4222": "綁匪",
    "4223": "紅熊",
    "4224": "野生馬",
    "4225": "白色山羊",
    "4226": "公鹿",
    "4227": "莫勒菲德莉亞娜絲",
    "4228": "摩勒愛德",
    "4229": "米羅舞兒",
    "4230": "巴圖魯",
    "4231": "遺物戰士亡靈",
    "4232": "遺物亡靈狂信徒師生",
    "4233": "遺物亡靈狂信徒",
    "4234": "遺物獵人亡靈",
    "4235": "巨大白蛇",
    "4236": "巨大黑蛇",
    "4237": "非常巨大的黑蛇",
    "4238": "黑惡狼",
    "4239": "白惡狼",
    "4240": "紅熊",
    "4241": "山豬",
    "4242": "粗暴的野狗",
    "4243": "粗暴的野狗",
    "4244": "紅狐狸",
    "4245": "灰狐狸",
    "4246": "浣熊",
    "4247": "飢餓的老鼠",
    "4248": "不知在嗨什麼的老鼠",
    "4249": "明顯在生氣的老鼠",
    "4250": "飢餓的老鼠",
    "4251": "不知在嗨什麼的老鼠",
    "4252": "明顯在生氣的老鼠",
    "4253": "紅熊",
    "4254": "山豬",
    "4255": "粗暴的野狗",
    "4256": "粗暴的野狗",
    "4257": "紅狐狸",
    "4258": "灰狐狸",
    "4259": "浣熊",
    "4260": "飢餓的老鼠",
    "4261": "不知在嗨什麼的老鼠",
    "4262": "明顯在生氣的老鼠",
    "4263": "看不見的人",
    "4264": "大型營火",
    "4265": "玫瑰與草",
    "4266": "大型蠟燭",
    "4267": "檯燈",
    "4268": "達雷克",
    "4269": "莫勒菲德莉亞娜絲",
    "4270": "馬納南",
    "4271": "帕迪亞露露",
    "4272": "帕迪亞露露",
    "4273": "帕迪亞露露",
    "4274": "帕迪亞露露",
    "4275": "珊瑚 食蟲植物",
    "4276": "珊瑚亡靈",
    "4277": "珊瑚巨魔像",
    "4278": "馬納南的手下",
    "4279": "馬納南",
    "4280": "變異的達雷克",
    "4281": "變異的達雷克",
    "4282": "被蠶食的靈魂",
    "4283": "莫梨彼絲",
    "4284": "達雷克",
    "4285": "帕迪亞露露",
    "4286": "帕迪亞露露",
    "4287": "帕迪亞露露",
    "4288": "帕迪亞露露",
    "4289": "馬納南的水精靈",
    "4290": "鍊金術實驗體",
    "4291": "帕迪亞露露",
    "4292": "透明設置物",
    "4293": "哆哆嗦嗦 帕迪亞露露",
    "4294": "躲起來的帕迪亞露露",
    "4295": "很會找路的帕迪亞露露",
    "4296": "勇敢的帕迪亞露露",
    "4297": "不須幫忙的帕迪亞露露",
    "4298": "火焰史萊姆",
    "4299": "寒冰史萊姆",
    "4300": "雷電史萊姆",
    "4301": "巨魔像",
    "4302": "達雷克",
    "4303": "克赫蓮",
    "4304": "幻象火蜥蜴",
    "4305": "珊瑚亡靈",
    "4306": "馬納南的手下",
    "4307": "馬納南的手下",
    "4308": "馬納南",
    "4309": "馬納南的手下",
    "4310": "珊瑚礁",
    "4311": "骷髏吟遊詩人",
    "4312": "戰鬥船員骷髏",
    "4313": "戰鬥病痛骷髏",
    "4314": "骸骨弓箭手",
    "4315": "骷髏食人魔",
    "4316": "自爆魚人",
    "4317": "看不見的人",
    "4318": "閃亮的物體",
    "4319": "閃亮的物體",
    "4320": "閃亮的物體",
    "4321": "閃亮的物體",
    "4322": "帕迪亞露露",
    "4323": "帕迪亞露露",
    "4324": "再生的樹木",
    "4325": "閃亮的物體",
    "4326": "珊瑚亡靈",
    "4327": "克拉班",
    "4328": "猛毒尖刺鱷魚",
    "4329": "阿勒賀德",
    "4330": "杜赫卡的薩提洛斯",
    "4331": "杜赫卡浮游石",
    "4332": "托利峽谷傳送點",
    "4350": "貝演奈克",
    "4351": "貝仁",
    "4352": "克赫蓮",
    "4353": "克赫蓮",
    "4354": "摩勒愛德",
    "4355": "皮魯安",
    "4356": "西拉",
    "4357": "惡翅魅魔國王",
    "4358": "波德拉",
    "4359": "黛伊爾布拉",
    "4360": "梅林",
    "4361": "艾亞莉",
    "4362": "寶藏獵人",
    "4363": "猩猩",
    "4364": "Diva",
    "4365": "教授J",
    "4366": "總舖師",
    "4367": "總舖師的夢想餐車",
    "4368": "巴圖魯",
    "4369": "米羅舞兒",
    "4370": "塔妮莉姆",
    "4371": "梅林",
    "4372": "半魔族",
    "4373": "半族",
    "4374": "人類",
    "4375": "亡靈",
    "4376": "人類",
    "4377": "月石碎片",
    "4378": "月石碎片",
    "4379": "月石碎片",
    "4380": "靈魂球體",
    "4381": "月石碎片",
    "4382": "月石碎片",
    "4383": "月石碎片",
    "4384": "巨人",
    "4385": "精靈",
    "4386": "精靈",
    "4387": "精靈守衛",
    "4388": "巨人守衛",
    "4389": "普力斯",
    "4390": "貝爾法斯特警衛",
    "4391": "迪恩",
    "4392": "羊",
    "4393": "灰狼",
    "4394": "巨大黑狼",
    "4395": "康格",
    "4396": "紅蜘蛛",
    "4397": "哥布林",
    "4398": "劇毒哥布林",
    "4399": "黑蜘蛛",
    "4400": "哥布林弓箭手",
    "4401": "妖魔",
    "4402": "寶箱怪",
    "4403": "吸血蝙蝠",
    "4404": "看不見的人1",
    "4405": "看不見的人2",
    "4406": "看不見的人3",
    "4407": "馬努斯",
    "4408": "總舖師",
    "4409": "克赫蓮",
    "4410": "黑月教團成員",
    "4411": "黑月教團成員",
    "4412": "黑月教團成員",
    "4413": "摩勒愛德",
    "4414": "寶藏獵人",
    "4415": "艾亞莉",
    "4416": "梅林",
    "4417": "猛毒尖刺鱷魚",
    "4418": "阿勒賀德",
    "4419": "克拉班",
    "4420": "幽靈海盜",
    "4421": "幽靈海盜",
    "4422": "幽靈海盜",
    "4423": "幽靈海盜偵查兵",
    "4424": "幽靈海盜偵查兵",
    "4425": "幽靈海盜偵查兵",
    "4426": "西拉",
    "4427": "人類",
    "4428": "梅麗絲",
    "4429": "雅拉塔",
    "4430": "安德拉絲",
    "4431": "陶恩斯",
    "4432": "卡芬",
    "4433": "格拉納特",
    "4434": "艾蕾蒙",
    "4435": "城堡士兵",
    "4436": "人類士兵",
    "4437": "巨人士兵",
    "4438": "精靈士兵",
    "4439": "巨人守衛",
    "4440": "人類",
    "4441": "精靈",
    "4442": "巨人士兵",
    "4443": "精靈士兵",
    "4444": "人類士兵",
    "4445": "枚伊克",
    "4446": "塔烏拉",
    "4447": "米羅舞兒",
    "4448": "巴圖魯",
    "4449": "Diva",
    "4450": "安德拉絲",
    "4451": "卡芬",
    "4452": "格拉納特",
    "4453": "歐文提督",
    "4454": "惡靈戰士",
    "4455": "惡靈弓箭手",
    "4456": "半巫妖",
    "4457": "食屍鬼",
    "4458": "惡夢的面具幻影",
    "4459": "護衛犬",
    "4460": "最高級餐具幻影",
    "4461": "馬之魂",
    "4462": "惡翅魅魔",
    "4463": "惡翅魅魔",
    "4464": "惡翅魅魔",
    "4465": "蜈蚣",
    "4466": "鍬形蟲",
    "4467": "紅蜘蛛黃蜂",
    "4468": "冰晶殭屍",
    "4469": "黑色牢獄殭屍",
    "4470": "陶瓷娃娃",
    "4471": "巨大無頭怪",
    "4472": "百眼巨人",
    "4473": "藍色鬼怪",
    "4474": "魅魔王",
    "4475": "巨人士兵",
    "4476": "精靈士兵",
    "4477": "枚伊克",
    "4478": "塔烏拉",
    "4479": "米羅舞兒",
    "4480": "巴圖魯",
    "4481": "白色蟻獅",
    "4482": "凱薩首領",
    "4483": "魯艾利",
    "4484": "艾德翰",
    "4485": "伊文",
    "4486": "特拉克",
    "4487": "瑪麗",
    "4488": "亞特",
    "4489": "托爾維斯",
    "4490": "泰赫圖殷之門",
    "4491": "卡芬",
    "4492": "格拉納特",
    "4493": "黑月科隆克斯亞",
    "4494": "橡木桶",
    "4495": "橡木桶",
    "4496": "橡木桶",
    "4497": "凱薩首領",
    "4498": "巨人守衛",
    "4499": "巨人守衛",
    "4500": "巨人守衛",
    "4501": "巨人守衛",
    "4502": "巨人守衛",
    "4503": "巨人",
    "4504": "精靈",
    "4505": "人類",
    "4506": "人類",
    "4507": "貝演奈克",
    "4508": "移動用魔法陣",
    "4509": "幽靈少女",
    "4510": "幽靈少年",
    "4511": "月石",
    "4512": "賽拉",
    "4513": "黛伊爾布拉",
    "4514": "紅色面具幻影",
    "4515": "黑色面具幻影",
    "4516": "白色面具幻影",
    "4517": "奴隸狩獵犬",
    "4518": "巨大的面具幻影",
    "4519": "精靈少年",
    "4520": "艾薇琳",
    "4521": "卡茲遠",
    "4522": "畢奈",
    "4523": "洛維林",
    "4524": "精靈",
    "4525": "王城鍊金術師",
    "4526": "Diva",
    "4527": "寶藏獵人",
    "4528": "艾亞莉",
    "4529": "梅林",
    "4530": "諜報員",
    "4531": "諜報員",
    "4532": "親衛隊員",
    "4533": "親衛隊員",
    "4534": "巨人士兵",
    "4535": "精靈士兵",
    "4536": "巨人士兵",
    "4537": "巨人士兵",
    "4538": "精靈士兵",
    "4539": "巨人士兵",
    "4540": "精靈士兵",
    "4541": "倒下的士兵",
    "4542": "倒下的士兵",
    "4543": "枚伊克",
    "4544": "塔烏拉",
    "4545": "米羅舞兒",
    "4546": "巴圖魯",
    "4547": "卡芬",
    "4548": "格拉納特",
    "4549": "卡茲遠",
    "4550": "畢奈",
    "4551": "亞特",
    "4552": "艾薇琳",
    "4553": "托爾維斯",
    "4554": "卡茲遠",
    "4555": "卡茲遠",
    "4556": "畢奈",
    "4557": "洛維林",
    "4558": "可娜",
    "4559": "艾樂莉絲",
    "4560": "艾希",
    "4561": "洛根",
    "4562": "寇爾",
    "4563": "戴伊",
    "4564": "次元裂縫",
    "4565": "皮魯安",
    "4566": "黛伊爾布拉",
    "4567": "貝演奈克",
    "4568": "埃坦",
    "4569": "恩雅",
    "4570": "塔妮莉姆",
    "4571": "海米斯",
    "4572": "人類",
    "4573": "人類",
    "4574": "精靈",
    "4575": "精靈",
    "4576": "巨人",
    "4577": "巨人",
    "4578": "庫魯格",
    "4579": "卡絲妮亞",
    "4580": "可娜",
    "4581": "艾樂莉絲",
    "4582": "艾希",
    "4583": "洛根",
    "4584": "寇爾",
    "4585": "戴伊",
    "4586": "亞特",
    "4587": "粉紅",
    "4588": "黑暗領主",
    "4589": "特里歐納",
    "4590": "短鬃毛土狼",
    "4591": "熱帶草原豺狼",
    "4592": "獅子",
    "4593": "母獅子",
    "4594": "克赫蓮",
    "4595": "托爾維斯",
    "4596": "貝演奈克",
    "4597": "異神化",
    "4598": "異神化",
    "4600": "奈克拉維",
    "4601": "海米斯",
    "4602": "貝演奈克",
    "4603": "黛伊爾布拉",
    "4604": "邪眼的巴羅爾",
    "4605": "精靈守衛",
    "4606": "諜報員",
    "4607": "諜報員",
    "4608": "洛維林",
    "4609": "恩雅",
    "4610": "塔烏拉",
    "4611": "艾亞莉",
    "4612": "蒙面哥布林",
    "4613": "蒙面哥布林弓箭手",
    "4614": "罈壺蜘蛛",
    "4615": "石頭獵犬",
    "4616": "石頭妖魔",
    "4617": "石頭殭屍",
    "4618": "沙華魚人鬥士",
    "4619": "沙華魚人戰士",
    "4620": "黑梨鼠",
    "4621": "魔劍",
    "4622": "海盜骷髏",
    "4623": "海盜紅骷髏船長",
    "4624": "獨眼巨人",
    "4625": "黑月教團上級教官",
    "4626": "黑月教團上級法師",
    "4627": "克赫蓮",
    "4628": "狂暴化的安巴爾",
    "4629": "短鬃毛土狼",
    "4630": "熱帶草原豺狼",
    "4631": "沼澤眼鏡蛇",
    "4632": "巨大蜻蜓",
    "4633": "鱷魚",
    "4634": "巨鱷",
    "4635": "紅色叢林狼",
    "4636": "叢林哥布林戰士",
    "4637": "叢林哥布林弓箭手",
    "4638": "叢林哥布林咒術師",
    "4639": "紅毒蛇",
    "4640": "棕色荒野狼",
    "4641": "巨大雄性黃蜂",
    "4642": "巨大黃蜂士兵",
    "4643": "巨大雌性黃蜂",
    "4644": "巨大黃蜂女王",
    "4645": "紅眼刺腳蜘蛛",
    "4646": "巨大紅眼刺腳蜘蛛",
    "4647": "石頭寶箱怪",
    "4648": "石頭野牛",
    "4649": "狂暴化的安巴爾",
    "4650": "狂暴化的安巴爾",
    "4651": "狂暴化的安巴爾",
    "4652": "狂暴化的安巴爾",
    "4653": "狂暴化的安巴爾",
    "4654": "教授J",
    "4655": "亞特",
    "4656": "教授J",
    "4657": "總舖師",
    "4658": "獅子",
    "4659": "母獅子",
    "4660": "巨大母獅子",
    "4661": "巨大獅子",
    "4662": "黛伊爾布拉的魔杖",
    "4663": "艾薇琳",
    "4664": "卡茲遠",
    "4665": "畢奈",
    "4666": "藍色鬼怪",
    "4667": "紅色鬼怪",
    "4668": "食屍鬼",
    "4669": "鬼魂偽裝怪",
    "4670": "可娜",
    "4671": "艾樂莉絲",
    "4672": "托爾維斯",
    "4673": "亞特",
    "4676": "魯艾利",
    "4677": "特拉克",
    "4678": "瑪麗",
    "4679": "魅魔克莉絲",
    "4680": "特拉克",
    "4700": "歐哈德",
    "4701": "歐哈德",
    "4702": "歐哈德",
    "4703": "雷伊璐",
    "4704": "雷伊璐",
    "4705": "雷伊璐",
    "4706": "卡薇娜",
    "4707": "卡薇娜",
    "4708": "卡薇娜",
    "4709": "艾蕾蒙",
    "4710": "固定木偶",
    "4711": "訓練用打擊人偶",
    "4712": "流氓",
    "4713": "流氓",
    "4714": "流氓",
    "4715": "流氓",
    "4716": "蘿晚",
    "4717": "蘿晚",
    "4718": "蘿晚",
    "4719": "羅西尼",
    "4720": "羅西尼",
    "4721": "羅西尼",
    "4724": "具體化的黑闇值",
    "4725": "冰花之靈的殘骸",
    "4726": "伊歐拉",
    "4727": "伊歐拉",
    "4728": "伊歐拉",
    "4729": "伊歐拉",
    "4730": "變胖的王城鼠",
    "4731": "哥布林",
    "4732": "劇毒哥布林",
    "4733": "馬特烏斯",
    "4734": "馬特烏斯",
    "4735": "暗殺者",
    "4736": "暗殺者",
    "4737": "暗殺者",
    "4738": "巨人暗殺者",
    "4739": "巨人暗殺者",
    "4740": "暗殺者",
    "4741": "暗殺者",
    "4743": "暗殺者",
    "4744": "塔莎",
    "4745": "米希爾",
    "4746": "塔莎",
    "4747": "塔莎",
    "4748": "米希爾",
    "4749": "米希爾",
    "4750": "掠奪團頭目",
    "4751": "拙劣的掠奪者",
    "4752": "狂妄的掠奪者",
    "4753": "懶惰的掠奪者",
    "4754": "流氓",
    "4755": "流氓",
    "4756": "流氓",
    "4757": "流氓",
    "4758": "哥哥",
    "4759": "陌生的傳令",
    "4760": "恐怖的幻影",
    "4761": "陰森的幻影",
    "4762": "被召喚的巨魔像",
    "4763": "被召喚的巨魔像",
    "4764": "幽靈",
    "4765": "雪球",
    "4766": "究極槍枝雪人",
    "4767": "究極曼德拉草雪人",
    "4768": "幽靈",
    "4769": "訓練用打擊人偶",
    "4770": "不再是媽媽的存在",
    "4771": "銜尾蛇",
    "4772": "銜尾蛇",
    "4773": "銜尾蛇",
    "4774": "銜尾蛇",
    "4775": "可疑的馬車",
    "4776": "伊歐拉",
    "4801": "羅西尼",
    "4802": "羅西尼",
    "4803": "霜角鹿",
    "4804": "霜角鹿",
    "4856": "和浣熊一樣虛弱的木頭人",
    "4857": "和泰赫圖殷之門一樣堅固的木頭人",
    "4858": "和魅魔女王一樣堅固的木頭人",
    "4859": "和伊魯夏一樣堅固的木頭人",
    "4860": "和卡莉亞赫一樣堅固的木頭人",
    "5000": "黛迦",
    "5001": "艾涅",
    "5002": "狄克倫",
    "5003": "夏普拉",
    "5004": "艾蕾蒙",
    "5005": "埃坦",
    "5006": "卡爾汀",
    "5007": "格威爾比",
    "5008": "托奇",
    "5009": "瑪德朱",
    "5010": "錫妮",
    "5011": "蝴蝶神獸",
    "5012": "人類",
    "5013": "人類",
    "5014": "營地帳篷",
    "5015": "托爾維斯",
    "5016": "普麗雅",
    "5017": "梅林",
    "5018": "艾亞莉",
    "5019": "寶藏獵人",
    "5020": "大猩猩",
    "5021": "DIVA",
    "5022": "教授J",
    "5023": "總鋪師",
    "5024": "總舖師的夢想餐車",
    "5025": "雷伊璐",
    "5026": "蝴蝶神獸",
    "5027": "黛迦",
    "5028": "青毒蛇",
    "5029": "白毒蛇",
    "5030": "黑毒蛇",
    "5031": "殭屍士兵",
    "5032": "殭屍士兵",
    "5050": "普麗雅",
    "5051": "被影子籠罩的普麗雅",
    "5052": "普麗雅的翅膀",
    "5053": "蝴蝶神獸",
    "5054": "魚神獸",
    "5055": "鳥神獸",
    "5056": "艾涅",
    "5057": "狄克倫",
    "5058": "一流商團掠奪者精靈",
    "5059": "一流商團掠奪者精靈",
    "5060": "一流商團掠奪者人類",
    "5061": "一流商團掠奪者巨人",
    "5062": "一流商團掠奪團頭目",
    "5063": "一流商團掠奪團頭目",
    "5064": "一流商團掠奪團頭目",
    "5065": "暗影夏爾馬",
    "5066": "暗影戰士",
    "5067": "暗影鬥士",
    "5068": "暗影弓箭手",
    "5069": "暗影巫師",
    "5070": "暗影槍騎兵",
    "5071": "暗影巫師",
    "5072": "暗影鍊金術師",
    "5073": "那隻兔子",
    "5074": "那隻貓咪",
    "5075": "那隻貓咪",
    "5076": "那隻兔子",
    "5077": "那隻貓咪",
    "5078": "狄克倫",
    "5079": "布林",
    "5080": "梅伊拉",
    "5081": "薛西",
    "5082": "薛西",
    "5083": "培爾",
    "5084": "布林",
    "5085": "艾涅",
    "5086": "夏普拉",
    "5087": "傭兵",
    "5088": "傭兵",
    "5089": "傭兵",
    "5090": "傭兵",
    "5091": "傭兵",
    "5092": "傭兵",
    "5093": "傭兵",
    "5094": "傭兵",
    "5095": "蝴蝶神獸",
    "5096": "夏普拉",
    "5097": "鳥神獸",
    "5098": "鳥神獸",
    "5099": "普麗雅的翅膀",
    "5100": "鼻子上有傷痕的游擊隊員",
    "5101": "俏鬍子游擊隊員",
    "5102": "長腿游擊隊員",
    "5103": "一把山羊鬍的游擊隊員",
    "5104": "地靈",
    "5105": "劇毒地靈",
    "5106": "地靈弓箭手",
    "5107": "圖哈德達南",
    "5108": "圖哈德達南",
    "5109": "圖哈德達南",
    "5110": "孤獨",
    "5111": "空虛",
    "5112": "虛無",
    "5113": "喪失",
    "5114": "夏普拉",
    "5115": "薛西",
    "5116": "梅伊拉",
    "5117": "棕色牢獄鬼魂",
    "5118": "紅色牢獄鬼魂",
    "5119": "藍色牢獄鬼魂",
    "5120": "灰色牢獄殭屍",
    "5121": "黑色牢獄殭屍",
    "5122": "白色牢獄殭屍",
    "5123": "牢獄魔劍",
    "5124": "棕色牢獄鬼魂",
    "5125": "紅色牢獄鬼魂",
    "5126": "藍色牢獄鬼魂",
    "5127": "灰色牢獄殭屍",
    "5128": "黑色牢獄殭屍",
    "5129": "白色牢獄殭屍",
    "5130": "牢獄魔劍",
    "5131": "梅伊拉",
    "5132": "薛西",
    "5133": "克拉班",
    "5134": "猛毒尖刺鱷魚",
    "5135": "阿勒賀德",
    "5136": "培爾",
    "5137": "培爾",
    "5138": "培爾",
    "5139": "雅莉安妮",
    "5140": "培爾",
    "5141": "狄克倫",
    "5142": "黑惡狼",
    "5143": "白惡狼",
    "5144": "白惡狼",
    "5145": "人類",
    "5146": "食屍鬼",
    "5147": "地獄貓",
    "5148": "半巫妖",
    "5149": "大師巫妖",
    "5150": "黑惡狼",
    "5151": "白惡狼",
    "5152": "白惡狼",
    "5153": "人類",
    "5154": "食屍鬼",
    "5155": "地獄貓",
    "5156": "半巫妖",
    "5157": "大師巫妖",
    "5158": "培爾",
    "5160": "佩塔克",
    "5162": "雷楠",
    "5163": "被遺棄的暗夜使者狂戰士",
    "5164": "德琳",
    "5165": "運輸用馬車",
    "5166": "亞特",
    "5167": "德琳",
    "5168": "梅林",
    "5169": "秋收組員",
    "5170": "秋收組員",
    "5171": "雷楠",
    "5172": "皮昂塔恩",
    "5173": "梅琉赫拉",
    "5174": "巴寬",
    "5175": "伊比卡",
    "5176": "休臣",
    "5177": "農",
    "5178": "魯布斯",
    "5179": "克蕾赫",
    "5180": "緹達",
    "5181": "索爾里歐",
    "5182": "德琳",
    "5183": "佩塔克",
    "5184": "夏普拉",
    "5185": "格威爾比",
    "5186": "狄克倫",
    "5187": "黛迦",
    "5188": "艾涅",
    "5189": "狄克倫",
    "5190": "夏普拉",
    "5191": "黛迦",
    "5193": "佩塔克",
    "5194": "佩塔克",
    "5195": "皮昂塔恩",
    "5196": "梅琉赫拉",
    "5197": "巴寬",
    "5198": "伊比卡",
    "5199": "休臣",
    "5200": "農",
    "5201": "魯布斯",
    "5202": "克蕾赫",
    "5203": "緹達",
    "5204": "索爾里歐",
    "5210": "侵蝕心靈的牽掛",
    "5211": "佩塔克",
    "5212": "渾身發抖的警衛兵",
    "5213": "鎮定的警衛兵",
    "5214": "蝴蝶神獸",
    "5215": "鳥神獸",
    "5216": "佩塔克",
    "5218": "雷楠的米勒",
    "5219": "安樂的碎片",
    "5220": "安樂的碎片",
    "5221": "安樂的碎片",
    "5222": "安樂的碎片",
    "5223": "安樂的碎片",
    "5224": "古樹的佩塔克",
    "5225": "布倫塔納斯",
    "5226": "狄克倫",
    "5227": "艾涅",
    "5228": "夏普拉",
    "5229": "佩塔克",
    "5230": "普拉姆納",
    "5231": "波茵榭",
    "5232": "齊利亞",
    "5233": "格拉納1",
    "5234": "格拉納2",
    "5235": "格拉納3",
    "5236": "貝利1",
    "5237": "貝利2",
    "5238": "貝利3",
    "5239": "斯卡默1",
    "5240": "斯卡默2",
    "5241": "斯卡默3",
    "5242": "蟲子",
    "5243": "蝴蝶神獸",
    "5244": "蝴蝶神獸",
    "5245": "蝴蝶神獸",
    "5246": "魚神獸",
    "5247": "魚神獸",
    "5248": "魚神獸",
    "5249": "鳥神獸",
    "5250": "鳥神獸",
    "5251": "鳥神獸",
    "5252": "圈圈標示",
    "5253": "叉叉標示",
    "5254": "神獸防禦軍桌子1",
    "5255": "神獸防禦軍桌子2",
    "5256": "神獸防禦軍補武器箱1",
    "5257": "神獸防禦軍補武器箱2",
    "5258": "神獸防禦軍木箱1",
    "5259": "神獸防禦軍木箱2",
    "5260": "少年齊利亞",
    "5261": "阿德里亞",
    "5262": "阿德里亞",
    "5263": "尹瑟拉",
    "5264": "尹瑟拉",
    "5265": "普拉姆納",
    "5266": "勤勞的塔拉支援兵",
    "5267": "沉穩的塔拉支援兵",
    "5268": "膽小的塔拉支援兵",
    "5269": "佛帝斯",
    "5270": "奈麗絲",
    "5271": "馬努斯",
    "5272": "馬努斯 美國",
    "5273": "瓦爾特",
    "5274": "史帝華",
    "5275": "蕾拉",
    "5276": "奧斯丁",
    "5277": "克莉絲",
    "5278": "阿蘭雯",
    "5279": "梅溫",
    "5280": "伊文",
    "5281": "石堆",
    "5282": "波茵榭",
    "5283": "派遣來的怪人學者",
    "5284": "派遣來的輔助學者",
    "5285": "派遣來的王城學者",
    "5286": "格里亞斯草",
    "5289": "淡然的巴雷斯近衛兵",
    "5290": "冰冷的巴雷斯近衛兵",
    "5291": "好戰的巴雷斯近衛兵",
    "5292": "艾涅",
    "5293": "黛迦",
    "5294": "狄克倫",
    "5295": "艾涅",
    "5296": "夏普拉",
    "5297": "近距離戰鬥兵",
    "5298": "弓箭隊士兵",
    "5299": "鍊金術士兵",
    "5300": "波茵榭",
    "5301": "齊利亞",
    "5302": "齊利亞",
    "5303": "蝴蝶神獸",
    "5304": "魚神獸",
    "5305": "鳥神獸",
    "5306": "防線",
    "5307": "任務用透明人",
    "5308": "精銳近距離戰鬥兵",
    "5309": "精銳弓箭隊士兵",
    "5310": "精銳鍊金術士兵",
    "5311": "最精銳近距離戰鬥兵",
    "5312": "最精銳弓箭隊士兵",
    "5313": "最精銳鍊金術士兵",
    "5314": "防禦戰指揮官",
    "5315": "齊利亞",
    "5316": "狄克倫",
    "5317": "夏普拉",
    "5318": "齊利亞",
    "5319": "小型爐火火焰",
    "5320": "行政區火焰",
    "6000": "異神化",
    "7000": "崔弗",
    "7001": "佛格斯",
    "7002": "雷納德",
    "7003": "歐文提督",
    "7004": "奈麗絲",
    "7005": "阿蘭雯",
    "7006": "布洛斯",
    "7007": "史恩",
    "7008": "休馬斯",
    "7009": "艾德翰",
    "7010": "路卡斯",
    "7011": "乞丐",
    "7012": "安德拉絲",
    "7013": "卡芬",
    "7014": "古魯亞司",
    "7015": "佩丹",
    "7016": "博伊特",
    "7017": "沃沃卡",
    "7018": "哈吉爾",
    "7019": "姬琳",
    "7020": "庫魯格",
    "7021": "派瑞克",
    "7022": "貝莉塔",
    "7023": "格拉納特",
    "7024": "李奧卡德",
    "7025": "凱琳",
    "7026": "安黛莉",
    "7027": "阿隬",
    "7028": "瓦爾特",
    "7029": "艾琳",
    "7030": "珍妮佛",
    "7031": "黛兒",
    "7032": "黛蓮",
    "7033": "艾潔拉",
    "7034": "庫西娜",
    "7035": "伊絲娜",
    "7036": "梅麗絲",
    "7037": "葛尼提斯",
    "7038": "麗莎",
    "7039": "史帝華",
    "7040": "蓋維",
    "7041": "貝瑞克希德",
    "7042": "潘賈斯特",
    "7043": "庫塞",
    "7044": "卡絲妮亞",
    "7045": "鄧肯",
    "7046": "馬努斯",
    "7047": "馬努斯 美國",
    "7048": "康格",
    "7049": "安格妮絲",
    "7050": "柯洛恩",
    "7051": "卡爾汀",
    "7052": "希布林",
    "7053": "雅拉塔",
    "7054": "阿依巴",
    "7055": "海蕾特",
    "7056": "錫妮",
    "7057": "多琳",
    "7058": "迪恩",
    "7059": "西蒙",
    "7060": "艾頓",
    "7061": "納里",
    "7062": "洛瓦伊",
    "7063": "莉莉絲",
    "7064": "陶恩斯",
    "7065": "特拉克",
    "7066": "布萊斯",
    "7067": "腓力特",
    "7068": "克莉絲",
    "7101": "羊",
    "7102": "披著羊皮的狼",
    "7103": "鴕鳥",
    "7104": "河馬",
    "7105": "拉布",
    "7106": "生氣熊",
    "7500": "霜角鹿",
    "7501": "斯奈塔",
    "7502": "斯奈塔",
    "7503": "斯奈塔",
    "7504": "夜靈",
    "7505": "夜靈(不使用)",
    "7506": "夜靈(不使用)",
    "7507": "被雪覆蓋的食人植物",
    "7508": "被雪覆蓋的食蟲植物",
    "7509": "異質體遊魂",
    "7510": "琥珀妖精",
    "7511": "冰錐妖精",
    "7512": "凱撒兔",
    "7513": "均衡的凱撒兔",
    "7514": "冰花之靈",
    "7515": "霜紋靈貓",
    "7516": "冰脊野狼",
    "7517": "卡莉亞赫",
    "7518": "卡莉亞赫",
    "7519": "不完整的空想",
    "7520": "克羅克艾德",
    "7521": "影子任務透明怪物",
    "7522": "霜紋靈貓",
    "7523": "卡莉亞赫的結界1階段",
    "7524": "卡莉亞赫的結界2階段",
    "7525": "卡莉亞赫的結界最終階段",
    "7526": "卡莉亞赫的結界最終階段",
    "7527": "燃燒靈魂的火爐",
    "7528": "霜角鹿",
    "7529": "斯奈塔",
    "7530": "斯奈塔",
    "7531": "斯奈塔",
    "7532": "夜靈",
    "7533": "夜靈(不使用)",
    "7534": "夜靈(不使用)",
    "7535": "被雪覆蓋的食人植物",
    "7536": "被雪覆蓋的食蟲植物",
    "7537": "異質體遊魂",
    "7538": "琥珀妖精",
    "7539": "冰錐妖精",
    "7540": "凱撒兔",
    "7541": "均衡的凱撒兔",
    "7542": "冰花之靈",
    "7543": "霜紋靈貓",
    "7544": "冰脊野狼",
    "7545": "霜紋靈貓",
    "7546": "卡莉亞赫的結界1階段",
    "7547": "卡莉亞赫的結界2階段",
    "7548": "卡莉亞赫的結界最終階段",
    "7549": "卡莉亞赫的結界最終階段",
    "7550": "燃燒靈魂的火爐",
    "7551": "冰之碎片",
    "7552": "冰之巨魔像",
    "7553": "純白的靈魂",
    "7554": "不完整的空想",
    "7555": "霜角鹿",
    "7556": "琥珀妖精",
    "7557": "異質體遊魂",
    "7558": "冰錐妖精",
    "7559": "冰花之靈",
    "7560": "卡莉亞赫",
    "7561": "卡莉亞赫",
    "7562": "斯奈塔",
    "7563": "斯奈塔",
    "7564": "斯奈塔",
    "7565": "冰之巨魔像",
    "7566": "純白的靈魂",
    "7567": "霜角鹿",
    "7568": "琥珀妖精",
    "7569": "異質體遊魂",
    "7570": "冰錐妖精",
    "7571": "冰花之靈",
    "7572": "斯奈塔",
    "7573": "斯奈塔",
    "7574": "斯奈塔",
    "7575": "卡莉亞赫",
    "7576": "克羅克艾德",
    "7577": "不完整的空想",
    "7583": "冰錐妖精",
    "7584": "卡莉亞赫",
    "7585": "不完整的空想",
    "7586": "不完整的空想",
    "7587": "冬天的篡奪者",
    "7588": "寒冬的密語",
    "7600": "古樹的佩塔克",
    "7601": "古樹的佩塔克",
    "7602": "布倫塔納斯",
    "7603": "雷楠的米勒",
    "7604": "安樂的碎片",
    "7605": "安樂的碎片",
    "7606": "安樂的碎片",
    "7607": "安樂的碎片",
    "7608": "安樂的碎片",
    "7609": "升起的地面",
    "7610": "古代的意志",
    "7611": "古代的巨人",
    "7612": "古代的巨人",
    "7613": "古代的巨人",
    "7614": "古代的巨人",
    "7616": "安樂的碎片",
    "7617": "安樂的碎片",
    "7618": "安樂的碎片",
    "7619": "安樂的碎片",
    "7620": "安樂的碎片",
    "7622": "安樂的碎片",
    "8000": "巨人",
    "8001": "巨人",
    "8002": "巨人",
    "8003": "巨人士兵",
    "8004": "巨人士兵",
    "8005": "巨人士兵",
    "8006": "巨人士兵",
    "8007": "巨人士兵",
    "8008": "巨人士兵",
    "8009": "巨人士兵",
    "8010": "巨人士兵",
    "8011": "巨人士兵",
    "8012": "巨人士兵",
    "8013": "巨人士兵",
    "8014": "廟會商人",
    "8015": "廟會商人",
    "8016": "貝爾法斯特警衛隊長",
    "8017": "자이언트",
    "8018": "巨人",
    "8101": "黑暗指揮官",
    "8102": "瑪塔",
    "8103": "瑪塔",
    "9000": "精靈",
    "9001": "精靈",
    "9002": "精靈",
    "9003": "精靈",
    "9004": "精靈",
    "9005": "精靈士兵",
    "9006": "精靈士兵",
    "9007": "精靈士兵",
    "9008": "精靈士兵",
    "9009": "精靈士兵",
    "9010": "精靈士兵",
    "9011": "精靈士兵",
    "9012": "精靈士兵",
    "9013": "精靈偵察兵",
    "9014": "精靈士兵",
    "9015": "精靈士兵",
    "9016": "精靈士兵",
    "9017": "廟會商人",
    "9018": "엘프",
    "9020": "精靈",
    "9021": "巨人",
    "9022": "精靈",
    "9023": "人類",
    "9999": "人類",
    "10000": "人類",
    "10001": "人類",
    "10002": "人類",
    "10003": "闇黑巫師",
    "10004": "闇黑戰士",
    "10005": "闇黑士兵",
    "10006": "幽靈",
    "10007": "幽靈",
    "10008": "闇黑巫師",
    "10009": "人類",
    "10010": "凱彼",
    "10011": "詹娜",
    "10012": "人類士兵",
    "10013": "人類士兵",
    "10014": "人類士兵",
    "10015": "人類士兵",
    "10016": "人類士兵",
    "10017": "人類士兵",
    "10018": "人類士兵",
    "10019": "人類士兵",
    "10020": "人類士兵",
    "10021": "人類士兵",
    "10022": "詹娜",
    "10023": "人類士兵",
    "10024": "聖戰騎士團",
    "10025": "聖戰騎士團",
    "10026": "聖戰騎士團",
    "10027": "聖戰騎士團",
    "10028": "聖戰騎士團",
    "10029": "聖戰騎士團",
    "10030": "聖戰騎士團",
    "10031": "聖戰騎士團",
    "10032": "人類士兵",
    "10033": "人類士兵",
    "10034": "詹娜",
    "10035": "法隆的士兵",
    "10036": "法隆的士兵",
    "10037": "法隆的士兵",
    "10038": "法隆的士兵",
    "10039": "法隆的士兵",
    "10040": "黑巫師",
    "10041": "士兵屍體",
    "10042": "士兵屍體",
    "10043": "士兵屍體",
    "10044": "士兵屍體",
    "10045": "士兵屍體",
    "10046": "士兵屍體",
    "10047": "士兵屍體",
    "10048": "士兵屍體",
    "10049": "士兵屍體",
    "10050": "士兵屍體",
    "10052": "雷摩爾",
    "10053": "克依",
    "10054": "雷摩爾",
    "10055": "人類士兵",
    "10056": "克依",
    "10057": "被侵蝕的 克依",
    "10058": "被侵蝕的 克依",
    "10059": "被侵蝕的 克依",
    "10060": "詹娜",
    "10061": "巨蛇騎士",
    "10062": "都拉漢",
    "10063": "巨蛇騎士",
    "10064": "雷摩爾",
    "10065": "克依",
    "10066": "雷摩爾",
    "10067": "古魯亞司",
    "10068": "路卡斯",
    "10069": "克依",
    "10070": "雷摩爾",
    "10071": "<mini>NPC</mini> 布坎南",
    "10072": "詹娜",
    "10073": "詹娜_G11_效應",
    "10074": "巨蛇騎士",
    "10075": "都拉漢",
    "10076": "<mini>NPC</mini> 阿依巴",
    "10077": "聖騎士團軍官",
    "10078": "聖騎士團軍官",
    "10079": "聖騎士團軍官",
    "10080": "海貝特烏斯",
    "10081": "人類",
    "10082": "人類",
    "10083": "詹娜",
    "10084": "福丁布拉斯2世",
    "10085": "挪威士兵",
    "10086": "挪威士兵",
    "10087": "雷爾提",
    "10088": "補給兵",
    "10089": "赫瑞修",
    "10090": "衛兵",
    "10091": "衛兵",
    "10092": "一般市民",
    "10093": "一般市民",
    "10094": "一般市民",
    "10095": "闇黑戰士",
    "10096": "闇黑巫師",
    "10097": "哈姆雷特",
    "10098": "羅生克蘭",
    "10099": "歐茲雷",
    "10100": "蓋登思鄧",
    "10101": "哥布林",
    "10102": "劇毒哥布林",
    "10103": "哥布林弓箭手",
    "10104": "黃金哥布林",
    "10105": "競技場哥布林",
    "10106": "哥布林盜賊",
    "10107": "紅哥布林弓箭手",
    "10108": "紅哥布林",
    "10109": "哥布林",
    "10110": "哥布林獵人",
    "10111": "哥布林獵人弓箭手",
    "10112": "幼小哥布林",
    "10113": "幼小劇毒哥布林",
    "10114": "幼小哥布林弓箭手",
    "10115": "黃金哥布林",
    "10116": "蒙面哥布林",
    "10117": "蒙面哥布林",
    "10118": "蒙面哥布林弓箭手",
    "10119": "板岩國王",
    "10120": "板岩皇后",
    "10121": "板岩弓箭手",
    "10122": "板岩鬥士",
    "10123": "哥布林劍士",
    "10124": "哥布林劍術大師",
    "10125": "洞穴蒙面哥布林",
    "10126": "哥布林守衛",
    "10127": "哥布林守衛弓箭手",
    "10128": "哥布林守衛",
    "10129": "哥布林守衛弓箭手",
    "10130": "哥布林守衛",
    "10131": "哥布林守衛弓箭手",
    "10132": "蜘蛛鬥士",
    "10133": "蜘蛛弓箭手",
    "10134": "蜘蛛士兵",
    "10135": "蜘蛛遊俠",
    "10136": "蜘蛛戰士",
    "10137": "叢林哥布林弓箭手",
    "10138": "叢林哥布林咒術師",
    "10139": "叢林哥布林咒術師",
    "10140": "叢林哥布林咒術師",
    "10141": "叢林哥布林戰士",
    "10142": "叢林哥布林弓箭手",
    "10143": "叢林哥布林咒術師",
    "10144": "叢林哥布林咒術師",
    "10145": "叢林哥布林咒術師",
    "10146": "叢林哥布林弓箭手",
    "10147": "叢林哥布林咒術師",
    "10148": "叢林哥布林咒術師",
    "10149": "叢林哥布林咒術師",
    "10150": "叢林哥布林戰士",
    "10151": "叢林哥布林爆破兵",
    "10152": "叢林哥布林爆破兵",
    "10153": "叢林哥布林頭目",
    "10154": "叢林哥布林頭目",
    "10155": "哥布林獵人",
    "10156": "哥布林獵人",
    "10157": "哥布林獵人",
    "10158": "哥布林獵人",
    "10159": "哥布林獵人弓箭手",
    "10160": "哥布林",
    "10161": "哥布林弓箭手",
    "10162": "劇毒哥布林",
    "10163": "蜘蛛戰士",
    "10164": "蜘蛛弓箭手",
    "10165": "蜘蛛士兵",
    "10166": "蜘蛛遊俠",
    "10167": "蜘蛛戰士",
    "10168": "哥布林",
    "10169": "哥布林弓箭手",
    "10170": "以淚洗面的弓箭手",
    "10171": "單身哥布林弓箭手",
    "10172": "哥布林",
    "10173": "紅哥布林",
    "10174": "哥布林劍士",
    "10175": "哥布林弓箭手",
    "10176": "紅哥布林弓箭手",
    "10177": "哥布林",
    "10178": "哥布林弓箭手",
    "10179": "哥布林盜賊",
    "10180": "羅生克蘭",
    "10181": "蓋登思鄧",
    "10182": "蒙塔古家族",
    "10183": "蒙塔古家族",
    "10184": "蒙塔古家族",
    "10185": "蒙塔古家族",
    "10186": "凱普雷特家族",
    "10187": "凱普雷特家族",
    "10188": "凱普雷特家族",
    "10189": "凱普雷特家族",
    "10190": "提伯爾特",
    "10191": "茱麗葉的奶媽",
    "10192": "警衛兵",
    "10193": "帕里斯",
    "10194": "冒牌貨",
    "10195": "活動 哥布林",
    "10196": "活動 哥布林弓箭手",
    "10197": "活動 叢林哥布林爆破兵",
    "10198": "活動 叢林哥布林爆破兵",
    "10199": "活動 叢林哥布林弓箭手",
    "10200": "里內",
    "10201": "地靈",
    "10202": "劇毒地靈",
    "10203": "地靈弓箭手",
    "10204": "黃金地靈",
    "10205": "地靈礦工",
    "10206": "地靈盜賊",
    "10207": "地靈礦工",
    "10208": "地靈礦工",
    "10209": "紅地靈",
    "10210": "紅小地靈",
    "10211": "雷攻擊的地靈",
    "10212": "火攻擊的地靈",
    "10213": "冰攻擊的地靈",
    "10214": "弓箭攻擊的地靈",
    "10215": "跳躍攻擊的地靈",
    "10220": "紅地靈",
    "10221": "紅地靈",
    "10222": "紅地靈",
    "10223": "紅地靈",
    "10224": "孤獨的地靈",
    "10225": "活動 地靈",
    "10226": "活動 地靈弓箭手",
    "10229": "活動 叢林哥布林戰士",
    "10230": "活動 叢林哥布林頭目",
    "10231": "安東尼奧",
    "10232": "巴薩尼奧",
    "10233": "尼克",
    "10234": "伊絲娜",
    "10235": "哥布林獵人",
    "10236": "單身地靈",
    "10237": "單身劇毒地靈",
    "10238": "單身地靈弓箭手",
    "10239": "克依",
    "10240": "雷摩爾",
    "10241": "法隆的士兵",
    "10242": "法隆的士兵",
    "10243": "法隆的士兵",
    "10244": "法隆的士兵",
    "10245": "叢林哥布林弓箭手",
    "10246": "叢林哥布林咒術師",
    "10247": "叢林哥布林咒術師",
    "10248": "叢林哥布林咒術師",
    "10249": "叢林哥布林戰士",
    "10250": "叢林哥布林頭目",
    "10251": "叢林哥布林頭目",
    "10252": "叢林哥布林炸彈兵",
    "10255": "인간",
    "10256": "인간",
    "10257": "인간",
    "10301": "黑魅魔",
    "10302": "紅魅魔",
    "10303": "白魅魔",
    "10304": "黃魅魔",
    "10305": "棕魅魔",
    "10306": "粉紅魅魔",
    "10307": "火焰魅魔",
    "10308": "雷電魅魔",
    "10309": "寒冰魅魔",
    "10310": "劇毒魅魔",
    "10311": "黑魅魔",
    "10312": "黑暗魅魔",
    "10313": "紅色魅魔",
    "10314": "黑色魅魔",
    "10315": "白魅魔",
    "10316": "黃魅魔",
    "10317": "粉紅魅魔",
    "10318": "黑魅魔",
    "10319": "紅魅魔",
    "10320": "黃魅魔",
    "10321": "活動 白魅魔",
    "10401": "巨魔",
    "10402": "小巨魔",
    "10403": "巨魔",
    "10404": "雪山巨魔",
    "10405": "巨大雪山巨魔",
    "10406": "雪山巨魔",
    "10407": "雪山巨魔",
    "10408": "雪山巨魔",
    "10409": "雪山巨魔",
    "10411": "熊地精",
    "10412": "熊地精",
    "10413": "熊地精",
    "10421": "海巨魔",
    "10422": "巨大海巨魔",
    "10423": "荒野巨魔",
    "10424": "巨大荒野巨魔",
    "10425": "海巨魔",
    "10426": "巨大海巨魔",
    "10427": "荒野巨魔",
    "10428": "巨大荒野巨魔",
    "10501": "木頭人",
    "10502": "鐵人",
    "10601": "妖魔",
    "10602": "巨大妖魔",
    "10603": "隱形妖魔",
    "10604": "骷髏妖魔",
    "10605": "巨大骷髏妖魔",
    "10606": "優等生 妖魔",
    "10607": "妖魔",
    "10608": "妖魔",
    "10609": "妖魔",
    "10610": "冰雪妖魔",
    "10611": "冰雪妖魔",
    "10612": "冰雪妖魔",
    "10613": "優等生 妖魔",
    "10614": "優等生 妖魔",
    "10615": "優等生 妖魔",
    "10616": "巨大冰雪妖魔",
    "10617": "小鬼",
    "10618": "妖魔",
    "10619": "巨大妖魔",
    "10620": "孤單的妖魔",
    "10621": "活動 妖魔",
    "10622": "活動 巨大妖魔",
    "10623": "冰雪妖魔",
    "10624": "紛爭的透明妖魔",
    "10701": "魔女",
    "10702": "魔女",
    "10703": "魔女",
    "10704": "魔女",
    "10705": "魔女",
    "10706": "魔女",
    "10801": "屍妖",
    "10802": "屍妖",
    "10803": "屍妖",
    "10804": "屍妖",
    "10805": "固執的 屍妖",
    "10806": "活動 屍妖",
    "10901": "食屍鬼",
    "10902": "食屍鬼",
    "10903": "食屍鬼",
    "10904": "食屍鬼",
    "10905": "水",
    "10906": "肉團",
    "10907": "蔬菜",
    "10908": "果實",
    "10909": "起司",
    "10910": "葡萄酒",
    "10911": "香料",
    "10912": "海產",
    "10913": "小麥粉",
    "10914": "雞蛋",
    "10915": "無力的 食屍鬼",
    "10916": "剛復活的食屍鬼",
    "10917": "憤怒的 食屍鬼",
    "10918": "憤怒的 食屍鬼",
    "10919": "維羅納食屍鬼",
    "10920": "維羅納食屍鬼",
    "10921": "活動 食屍鬼",
    "10922": "果實",
    "10923": "小麥粉",
    "10924": "雞蛋",
    "10925": "牛奶巧克力",
    "10926": "杏仁果巧克力",
    "10927": "黑巧克力",
    "10928": "秘密調味粉",
    "10929": "小麥粉",
    "10930": "巧克力瑞士火鍋點心棒",
    "10931": "掃興的葛魯奇",
    "10932": "算命克萊傑",
    "10933": "毛皮愛好家 佩勒斯",
    "10934": "偷走總舖師的實務的小偷",
    "11001": "骷髏",
    "11002": "紅骷髏",
    "11003": "金屬骷髏",
    "11004": "骷髏士兵",
    "11005": "巨大骷髏",
    "11006": "骷髏",
    "11007": "骷髏",
    "11008": "紅骷髏",
    "11009": "紅骷髏",
    "11010": "金屬骷髏",
    "11011": "金屬骷髏",
    "11012": "黑暗骷髏",
    "11013": "海盜骷髏",
    "11014": "海盜骷髏",
    "11015": "骷髏船長",
    "11016": "海盜紅骷髏",
    "11017": "海盜紅骷髏",
    "11018": "海盜紅骷髏船長",
    "11019": "骷髏吟遊詩人",
    "11020": "金屬骷髏吟遊詩人",
    "11021": "骷髏守衛",
    "11022": "骷髏",
    "11023": "劇毒骷髏士兵",
    "11024": "金屬骷髏",
    "11025": "骷髏吟遊詩人",
    "11026": "骷髏自爆兵",
    "11027": "骷髏自爆兵",
    "11028": "骷髏",
    "11029": "紅骷髏",
    "11030": "金屬骷髏",
    "11031": "骷髏",
    "11032": "金屬骷髏",
    "11033": "金屬骷髏",
    "11034": "金屬骷髏",
    "11035": "金屬骷髏",
    "11036": "海盜紅骷髏",
    "11037": "海盜紅骷髏",
    "11038": "海盜紅骷髏",
    "11039": "海盜紅骷髏",
    "11040": "紅骷髏",
    "11041": "紅骷髏",
    "11042": "紅骷髏",
    "11043": "紅骷髏",
    "11044": "金屬骷髏",
    "11045": "金屬骷髏",
    "11046": "海盜骷髏",
    "11047": "海盜骷髏",
    "11048": "骷髏",
    "11049": "海盜紅骷髏船長",
    "11050": "骷髏船長",
    "11051": "海盜紅骷髏船長",
    "11052": "海盜紅骷髏船長",
    "11053": "艾希諾鬼魂",
    "11054": "艾希諾鬼魂",
    "11055": "海盜骷髏船員",
    "11056": "海盜骷髏船員",
    "11057": "海盜骷髏船員",
    "11058": "海盜骷髏船員",
    "11059": "海盜骷髏船長",
    "11060": "海盜骷髏船長",
    "11061": "海盜骷髏船長",
    "11062": "維羅納黑暗骷髏士兵",
    "11063": "維羅納黑暗骷髏士兵",
    "11064": "活動 黑暗骷髏士兵",
    "11065": "骷髏自爆兵",
    "11101": "紅骷髏",
    "11102": "骷髏",
    "11103": "骷髏",
    "11104": "海盜骷髏",
    "11105": "骷髏船長",
    "11106": "小骷髏",
    "11107": "小骷髏",
    "11201": "茶壺士兵",
    "11202": "茶壺士兵",
    "11301": "燭臺士兵",
    "11302": "燭臺士兵",
    "12001": "鬼魂之鎧",
    "12101": "石頭妖魔",
    "12102": "石頭妖魔-帽子發光",
    "12103": "石頭妖魔-寶石發光",
    "12104": "石頭妖魔-頭飾發光",
    "12105": "石頭妖魔-鼻子發光",
    "12106": "石頭妖魔-耳朵發光",
    "12107": "石頭妖魔-涼鞋發光",
    "12108": "發光石頭妖魔",
    "12109": "石頭妖魔",
    "12110": "石頭妖魔",
    "12111": "石頭妖魔",
    "12112": "石頭妖魔",
    "13001": "沙華魚人士兵",
    "13002": "沙華魚人鬥士",
    "13003": "沙華魚人遊俠",
    "13004": "沙華魚人戰士",
    "13005": "迷失沙華魚人",
    "13006": "迷失沙華魚人",
    "13007": "迷失沙華魚人",
    "13008": "_迷失沙華魚人(被動 自爆)",
    "13009": "_迷失沙華魚人(戰鬥 自爆)",
    "13010": "迷失沙華魚人",
    "13011": "迷失沙華魚人",
    "13012": "沙華魚人鬥士",
    "13013": "沙華魚人鬥士",
    "13014": "沙華魚人鬥士",
    "13015": "沙華魚人鬥士",
    "13016": "沙華魚人遊俠",
    "13017": "沙華魚人士兵",
    "13018": "沙華魚人鬥士",
    "13019": "沙華魚人遊俠",
    "13020": "沙華魚人戰士",
    "13021": "淡水沙華魚人遊俠",
    "13022": "淡水沙華魚人鬥士",
    "13023": "洞穴沙華魚人魔法師",
    "13024": "洞穴沙華魚人戰士",
    "13025": "淡水沙華魚人遊俠",
    "13026": "淡水沙華魚人鬥士",
    "13027": "洞穴沙華魚人魔法師",
    "13028": "洞穴沙華魚人戰士",
    "13101": "沙華魚人戰士",
    "14001": "惡翅魅魔",
    "14002": "惡翅魅魔",
    "14003": "惡翅魅魔",
    "14004": "惡翅魅魔",
    "14005": "惡翅魅魔",
    "14006": "惡翅魅魔",
    "14007": "惡翅魅魔",
    "14008": "惡翅魅魔",
    "14009": "惡翅魅魔",
    "14010": "惡翅魅魔",
    "14011": "惡翅魅魔",
    "14012": "活動 惡翅魅魔",
    "15001": "幽靈軍首領",
    "15002": "幽靈軍鬥士",
    "15003": "幽靈軍戰士",
    "15004": "幽靈軍弓箭手",
    "16001": "遺跡守護者",
    "16002": "遺跡守護者",
    "16003": "遺跡守護者",
    "17001": "貓妖精騎士",
    "17002": "貓妖精騎士",
    "17003": "貓妖精騎士",
    "17004": "貓妖精騎士",
    "17005": "貓妖精魔法師",
    "17006": "貓妖精",
    "17007": "貓妖精騎士",
    "17008": "貓妖精騎士",
    "17009": "貓妖精騎士",
    "17010": "貓妖精騎士",
    "17011": "貓妖精魔法師",
    "17012": "원령 기사",
    "17013": "원령 궁수",
    "17014": "거대 원령 기사",
    "17015": "거대 원령 궁수",
    "17101": "沙漠戰士亡靈",
    "17102": "沙漠戰士亡靈",
    "17103": "沙漠獵手亡靈",
    "17104": "沙漠獵手亡靈",
    "17105": "沙漠戰士亡靈",
    "17106": "沙漠亡靈狂信徒",
    "17107": "沙漠亡靈狂信徒祭司",
    "17108": "沙漠亡靈狂信徒",
    "17109": "沙漠亡靈狂信徒",
    "17110": "沙漠亡靈狂信徒祭司",
    "17111": "獵手亡靈",
    "17400": "豺狼人",
    "17401": "豺狼人",
    "17402": "豺狼人",
    "17403": "豺狼人",
    "17404": "豺狼人",
    "17405": "豺狼人",
    "17406": "豺狼人",
    "17407": "豺狼人",
    "17408": "豺狼人",
    "17409": "豺狼人",
    "17410": "豺狼人",
    "17411": "豺狼人",
    "17501": "半巫妖",
    "17502": "活動 半巫妖",
    "17601": "藍色鬼魂",
    "17602": "紅色鬼魂",
    "17603": "鬼魂",
    "17604": "鬼魂",
    "17605": "鬼魂",
    "17606": "藍色鬼魂",
    "17607": "紅色鬼魂",
    "17608": "鬼魂",
    "17609": "骷髏幽靈",
    "17610": "綠色骷髏幽靈",
    "17611": "藍色骷髏幽靈",
    "17612": "白色骷髏幽靈",
    "17613": "紅色骷髏幽靈",
    "17614": "棕色牢獄鬼魂",
    "17615": "紅色牢獄鬼魂",
    "17616": "藍色牢獄鬼魂",
    "17617": "虛弱的 鬼魂",
    "17618": "巨大藍色鬼魂",
    "17619": "暗影鬼魂",
    "17620": "缺乏能量的 鬼魂",
    "17621": "缺乏能量的 鬼魂",
    "17622": "藍色鬼魂之王",
    "17623": "紅色鬼魂之王",
    "17624": "鬼魂之王",
    "17625": "維羅納黑色牢獄鬼魂",
    "17626": "維羅納黑色牢獄鬼魂",
    "17627": "鬼魂",
    "17628": "紅色鬼魂",
    "17629": "巨大鬼魂",
    "17630": "徘徊的牢獄鬼魂",
    "17701": "虛無騎士",
    "17702": "虛無騎士",
    "17703": "締下契約的 虛無騎士",
    "17704": "活動 虛無騎士",
    "17801": "報喪女妖",
    "17802": "活動 報喪女妖",
    "17901": "石頭戰馬守衛",
    "18001": "古代巫妖",
    "18101": "棕色蜥蜴魔法師",
    "18102": "綠色蜥蜴魔法師",
    "18103": "藍色蜥蜴魔法師",
    "18104": "暗影巫師",
    "18105": "暗影巫師",
    "18106": "暗影鍊金術師",
    "18107": "提阿瑪特",
    "18108": "暗影巫師",
    "18109": "暗影鍊金術師",
    "18110": "阿蘭特鍊金術師",
    "18111": "阿蘭特鍊金術師",
    "18112": "墮落的鍊金術師",
    "18113": "墮落的鍊金術師",
    "18114": "暗影鍊金術師",
    "18115": "墮落的鍊金術師",
    "18116": "暗影巫師",
    "18117": "虛象的 闇影巫師",
    "18118": "墮落的鍊金術師",
    "18119": "墮落的鍊金術師",
    "18120": "墮落的鍊金術師",
    "18121": "墮落的鍊金術師屍體",
    "18122": "墮落的鍊金術師",
    "18123": "墮落的鍊金術師",
    "18124": "墮落的鍊金術師",
    "18125": "暗影鍊金術師",
    "18126": "活動 暗影巫師",
    "18201": "紅木乃伊僕人",
    "18202": "黑木乃伊僕人",
    "18203": "白木乃伊僕人",
    "18301": "棕色鬼魂僕人",
    "18302": "黑色鬼魂僕人",
    "18303": "白色鬼魂僕人",
    "18401": "<mini>NPC</mini> 精靈守衛",
    "18402": "<mini>NPC</mini> 精靈守衛",
    "18403": "<mini>NPC</mini> 精靈守衛",
    "18404": "<mini>NPC</mini> 精靈守衛",
    "18405": "精靈守衛",
    "18406": "精靈守衛",
    "18407": "精靈隊長",
    "18408": "精靈隊長",
    "18409": "<mini>NPC</mini> 精靈守衛",
    "18410": "<mini>NPC</mini> 精靈守衛",
    "18411": "<mini>NPC</mini> 精靈守衛",
    "18412": "<mini>NPC</mini> 精靈守衛",
    "19001": "冰鏡魔女",
    "19002": "冰鏡魔女",
    "19101": "奧拉克妮",
    "19102": "奧拉克妮",
    "19103": "餅乾魔女",
    "19104": "活動 奧拉克妮",
    "19105": "活動 奧拉克妮",
    "19106": "憤怒的紅木乃伊僕人",
    "19107": "憤怒的黑木乃伊僕人",
    "19108": "憤怒的白木乃伊僕人",
    "19110": "萊爾特精靈",
    "19111": "拉斯帕精靈",
    "19112": "綠洲精靈",
    "19113": "萬聖節棺材寶箱怪",
    "19114": "四處飄動的幽靈",
    "19115": "四處飄動的幽靈",
    "19116": "四處飄動的幽靈",
    "19117": "四處飄動的幽靈",
    "19118": "四處飄動的幽靈",
    "19119": "四處飄動的幽靈",
    "19120": "四處飄動的幽靈",
    "19121": "四處飄動的幽靈",
    "19122": "四處飄動的幽靈",
    "19123": "故障的警衛兔子玩偶",
    "19124": "人偶工坊人偶",
    "19125": "人偶工坊人偶",
    "19126": "人偶工坊人偶",
    "19127": "人偶工坊人偶",
    "19137": "銀河鋼琴",
    "19138": "鼓",
    "19139": "站立式麥克風",
    "19140": "向日葵",
    "19141": "向日葵",
    "19142": "向日葵",
    "19143": "復古拉米",
    "19144": "復古萊里",
    "19145": "復古卡塔爾",
    "19146": "轉盤",
    "19147": "莫克爾卡爾菲",
    "19148": "巨大地蟲",
    "19149": "世界樹小精靈",
    "19150": "森林巨龍",
    "19151": "哈西汀",
    "19221": "星座熊",
    "19222": "星座馬",
    "19223": "星座羊",
    "19301": "帕爾赫德族的幽靈",
    "19302": "巨蛇士兵",
    "19303": "巨蛇咒術師",
    "19304": "巨蛇巫師",
    "19305": "巨大帕爾赫德族的幽靈",
    "19306": "暗影鬼魂",
    "19307": "黃金骸骨戰士",
    "19308": "黃金骸骨槍騎兵",
    "19309": "黃金骸骨弓箭手",
    "19310": "黑暗指揮官",
    "19311": "硫磺蜘蛛",
    "19312": "巨大硫磺蜘蛛",
    "19313": "小硫磺蜘蛛",
    "19314": "黑色硫磺蜘蛛",
    "19315": "紅色硫磺蜘蛛",
    "19316": "都拉漢",
    "19330": "長老凱倫嘉",
    "19333": "浪漫廚師克麗塔",
    "19336": "浪漫火炬",
    "19338": "雷特",
    "19339": "洛特",
    "20001": "灰狼",
    "20002": "黑狼",
    "20003": "白狼",
    "20004": "骷髏狼",
    "20005": "棕惡狼",
    "20006": "灰惡狼",
    "20007": "黑惡狼",
    "20008": "白惡狼",
    "20009": "幼小棕惡狼",
    "20010": "幼小灰惡狼",
    "20011": "幼小黑惡狼",
    "20012": "幼小白惡狼",
    "20013": "巨大白狼",
    "20014": "巨大黑狼",
    "20015": "緋紅惡狼",
    "20016": "藍惡狼",
    "20017": "藍狼",
    "20018": "骷髏地獄犬",
    "20019": "巨大骷髏地獄犬",
    "20020": "披著羊皮的狼",
    "20021": "骷髏地獄看門犬",
    "20022": "灰狼",
    "20023": "白狼",
    "20024": "骷髏狼",
    "20025": "灰狼",
    "20026": "披著羊皮的狼",
    "20027": "藍狼",
    "20028": "藍惡狼魔族",
    "20029": "緋紅惡狼魔族",
    "20030": "骷髏狼",
    "20031": "披著羊皮的狼",
    "20032": "黑狼",
    "20033": "芬里爾",
    "20034": "芬里爾",
    "20035": "白惡狼",
    "20036": "黑惡狼",
    "20037": "巨大白狼",
    "20038": "黑狼",
    "20039": "黑惡狼",
    "20040": "巨大白狼",
    "20041": "巨大黑狼",
    "20042": "巨大披著羊皮的狼",
    "20043": "活動 巨大白狼",
    "20044": "이벤트 거대 검은늑대",
    "20045": "이벤트 거대 양 늑대",
    "20046": "이벤트 푸른늑대",
    "20047": "이벤트 양 늑대",
    "20048": "이벤트 회색늑대",
    "20049": "이벤트 검은늑대",
    "20050": "活動 白狼",
    "20051": "活動 白狼",
    "20052": "活動 巨大白狼",
    "20053": "從院子中逃出的巨大公雞",
    "20054": "第9個太陽",
    "20055": "棕色荒野狼",
    "20056": "灰色荒野狼",
    "20057": "棕色荒野狼",
    "20058": "灰色荒野狼",
    "20059": "約瑟芬",
    "20101": "狗",
    "20102": "混血哈士奇",
    "20201": "地獄犬",
    "20202": "地獄犬",
    "20301": "郊狼",
    "20303": "幼小棕色草原狼",
    "20304": "棕色草原狼",
    "20305": "幼小灰色草原狼",
    "20306": "灰色草原狼",
    "20307": "幼小白色草原狼",
    "20308": "白色草原狼",
    "20401": "豺狼",
    "20403": "幼小棕色豺狼",
    "20404": "棕色豺狼",
    "20405": "幼小灰色豺狼",
    "20406": "灰色豺狼",
    "20407": "幼小白色豺狼",
    "20408": "白色豺狼",
    "20501": "豺狼",
    "20502": "巨大豺狼",
    "20503": "森林豺狼",
    "20504": "熱帶草原豺狼",
    "20505": "巨大森林豺狼",
    "20601": "長鬃毛土狼",
    "20602": "短鬃毛土狼",
    "20603": "土狼首領",
    "20604": "斑紋土狼",
    "20605": "無紋土狼",
    "20606": "가드 하이에나",
    "20607": "條紋土狼",
    "20608": "短鬃毛土狼",
    "20609": "土狼首領",
    "20610": "長鬃毛土狼",
    "20611": "短鬃毛土狼",
    "20701": "石頭獵犬",
    "20702": "石頭獵犬-耳朵發光",
    "20703": "石頭獵犬-牙齒發光",
    "20704": "石頭獵犬-尾巴發光",
    "20705": "石頭獵犬-腳飾發光",
    "20706": "石頭獵犬-爪子發光",
    "20707": "發光石頭獵犬",
    "20708": "石頭獵犬",
    "20709": "石頭獵犬",
    "20710": "石頭獵犬",
    "20711": "石頭獵犬",
    "20801": "護衛犬",
    "20802": "護衛犬",
    "20901": "黃金鎧甲獵犬",
    "20902": "白銀鎧甲獵犬",
    "20903": "青銅鎧甲獵犬",
    "20904": "白銀鎧甲獵犬",
    "21001": "努比斯野狗",
    "21002": "拉圖勒野狗",
    "21003": "暗影惡犬",
    "21004": "暗影惡犬",
    "21005": "努比斯野狗",
    "21006": "暗影惡犬",
    "21101": "紅色大山貓",
    "21102": "白色大山貓",
    "21201": "幼小棕色野狼",
    "21202": "棕色野狼",
    "21203": "幼小藍色野狼",
    "21204": "藍色野狼",
    "21205": "幼小黑色野狼",
    "21206": "黑色野狼",
    "21207": "幼小白色野狼",
    "21208": "白色野狼",
    "21209": "白色野狼",
    "21210": "棕色野狼",
    "21301": "冰晶土狼",
    "21302": "綠寶石土狼",
    "21401": "無眼惡狼",
    "21402": "無眼惡狼",
    "21403": "步履蹣珊的狼",
    "21404": "無眼惡狼",
    "21501": "灰色叢林狼",
    "21502": "紅色叢林狼",
    "21601": "火山野狼",
    "21602": "火山野狼",
    "21607": "火山野狼",
    "21701": "火山野狗",
    "21702": "火山野狗",
    "21707": "火山野狗",
    "30001": "白蜘蛛",
    "30002": "黑蜘蛛",
    "30003": "紅蜘蛛",
    "30004": "巨大蜘蛛",
    "30005": "小白蜘蛛",
    "30006": "巨大黑蜘蛛",
    "30007": "巨大紅蜘蛛",
    "30008": "巨大白蜘蛛",
    "30009": "巨大黑蜘蛛",
    "30010": "巨大紅蜘蛛",
    "30011": "巨大白蜘蛛",
    "30012": "緋紅蜘蛛",
    "30013": "綻藍蜘蛛",
    "30014": "白蜘蛛",
    "30015": "守衛劇毒蜘蛛",
    "30016": "守衛蜘蛛",
    "30017": "白蜘蛛",
    "30018": "幼小巨大蜘蛛",
    "30019": "幼小紅色蜘蛛",
    "30020": "黑狼蛛",
    "30021": "幼小黑狼蛛",
    "30022": "幼小巨大蜘蛛",
    "30023": "巨大蜘蛛",
    "30024": "小白蜘蛛",
    "30025": "紅蜘蛛",
    "30026": "白蜘蛛",
    "30027": "黑狼蛛",
    "30028": "綻藍蜘蛛",
    "30029": "緋紅蜘蛛",
    "30030": "巨大紅蜘蛛",
    "30031": "巨大白蜘蛛",
    "30032": "黑蜘蛛",
    "30033": "雪原蜘蛛",
    "30034": "巨大雪原蜘蛛",
    "30101": "鐮刀劇毒蜘蛛",
    "30102": "釘刺劇毒蜘蛛",
    "30103": "緋紅鐮刀劇毒蜘蛛",
    "30104": "紅色鐮刀劇毒蜘蛛",
    "30105": "紅色釘刺劇毒蜘蛛",
    "30106": "紅色鐮刀劇毒蜘蛛",
    "30108": "骷髏劇毒蜘蛛",
    "30109": "鐮刀劇毒蜘蛛",
    "30110": "釘刺劇毒蜘蛛",
    "30111": "緋紅鐮刀劇毒蜘蛛",
    "30112": "紅色鐮刀劇毒蜘蛛",
    "30113": "紅色釘刺劇毒蜘蛛",
    "30114": "硫磺蜘蛛",
    "30115": "巨大硫磺蜘蛛",
    "30116": "小硫磺蜘蛛",
    "30117": "黑色硫磺蜘蛛",
    "30118": "紅色硫磺蜘蛛",
    "30119": "黑色硫磺蜘蛛",
    "30120": "紅色硫磺蜘蛛",
    "30121": "巨大硫磺蜘蛛",
    "30122": "小硫磺蜘蛛",
    "30123": "黑色硫磺蜘蛛",
    "30124": "紅色硫磺蜘蛛",
    "30125": "黑色硫磺蜘蛛",
    "30126": "紅色硫磺蜘蛛",
    "30127": "巨大硫磺蜘蛛",
    "30128": "小硫磺蜘蛛",
    "30129": "硫磺蜘蛛",
    "30130": "硫磺蜘蛛",
    "30201": "罈壺蜘蛛",
    "30202": "罈壺蜘蛛",
    "30203": "罈壺蜘蛛-腳發光",
    "30204": "罈壺蜘蛛-罈壺發光",
    "30205": "罈壺蜘蛛-牙發光",
    "30206": "罈壺蜘蛛-螯發光",
    "30207": "毒囊罈壺蜘蛛",
    "30208": "發光罈壺蜘蛛",
    "30209": "罈壺蜘蛛",
    "30210": "罈壺蜘蛛",
    "30211": "罈壺蜘蛛",
    "30301": "黑色沙漠蜘蛛",
    "30302": "白色斑點沙漠蜘蛛",
    "30303": "白色條紋沙漠蜘蛛",
    "30304": "白色沙漠蜘蛛",
    "30305": "狼紋沙漠蜘蛛",
    "30306": "狼紋沙漠蜘蛛",
    "30307": "紅眼刺腳蜘蛛",
    "30308": "巨大紅眼刺腳蜘蛛",
    "30309": "紅眼刺腳蜘蛛",
    "30310": "巨大紅眼刺腳蜘蛛",
    "30401": "棕色森林蘑菇蜘蛛",
    "30402": "紅色森林蘑菇蜘蛛",
    "30403": "藍色森林蘑菇蜘蛛",
    "30404": "黑色森林蘑菇蜘蛛",
    "30405": "巨大黃金森林磨菇蜘蛛",
    "30406": "巨大黃金森林磨菇蜘蛛",
    "30501": "燭臺蜘蛛",
    "30601": "吊燈蜘蛛",
    "30701": "白色蟻獅",
    "30702": "黃色蟻獅",
    "30703": "紅色蟻獅",
    "30704": "白色蟻獅",
    "30801": "巨大黃金蜘蛛",
    "30802": "幼小巨大黃金蜘蛛",
    "30901": "白腳狼蛛",
    "30902": "黑腳狼蛛",
    "31001": "藍色螃蟹",
    "31002": "紅色螃蟹",
    "31003": "白色螃蟹",
    "31004": "幼小巨大蜘蛛",
    "31005": "夏",
    "31006": "夏",
    "31007": "夏",
    "31008": "夏",
    "31009": "夏",
    "31010": "夜",
    "31011": "夜",
    "31012": "黑色忍者",
    "31104": "充滿憤怒的 見習考古學者",
    "31105": "充滿憤怒的 首席考古學者",
    "31106": "充滿憤怒的 探查隊員",
    "31107": "充滿憤怒的 資深地質學家",
    "31108": "充滿憤怒的 首席地質學家",
    "31109": "充滿憤怒的 沙漠戰士亡靈",
    "31110": "受挫的戰士",
    "32000": "艾爾班騎士巨魔像",
    "32001": "艾爾班騎士巨魔像",
    "32002": "艾爾班騎士巨魔像",
    "32003": "艾爾班騎士巨魔像",
    "32004": "艾爾班騎士巨魔像",
    "32005": "艾爾班騎士巨魔像",
    "32006": "黑色異變的熊",
    "32007": "半月熊",
    "32008": "獅子",
    "32009": "黑豹",
    "32010": "長毛象",
    "32011": "巨大黃金蜘蛛",
    "32012": "白腳狼蛛",
    "32013": "巨大雌性黃蜂",
    "32014": "黃寶石甲蟲",
    "32015": "毒針沙漠蠍子",
    "32016": "狂暴翼魔",
    "32017": "黑色搗蛋鬼之王",
    "32018": "哥布林獵人",
    "32019": "劇毒的 奇蘭",
    "32020": "食人魔戰士",
    "32021": "全鎧甲骷髏食人魔",
    "32022": "沙華魚人士兵",
    "32023": "洞穴沙華魚人魔法師",
    "32024": "炎魔",
    "32025": "藍色骷髏幽靈",
    "32026": "蜘蛛絲木乃伊",
    "32027": "殭屍",
    "32028": "迷路的 巨大雪白殭屍",
    "32029": "骷髏海盜船長",
    "32030": "骷髏吟遊詩人",
    "32031": "小精靈",
    "32032": "冰雪之魂",
    "32033": "被侵蝕的 伊弗烈特",
    "32034": "妖魔",
    "32035": "掠奪團妖魔",
    "32036": "巨大城牆巨魔像",
    "32037": "巨魔像",
    "32038": "水晶巨魔像",
    "32039": "蒙面哥布林弓箭手",
    "32040": "沙華魚人遊俠",
    "32041": "幽靈軍弓箭手",
    "32042": "白銀骸骨弓箭手",
    "32043": "哥布林獵人",
    "32044": "哥布林獵人",
    "32045": "戰士的意念",
    "32046": "戰士的意念",
    "32047": "戰士的意念",
    "32048": "強烈的 戰士的意念",
    "32049": "魔法師的意念",
    "32050": "魔法師的意念",
    "32051": "魔法師的意念",
    "32052": "強烈的 魔法師的意念",
    "32053": "弓箭手的意念",
    "32054": "弓箭手的意念",
    "32055": "弓箭手的意念",
    "32056": "強烈的 弓箭手的意念",
    "32057": "透明道具",
    "32058": "亞特的思念",
    "32059": "艾薇琳的思念",
    "32060": "托爾維斯的思念",
    "32061": "卡茲遠的思念",
    "32062": "畢奈的思念",
    "32063": "洛維林的思念",
    "32064": "冬至組組員的思念",
    "32065": "冬至組組員的思念",
    "32066": "秋收組組員的思念",
    "32067": "秋收組組員的思念",
    "32068": "立夏組團員的思念",
    "32069": "立夏組團員的思念",
    "32070": "春分組組員的思念",
    "32071": "春分組組員的思念",
    "33000": "浣熊",
    "33001": "犰狳",
    "33002": "狐狸",
    "33003": "老鼠",
    "33004": "蜘蛛",
    "33005": "寶箱怪",
    "33006": "亡靈",
    "33007": "蝙蝠",
    "33008": "蜈蚣",
    "33009": "魔劍",
    "33010": "哥布林",
    "33011": "巨魔像",
    "33012": "地靈",
    "33013": "貓鼬",
    "33014": "企鵝",
    "33015": "奇異鳥",
    "33016": "蠍子",
    "33017": "豺狼",
    "33018": "狼",
    "33019": "毒蛇",
    "33020": "搗蛋鬼",
    "33021": "元素之魂",
    "33022": "骷髏",
    "33023": "鬣蜥",
    "33024": "幼蟲",
    "33025": "郊狼",
    "33026": "野豬",
    "33027": "金龜子",
    "33028": "牛",
    "33029": "聖誕糜鹿",
    "33030": "淡水沙華魚人",
    "33031": "鴕鳥",
    "33032": "螃蟹",
    "33033": "水豚",
    "33034": "邋馬",
    "33035": "山羊",
    "33036": "水獺",
    "33037": "食蟻獸",
    "33038": "鬼魂",
    "33039": "暗影搗蛋鬼",
    "33040": "冰晶灰熊",
    "33041": "蜥蜴",
    "33042": "殭屍",
    "33043": "豺狼",
    "33044": "鼠人",
    "33045": "犀牛",
    "33046": "大熊",
    "33047": "妖魔",
    "33048": "食人魔",
    "33049": "石頭獵犬",
    "33050": "鹿",
    "33051": "土狼",
    "33052": "野狗",
    "33053": "劇毒蜘蛛",
    "33054": "蜻蜓",
    "33055": "翼魔",
    "33056": "大山貓",
    "33057": "骷髏狼",
    "33058": "盔甲獵犬",
    "33059": "食屍鬼",
    "33060": "馬",
    "33061": "獵犬",
    "33062": "食蟲植物",
    "33063": "鍬形蟲",
    "33064": "戈耳戈",
    "33065": "大象",
    "33066": "蜘蛛黃蜂",
    "33067": "小精靈",
    "33068": "萊肯",
    "33069": "狼人",
    "33070": "薩提洛斯",
    "33071": "魅魔",
    "33072": "石頭戰馬守衛",
    "33073": "巨魔",
    "33074": "豺狼人",
    "33075": "魔女",
    "33076": "板岩怪",
    "33077": "地獄犬",
    "33078": "河馬",
    "33079": "貓妖精",
    "33080": "惡翅魅魔",
    "33081": "鱷魚",
    "33082": "冰鏡魔女",
    "33083": "木乃伊",
    "33084": "鬼魂僕人",
    "33085": "蜥蜴魔法師",
    "33086": "百眼巨人",
    "33087": "巨大無頭怪",
    "33088": "幼蟲",
    "33089": "獅子",
    "33090": "炎魔",
    "33091": "獨眼巨人",
    "33092": "格蘭帝爾",
    "33093": "蜘蛛哥布林",
    "33094": "熊地精",
    "33095": "偽裝怪",
    "33096": "人類",
    "33097": "飛蛾",
    "33098": "蜘蛛絲木乃伊",
    "33099": "女妖",
    "33100": "虛無騎士",
    "33101": "半巫妖",
    "35000": "小田鼠",
    "35001": "溫馴的 蝙蝠",
    "35002": "小白蜘蛛",
    "35003": "鄉村老鼠",
    "35004": "古老的 寶箱怪",
    "35005": "蝙蝠",
    "35006": "白蜘蛛",
    "35007": "巨大蝙蝠",
    "35008": "藍狼",
    "35009": "巨大蜘蛛",
    "35010": "緋紅蜘蛛",
    "35011": "藍灰熊",
    "35012": "緋紅蜘蛛",
    "35013": "藍惡狼",
    "35014": "巨大蜘蛛",
    "35015": "藍灰熊",
    "35016": "緋紅惡狼",
    "35017": "小精靈",
    "35018": "灰狼人",
    "35019": "巨大白蜘蛛",
    "35020": "巨大紅蜘蛛",
    "35021": "白蜘蛛黃蜂",
    "35022": "黑狼蛛",
    "35023": "蜘蛛鬥士",
    "35024": "無眼惡狼",
    "35025": "蜘蛛弓箭手",
    "35026": "蜘蛛絲木乃伊",
    "35027": "蜘蛛士兵",
    "35028": "無眼惡狼",
    "35029": "蜘蛛遊俠",
    "35030": "格蘭帝爾",
    "35031": "紅蜘蛛黃蜂",
    "35032": "幼蟲",
    "35033": "格蘭帝爾",
    "35034": "蜘蛛戰士",
    "35035": "幼蟲",
    "35036": "黃蜘蛛黃蜂",
    "35037": "黑蜘蛛",
    "35038": "哥布林",
    "35039": "灰鼠",
    "35040": "寶箱怪",
    "35041": "哥布林弓箭手",
    "35042": "紅蜘蛛",
    "35043": "蝙蝠",
    "35044": "劇毒哥布林",
    "35045": "鐮刀劇毒蜘蛛",
    "35046": "棕蛇",
    "35047": "青蛇",
    "35048": "鼠人",
    "35049": "白蛇",
    "35050": "巨大寶箱怪",
    "35051": "釘刺劇毒蜘蛛",
    "35052": "蝙蝠",
    "35053": "鐮刀劇毒蜘蛛",
    "35054": "棕蛇",
    "35055": "青蛇",
    "35056": "鼠人",
    "35057": "白蛇",
    "35058": "緋紅鐮刀劇毒蜘蛛",
    "35059": "藍鼠人",
    "35060": "黑蛇",
    "35061": "紅鼠",
    "35062": "綠蛇",
    "35063": "暗黑鼠人",
    "35064": "紅色鐮刀劇毒蜘蛛",
    "35065": "紅色釘刺劇毒蜘蛛",
    "35066": "熊地精",
    "35067": "黑蜘蛛",
    "35068": "地靈",
    "35069": "灰鼠",
    "35070": "寶箱怪",
    "35071": "地靈弓箭手",
    "35072": "袋鼠",
    "35073": "紅蜘蛛",
    "35074": "蝙蝠",
    "35075": "劇毒地靈",
    "35076": "黑蜘蛛",
    "35077": "劇毒地靈",
    "35078": "灰鼠",
    "35079": "黃金地靈",
    "35080": "冰雪之魂",
    "35081": "紅地靈",
    "35082": "骷髏地獄犬",
    "35083": "紅地靈弓箭手",
    "35084": "小巨魔",
    "35085": "火焰之魂",
    "35086": "蝙蝠",
    "35087": "灰鼠",
    "35088": "寶箱怪",
    "35089": "骷髏",
    "35090": "骷髏狼",
    "35091": "紅骷髏",
    "35092": "金屬骷髏",
    "35093": "蝙蝠",
    "35094": "灰鼠",
    "35095": "釘刺劇毒蜘蛛",
    "35096": "寶箱怪之王",
    "35097": "骷髏",
    "35098": "紅骷髏",
    "35099": "金屬骷髏",
    "35100": "灰鼠",
    "35101": "黃金哥布林",
    "35102": "寶箱怪",
    "35103": "骷髏狼",
    "35104": "骷髏",
    "35105": "骷髏自爆兵",
    "35106": "骷髏自爆兵",
    "35107": "紅骷髏",
    "35108": "骷髏劇毒蜘蛛",
    "35109": "金屬骷髏",
    "35110": "黑蜘蛛",
    "35111": "哥布林",
    "35112": "妖魔",
    "35113": "哥布林弓箭手",
    "35114": "寶箱怪",
    "35115": "優等生 妖魔",
    "35116": "巨大寶箱怪",
    "35117": "劇毒哥布林",
    "35118": "紅蜘蛛",
    "35119": "吸血蝙蝠",
    "35120": "鐮刀劇毒蜘蛛",
    "35121": "綠色搗蛋鬼",
    "35122": "魔劍",
    "35123": "棕色搗蛋鬼",
    "35124": "灰色搗蛋鬼",
    "35125": "巨大寶箱怪",
    "35126": "戈耳戈",
    "35127": "寶箱怪之王",
    "35128": "釘刺劇毒蜘蛛",
    "35129": "吸血蝙蝠",
    "35130": "妖魔",
    "35131": "骸骨蝶",
    "35132": "棕色搗蛋鬼",
    "35133": "哥布林獵人弓箭手",
    "35134": "哥布林獵人",
    "35135": "灰色搗蛋鬼",
    "35136": "尖刺蚯蚓",
    "35137": "迷失沙華魚人",
    "35138": "寶箱怪之王",
    "35139": "綠色搗蛋鬼",
    "35140": "巨大地蟲",
    "35141": "黑蜘蛛",
    "35142": "豺狼",
    "35143": "灰鼠",
    "35144": "青蛇",
    "35145": "棕蛇",
    "35146": "冰雪之魂",
    "35147": "雷電之魂",
    "35148": "火焰之魂",
    "35149": "白蛇",
    "35150": "戈耳戈",
    "35151": "紅蜘蛛",
    "35152": "寶箱怪",
    "35153": "隱形妖魔",
    "35154": "狼人",
    "35155": "綠色搗蛋鬼",
    "35156": "紅灰熊",
    "35157": "紅熊",
    "35158": "黑蜘蛛",
    "35159": "豺狼",
    "35160": "灰鼠",
    "35161": "青蛇",
    "35162": "棕蛇",
    "35163": "狼人",
    "35164": "白蛇",
    "35165": "戈耳戈",
    "35166": "紅蜘蛛",
    "35167": "小精靈",
    "35168": "寶箱怪",
    "35169": "紅熊",
    "35170": "綠色搗蛋鬼",
    "35171": "幼小紅灰熊",
    "35172": "紅灰熊",
    "35173": "山豬",
    "35174": "森林豺狼",
    "35175": "巨大野鼠",
    "35176": "藍狼人",
    "35177": "巨大豺狼",
    "35178": "棕蛇",
    "35179": "緋紅灰熊",
    "35180": "白蛇",
    "35181": "小精靈",
    "35182": "戈耳戈",
    "35183": "青蛇",
    "35184": "狼人",
    "35185": "豺狼",
    "35186": "綠色搗蛋鬼",
    "35187": "百眼巨人",
    "35188": "百眼巨人",
    "35189": "百眼巨人",
    "35190": "巨大森林豺狼",
    "35191": "青毒蛇",
    "35192": "巨大棕熊",
    "35193": "巨大狼人",
    "35194": "圓滾滾老鼠",
    "35195": "巨大山豬",
    "35196": "小精靈",
    "35197": "黑毒蛇",
    "35198": "白毒蛇",
    "35199": "狼人",
    "35200": "百眼巨人",
    "35201": "灰鼠",
    "35202": "黑蜘蛛",
    "35203": "白蜘蛛",
    "35204": "紅蜘蛛",
    "35205": "海盜骷髏",
    "35206": "骷髏",
    "35207": "寶箱怪",
    "35208": "魔劍",
    "35209": "骷髏狼",
    "35210": "海盜骷髏",
    "35211": "蝙蝠",
    "35212": "灰鼠",
    "35213": "沙華魚人遊俠",
    "35214": "寶箱怪",
    "35215": "沙華魚人士兵",
    "35216": "豺狼人",
    "35217": "豺狼人",
    "35218": "黑梨鼠",
    "35219": "海盜紅骷髏",
    "35220": "黑蜘蛛",
    "35221": "小百眼巨人",
    "35222": "海盜紅骷髏",
    "35223": "海盜紅骷髏船長",
    "35224": "魔劍",
    "35225": "灰鼠",
    "35226": "骷髏",
    "35227": "棺材寶箱怪",
    "35228": "食屍鬼",
    "35229": "偽裝怪",
    "35230": "食屍鬼",
    "35231": "吸血蝙蝠",
    "35232": "屍妖",
    "35233": "紅色鬼魂",
    "35234": "藍色鬼魂",
    "35235": "虛無騎士",
    "35236": "寶箱怪",
    "35237": "棺材寶箱怪",
    "35238": "偽裝怪鬼魂",
    "35239": "吸血蝙蝠",
    "35240": "食屍鬼",
    "35241": "食屍鬼",
    "35242": "藍色鬼魂",
    "35243": "紅色鬼魂",
    "35244": "屍妖",
    "35245": "虛無騎士",
    "35246": "巨大飛蛾",
    "35247": "迅速的 吸血蝙蝠",
    "35248": "毀壞的 棺材寶箱怪",
    "35249": "憤怒的 食屍鬼",
    "35250": "鬼魂之王",
    "35251": "憤怒的 食屍鬼",
    "35252": "固執的 屍妖",
    "35253": "締下契約的 虛無騎士",
    "35254": "紅色鬼魂之王",
    "35255": "藍色鬼魂之王",
    "35256": "巨大女王飛蛾",
    "35257": "冠軍偽裝怪鬼魂",
    "35258": "鬼怪",
    "35259": "藍色鬼怪",
    "35260": "紅色鬼怪",
    "35261": "黑蜘蛛",
    "35262": "哥布林",
    "35263": "灰鼠",
    "35264": "寶箱怪",
    "35265": "哥布林弓箭手",
    "35266": "劇毒哥布林",
    "35267": "紅蜘蛛",
    "35268": "蝙蝠",
    "35269": "鐮刀劇毒蜘蛛",
    "35270": "棕蛇",
    "35271": "青蛇",
    "35272": "鼠人",
    "35273": "白蛇",
    "35274": "緋紅鐮刀劇毒蜘蛛",
    "35275": "藍鼠人",
    "35276": "黑蛇",
    "35277": "巨大寶箱怪",
    "35278": "釘刺劇毒蜘蛛",
    "35279": "紅鼠",
    "35280": "綠蛇",
    "35281": "暗黑鼠人",
    "35282": "紅色鐮刀劇毒蜘蛛",
    "35283": "紅色釘刺劇毒蜘蛛",
    "35284": "熊地精",
    "35285": "小田鼠",
    "35286": "溫馴的 蝙蝠",
    "35287": "小白蜘蛛",
    "35288": "鄉村老鼠",
    "35289": "古老的寶箱怪",
    "35290": "蝙蝠",
    "35291": "白蜘蛛",
    "35292": "綻藍蜘蛛",
    "35293": "巨大蝙蝠",
    "35294": "藍狼",
    "35295": "巨大蜘蛛",
    "35296": "緋紅蜘蛛",
    "35297": "藍惡狼",
    "35298": "巨大白蜘蛛",
    "35299": "藍灰熊",
    "35300": "小精靈",
    "35301": "緋紅惡狼",
    "35302": "灰狼人",
    "35303": "紅蜘蛛黃蜂",
    "35304": "黑狼蛛",
    "35305": "蜘蛛鬥士",
    "35306": "蜘蛛弓箭手",
    "35307": "無眼惡狼",
    "35308": "蜘蛛士兵",
    "35309": "幼蟲",
    "35310": "無眼惡狼",
    "35311": "格蘭帝爾",
    "35312": "蜘蛛絲木乃伊",
    "35313": "蜘蛛遊俠",
    "35314": "蜘蛛戰士",
    "35315": "格蘭帝爾",
    "35316": "幼蟲",
    "35317": "灰鼠",
    "35318": "黑蜘蛛",
    "35319": "白蜘蛛",
    "35320": "紅蜘蛛",
    "35321": "海盜骷髏",
    "35322": "骷髏",
    "35323": "寶箱怪",
    "35324": "魔劍",
    "35325": "骷髏狼",
    "35326": "海盜骷髏",
    "35327": "蝙蝠",
    "35328": "沙華魚人遊俠",
    "35329": "沙華魚人士兵",
    "35330": "豺狼人",
    "35331": "豺狼人",
    "35332": "黑梨鼠",
    "35333": "海盜紅骷髏",
    "35334": "小百眼巨人",
    "35335": "海盜紅骷髏",
    "35336": "海盜紅骷髏船長",
    "35337": "魔劍",
    "35338": "黃金地靈",
    "35339": "劇毒地靈",
    "35340": "紅地靈弓箭手",
    "35341": "小巨魔",
    "35342": "巨大蜘蛛",
    "35343": "巨大紅蜘蛛",
    "35344": "巨大黑蜘蛛",
    "35345": "萊肯",
    "35346": "巨大黑蜘蛛",
    "35347": "巨大紅蜘蛛",
    "35348": "巨大白蜘蛛",
    "35349": "奧拉克妮",
    "35350": "巨大黃金蜘蛛",
    "35351": "巨大黃金蜘蛛",
    "35352": "巨魔像",
    "35353": "巨魔像",
    "35354": "巨魔像",
    "35355": "巨魔像",
    "35356": "巨魔像",
    "35357": "巨魔像",
    "35358": "巨魔像",
    "35359": "巨魔像",
    "35360": "巨魔像",
    "35361": "巨魔像",
    "35362": "巨魔像",
    "35363": "地獄犬",
    "35364": "巨大骷髏地獄犬",
    "35365": "金屬骷髏吟遊詩人",
    "35366": "黑魅魔",
    "35367": "黃金哥布林",
    "35368": "紅魅魔",
    "35369": "萊肯",
    "35370": "萊肯",
    "35371": "紅魅魔",
    "35372": "黑魅魔",
    "35373": "白魅魔",
    "35374": "黃魅魔",
    "35375": "粉紅魅魔",
    "35376": "黑魅魔",
    "35377": "黃魅魔",
    "35378": "紅魅魔",
    "35379": "黃魅魔",
    "35380": "紅魅魔",
    "35381": "黃魅魔",
    "35382": "黑魅魔",
    "35383": "食人魔戰士",
    "35384": "食人魔戰士",
    "35385": "食人魔戰士",
    "35386": "食人魔戰士",
    "35387": "食人魔戰士",
    "35388": "狼人",
    "35389": "藍色搗蛋鬼之王",
    "35390": "粉紅搗蛋鬼之王",
    "35391": "藍色搗蛋鬼之王",
    "35392": "粉紅搗蛋鬼之王",
    "35393": "綠色搗蛋鬼之王",
    "35394": "藍色搗蛋鬼之王",
    "35395": "粉紅搗蛋鬼之王",
    "35396": "綠色搗蛋鬼之王",
    "35397": "白色搗蛋鬼之王",
    "35398": "黑色搗蛋鬼之王",
    "35399": "巨大無頭怪",
    "35400": "小巨魔像",
    "35401": "小巨魔像",
    "35402": "百眼巨人",
    "35403": "百眼巨人",
    "35404": "百眼巨人",
    "35405": "巨大妖魔",
    "35406": "鎧甲熊",
    "35407": "獨眼巨人",
    "35408": "貓妖精騎士",
    "35409": "貓妖精騎士",
    "35410": "貓妖精騎士",
    "35411": "貓妖精騎士",
    "35412": "獨眼巨人",
    "35413": "半巫妖",
    "35414": "報喪女妖",
    "35415": "大師巫妖",
    "35416": "巨魔像",
    "35417": "巨魔像",
    "35418": "巨魔像",
    "35419": "巨魔像",
    "35420": "巨魔像",
    "35421": "巨大蜘蛛",
    "35422": "巨大紅蜘蛛",
    "35423": "萊肯",
    "35424": "奧拉克妮",
    "35425": "獨眼巨人",
    "35426": "貓妖精騎士",
    "35427": "貓妖精騎士",
    "35428": "貓妖精騎士",
    "35429": "貓妖精騎士",
    "35430": "獨眼巨人",
    "35431": "紅蜘蛛",
    "35432": "綻藍蜘蛛",
    "35433": "緋紅蜘蛛",
    "35434": "戈耳戈",
    "35435": "緋紅蜘蛛",
    "35436": "蜘蛛戰士",
    "35437": "金屬骷髏",
    "35438": "金屬骷髏",
    "35439": "金屬骷髏",
    "35440": "金屬骷髏",
    "35441": "暗黑鼠人",
    "35442": "巨大雷電之魂",
    "35443": "巨大雷電之魂",
    "35444": "骷髏吟遊詩人",
    "35445": "哥布林弓箭手",
    "35446": "骷髏妖魔",
    "35447": "骷髏劇毒蜘蛛",
    "35448": "巨大雷電之魂",
    "35449": "巨大火焰之魂",
    "35450": "魔劍",
    "35451": "綠色搗蛋鬼",
    "35452": "狼人",
    "35453": "魔劍",
    "35454": "骷髏船長",
    "35455": "黑梨鼠",
    "35456": "地獄貓",
    "35457": "藍色鬼怪",
    "35458": "紅色鬼怪",
    "35459": "金屬骷髏",
    "35460": "金屬骷髏",
    "35461": "巨大雷電之魂",
    "35462": "紅蜘蛛",
    "35463": "綻藍蜘蛛",
    "35464": "戈耳戈",
    "35465": "魔劍",
    "35466": "骷髏船長",
    "35467": "寶箱怪",
    "35468": "黑蜘蛛",
    "35469": "紅蜘蛛",
    "35470": "青蛇",
    "35471": "棕蛇",
    "35472": "白蛇",
    "35473": "冰雪之魂",
    "35474": "雷電之魂",
    "35475": "火焰之魂",
    "35476": "狼人",
    "35477": "戈耳戈",
    "35478": "寶箱怪",
    "35479": "豺狼",
    "35480": "青蛇",
    "35481": "棕蛇",
    "35482": "白蛇",
    "35483": "冰雪之魂",
    "35484": "雷電之魂",
    "35485": "火焰之魂",
    "35486": "綠色搗蛋鬼",
    "35487": "狼人",
    "35488": "紅灰熊",
    "35489": "紅熊",
    "35490": "戈耳戈",
    "35491": "地獄犬",
    "35492": "巨大無頭怪",
    "35493": "巨大無頭怪",
    "35494": "孔雀蜘蛛",
    "35495": "突變的螃蟹",
    "35500": "小田鼠",
    "35501": "溫馴的 蝙蝠",
    "35502": "小白蜘蛛",
    "35503": "鄉村老鼠",
    "35504": "古老的 寶箱怪",
    "35505": "蝙蝠",
    "35506": "白蜘蛛",
    "35507": "巨大蜘蛛",
    "35508": "紅蜘蛛",
    "35509": "黑蜘蛛",
    "35510": "哥布林",
    "35511": "灰鼠",
    "35512": "寶箱怪",
    "35513": "哥布林弓箭手",
    "35514": "紅蜘蛛",
    "35515": "蝙蝠",
    "35516": "劇毒哥布林",
    "35517": "巨魔像",
    "35518": "金屬骷髏",
    "35519": "蝙蝠",
    "35520": "灰鼠",
    "35521": "寶箱怪",
    "35522": "骷髏",
    "35523": "骷髏狼",
    "35524": "紅骷髏",
    "35525": "金屬骷髏",
    "35526": "黑魅魔",
    "35527": "黃金哥布林",
    "35528": "黑蜘蛛",
    "35529": "地靈",
    "35530": "灰鼠",
    "35531": "寶箱怪",
    "35532": "地靈弓箭手",
    "35533": "袋鼠",
    "35534": "紅蜘蛛",
    "35535": "蝙蝠",
    "35536": "劇毒地靈",
    "35537": "地獄犬",
    "35538": "黑蜘蛛",
    "35539": "豺狼",
    "35540": "灰鼠",
    "35541": "青蛇",
    "35542": "棕蛇",
    "35543": "狼人",
    "35544": "白蛇",
    "35545": "戈耳戈",
    "35546": "紅蜘蛛",
    "35547": "小精靈",
    "35548": "寶箱怪",
    "35549": "紅熊",
    "35550": "綠色搗蛋鬼",
    "35551": "幼小紅灰熊",
    "35552": "紅灰熊",
    "35553": "小巨魔像",
    "35554": "魔劍",
    "35555": "黑蜘蛛",
    "35556": "哥布林",
    "35557": "妖魔",
    "35558": "哥布林弓箭手",
    "35559": "寶箱怪",
    "35560": "優等生 妖魔",
    "35561": "巨大寶箱怪",
    "35562": "劇毒哥布林",
    "35563": "紅蜘蛛",
    "35564": "吸血蝙蝠",
    "35565": "食人魔戰士",
    "35566": "食人魔戰士",
    "35567": "食人魔戰士",
    "35568": "食人魔戰士",
    "35569": "食人魔戰士",
    "35570": "黑蜘蛛",
    "35571": "豺狼",
    "35572": "灰鼠",
    "35573": "青蛇",
    "35574": "棕蛇",
    "35575": "冰雪之魂",
    "35576": "雷電之魂",
    "35577": "火焰之魂",
    "35578": "白蛇",
    "35579": "戈耳戈",
    "35580": "紅蜘蛛",
    "35581": "寶箱怪",
    "35582": "隱形妖魔",
    "35583": "狼人",
    "35584": "綠色搗蛋鬼",
    "35585": "紅灰熊",
    "35586": "紅熊",
    "35587": "巨大無頭怪",
    "35588": "巨大火焰之魂",
    "35589": "灰鼠",
    "35590": "黑蜘蛛",
    "35591": "白蜘蛛",
    "35592": "紅蜘蛛",
    "35593": "海盜骷髏",
    "35594": "骷髏",
    "35595": "寶箱怪",
    "35596": "魔劍",
    "35597": "骷髏狼",
    "35598": "海盜骷髏",
    "35599": "獨眼巨人",
    "35600": "棺材寶箱怪",
    "35601": "食屍鬼",
    "35602": "偽裝怪",
    "35603": "食屍鬼",
    "35604": "吸血蝙蝠",
    "35605": "人類",
    "35606": "紅色鬼魂",
    "35607": "藍色鬼魂",
    "35608": "虛無騎士",
    "35609": "寶箱怪",
    "35610": "半巫妖",
    "35611": "黑梨鼠",
    "35700": "黑蜘蛛",
    "35701": "劇毒地靈",
    "35702": "灰鼠",
    "35703": "黃金地靈",
    "35704": "冰雪之魂",
    "35705": "紅地靈",
    "35706": "骷髏地獄犬",
    "35707": "紅地靈弓箭手",
    "35708": "小巨魔",
    "35709": "火焰之魂",
    "35710": "灰鼠",
    "35711": "黃金哥布林",
    "35712": "寶箱怪",
    "35713": "骷髏狼",
    "35714": "骷髏",
    "35715": "骷髏自爆兵",
    "35716": "骷髏自爆兵",
    "35717": "紅骷髏",
    "35718": "骷髏劇毒蜘蛛",
    "35719": "金屬骷髏",
    "35720": "妖魔",
    "35721": "骸骨蝶",
    "35722": "棕色搗蛋鬼",
    "35723": "哥布林獵人弓箭手",
    "35724": "哥布林獵人",
    "35725": "灰色搗蛋鬼",
    "35726": "尖刺蚯蚓",
    "35727": "迷失沙華魚人",
    "35728": "寶箱怪之王",
    "35729": "綠色搗蛋鬼",
    "35730": "巨大地蟲",
    "35731": "巨大骷髏",
    "35732": "金屬骷髏吟遊詩人",
    "35733": "哥布林弓箭手",
    "35734": "黑魅魔",
    "35735": "骷髏妖魔",
    "35736": "骷髏劇毒蜘蛛",
    "35737": "藍色搗蛋鬼之王",
    "35738": "粉紅搗蛋鬼之王",
    "35739": "綠色搗蛋鬼之王",
    "35740": "狼人",
    "35741": "生疏的飛龍傭兵",
    "35742": "弱小的飛龍傭兵",
    "35743": "飛龍傭兵",
    "35744": "未成熟的飛龍傭兵",
    "35745": "彆腳的飛龍傭兵",
    "35746": "正職飛龍傭兵",
    "35747": "見習飛龍傭兵",
    "35748": "矮小的飛龍傭兵",
    "35749": "強壯的飛龍傭兵",
    "35750": "火焰飛龍",
    "35751": "火焰飛龍",
    "35752": "火焰飛龍",
    "35753": "愚蠢的紅龍",
    "35754": "生疏的商團掠奪者人類",
    "35755": "見習商團掠奪者精靈",
    "35756": "見習商團掠奪者精靈",
    "35757": "見習商團掠奪者人類",
    "35758": "見習商團掠奪者巨人",
    "35759": "見習商團掠奪團頭目",
    "35760": "見習商團掠奪團頭目",
    "35761": "見習商團掠奪團頭目",
    "35762": "2年資歷的商團掠奪者精靈",
    "35763": "2年資歷的商團掠奪者精靈",
    "35764": "2年資歷的商團掠奪者人類",
    "35765": "2年資歷的商團掠奪者巨人",
    "35766": "2年資歷的商團掠奪團頭目",
    "35767": "2年資歷的商團掠奪團頭目",
    "35768": "2年資歷的商團掠奪團頭目",
    "35769": "熟能生巧的商團掠奪者精靈",
    "35770": "熟能生巧的商團掠奪者精靈",
    "35771": "熟能生巧的商團掠奪者人類",
    "35772": "熟能生巧的商團掠奪者巨人",
    "35773": "熟能生巧的商團掠奪團頭目",
    "35774": "熟能生巧的商團掠奪團頭目",
    "35775": "熟能生巧的商團掠奪團頭目",
    "35776": "老練的商團掠奪者精靈",
    "35777": "老練的商團掠奪者精靈",
    "35778": "老練的商團掠奪者人類",
    "35779": "老練的商團掠奪者巨人",
    "35780": "老練的商團掠奪團頭目",
    "35781": "老練的商團掠奪團頭目",
    "35782": "老練的商團掠奪團頭目",
    "35783": "一流商團掠奪者精靈",
    "35784": "一流商團掠奪者精靈",
    "35785": "一流商團掠奪者人類",
    "35786": "一流商團掠奪者巨人",
    "35787": "一流商團掠奪團頭目",
    "35788": "一流商團掠奪團頭目",
    "35789": "一流商團掠奪團頭目",
    "35790": "3年資歷的生疏的飛龍傭兵",
    "35791": "3年資歷的弱小的飛龍傭兵",
    "35792": "3年資歷的飛龍傭兵",
    "35793": "3年資歷的未成熟的飛龍傭兵",
    "35794": "3年資歷的彆腳的飛龍傭兵",
    "35795": "3年資歷的正職飛龍傭兵",
    "35796": "3年資歷的見習飛龍傭兵",
    "35797": "3年資歷的矮小的飛龍傭兵",
    "35798": "3年資歷的強壯的飛龍傭兵",
    "35799": "5年資歷的生疏的飛龍傭兵",
    "35800": "5年資歷的弱小的飛龍傭兵",
    "35801": "5年資歷的飛龍傭兵",
    "35802": "5年資歷的未成熟的飛龍傭兵",
    "35803": "5年資歷的彆腳的飛龍傭兵",
    "35804": "5年資歷的正職飛龍傭兵",
    "35805": "5年資歷的見習飛龍傭兵",
    "35806": "5年資歷的矮小的飛龍傭兵",
    "35807": "5年資歷的強壯的飛龍傭兵",
    "40001": "羊",
    "40002": "黑羊潘",
    "40003": "棉花糖羊",
    "40004": "棉花糖羊",
    "40005": "棉花糖羊",
    "40006": "羊",
    "40007": "棉花糖羊",
    "40008": "棉花糖羊",
    "40009": "棉花糖羊",
    "40010": "羊",
    "40011": "塔爾汀山羊",
    "40012": "塔拉羊",
    "40013": "紙羊",
    "40014": "紙羊",
    "40015": "彩虹紅羊",
    "40016": "彩虹橙羊",
    "40017": "彩虹黃羊",
    "40018": "彩虹綠羊",
    "40019": "彩虹藍羊",
    "40020": "彩虹靛羊",
    "40021": "彩虹紫羊",
    "40022": "彩虹白羊",
    "40023": "彩虹黑羊",
    "40024": "羊",
    "40101": "豬",
    "40102": "野豬",
    "40103": "山豬",
    "40104": "大耳食蟻獸",
    "40105": "白耳灌木野豬",
    "40106": "小耳食蟻獸",
    "40107": "黑色食蟻獸",
    "40108": "長角食蟻獸",
    "40109": "鬃毛食蟻獸",
    "40110": "鬃毛灌木野豬",
    "40111": "大耳灌木野豬",
    "40112": "黑耳灌木野豬",
    "40113": "白色灌木野豬",
    "40114": "幼小大耳食蟻獸",
    "40115": "幼小黑色食蟻獸",
    "40116": "幼小鬃毛食蟻獸",
    "40117": "豬",
    "40118": "高原野豬",
    "40119": "阿蘭特野豬",
    "40120": "阿蘭特野豬",
    "40121": "阿蘭特野豬",
    "40122": "小耳食蟻獸",
    "40123": "巨大山豬",
    "40124": "荒野野豬",
    "40125": "巨大荒野野豬",
    "40126": "荒野野豬",
    "40201": "河馬",
    "40202": "河馬",
    "40203": "河馬",
    "40301": "水豚",
    "40401": "犄角野豬",
    "40402": "犄角野豬",
    "40501": "火山犄角野豬",
    "40502": "火山犄角野豬",
    "40507": "火山犄角野豬",
    "40508": "突變的野豬",
    "50001": "棕狐狸",
    "50002": "紅狐狸",
    "50003": "灰狐狸",
    "50004": "白狐狸",
    "50005": "幼小紅狐狸",
    "50006": "幼小灰狐狸",
    "50007": "幼小棕狐狸",
    "50008": "棕狐狸",
    "50009": "棕腳沙漠狐狸",
    "50010": "白色沙漠狐狸",
    "50011": "黑腳沙漠狐狸",
    "50012": "灰腳沙漠狐狸",
    "50013": "紅腳沙漠狐狸",
    "50014": "藍腳沙漠狐狸",
    "50015": "幼小棕腳沙漠狐狸",
    "50016": "白色沙漠狐狸",
    "50101": "浣熊",
    "50102": "幼小浣熊",
    "50103": "幼小灰浣熊",
    "50104": "黑浣熊",
    "50105": "幼小黑浣熊",
    "50106": "幼小浣熊",
    "50107": "黑浣熊",
    "50108": "迷路的巨大浣熊",
    "50201": "藍尾貓鼬",
    "50202": "黑尾貓鼬",
    "50203": "棕尾貓鼬",
    "50204": "灰尾貓鼬",
    "50205": "白尾貓鼬",
    "50206": "金尾貓鼬",
    "50207": "幼小棕尾貓鼬",
    "50208": "幼小灰尾貓鼬",
    "50209": "幼小白尾貓鼬",
    "50210": "金尾貓鼬",
    "50301": "幼小棕色菲西斯狐狸",
    "50302": "棕色菲西斯狐狸",
    "50303": "幼小紅色菲西斯狐狸",
    "50304": "紅色菲西斯狐狸",
    "50305": "幼小灰色菲西斯狐狸",
    "50306": "灰色菲西斯狐狸",
    "50307": "幼小白色菲西斯狐狸",
    "50308": "白色菲西斯狐狸",
    "50309": "幼小黑色菲西斯狐狸",
    "50310": "黑色菲西斯狐狸",
    "50311": "苔原狐狸",
    "60002": "公雞",
    "60003": "母雞",
    "60004": "小雞",
    "60005": "母雞",
    "60101": "黃金奇異鳥",
    "60102": "綠色奇異鳥",
    "60103": "白色奇異鳥",
    "60104": "黑色奇異鳥",
    "60105": "黃金奇異鳥",
    "60106": "綠色奇異鳥",
    "60201": "黑色鴕鳥",
    "60202": "棕色鴕鳥",
    "60203": "紅色鴕鳥",
    "60204": "灰色鴕鳥",
    "60205": "野生鴕鳥",
    "60206": "野生鴕鳥",
    "60207": "野生鴕鳥",
    "60208": "野生鴕鳥",
    "60301": "火雞",
    "60302": "宴會用火雞",
    "60401": "黃色雪原鴕鳥",
    "60402": "黑色雪原鴕鳥",
    "60403": "黃色雪原鴕鳥",
    "60404": "黑色雪原鴕鳥",
    "60405": "虛弱的 綠色奇異鳥",
    "60406": "火雞迷你寵物",
    "70001": "棕熊",
    "70002": "紅熊",
    "70003": "黑熊",
    "70004": "棕灰熊",
    "70005": "紅灰熊",
    "70006": "黑灰熊",
    "70007": "幼小棕灰熊",
    "70008": "幼小紅灰熊",
    "70009": "幼小黑灰熊",
    "70010": "巨熊",
    "70011": "藍灰熊",
    "70012": "緋紅灰熊",
    "70013": "白灰熊",
    "70014": "白熊",
    "70015": "藍灰熊",
    "70016": "巨熊",
    "70017": "白灰熊",
    "70018": "鎧甲熊",
    "70019": "巨大棕熊",
    "70020": "鎧甲熊",
    "70101": "棕熊",
    "70102": "棕熊",
    "70201": "白色半月熊",
    "70202": "黑色半月熊",
    "70203": "幼小白色半月熊",
    "70204": "幼小黑色半月熊",
    "70301": "棕色沙漠熊",
    "70302": "古銅色沙漠熊",
    "70303": "黑色沙漠熊",
    "70304": "白色沙漠熊",
    "70401": "幼小棕色雪原熊",
    "70402": "棕色雪原熊",
    "70403": "幼小紅色雪原熊",
    "70404": "紅色雪原熊",
    "70405": "幼小黑色雪原熊",
    "70406": "黑色雪原熊",
    "70407": "幼小白色雪原熊",
    "70408": "白色雪原熊",
    "70501": "冰晶灰熊",
    "70601": "格蘭帝爾",
    "70602": "格蘭帝爾",
    "70603": "格蘭帝爾",
    "70604": "格蘭帝爾",
    "70701": "叢林熊",
    "70801": "緋紅熊",
    "70802": "暗影黑熊",
    "70803": "突變的熊",
    "80001": "蝙蝠",
    "80002": "溫馴的 蝙蝠",
    "80003": "吸血蝙蝠",
    "80004": "巨大蝙蝠",
    "80005": "白色洞穴蝙蝠",
    "80006": "黃色洞穴蝙蝠",
    "80007": "棕色洞穴蝙蝠",
    "80008": "蝙蝠",
    "80009": "溫馴的 蝙蝠",
    "80010": "巨大蝙蝠",
    "80011": "迅速的 吸血蝙蝠",
    "80012": "蝙蝠",
    "80013": "黑色洞穴蝙蝠",
    "80014": "巨大黑色洞穴蝙蝠",
    "80015": "巨大吸血蝙蝠",
    "80101": "小精靈",
    "80102": "小精靈",
    "80103": "小精靈",
    "80104": "小精靈",
    "80201": "雷電之魂",
    "80202": "火焰之魂",
    "80203": "冰雪之魂",
    "80204": "巨大雷電之魂",
    "80205": "巨大火焰之魂",
    "80206": "巨大冰雪之魂",
    "80207": "巨大雷電之魂",
    "80208": "巨大雷電之魂",
    "80209": "巨大雷電之魂",
    "80210": "雷電之魂",
    "80211": "火焰之魂",
    "80212": "冰雪之魂",
    "80213": "士兵",
    "80214": "主教",
    "80215": "城堡",
    "80216": "雷電之魂",
    "80217": "火焰之魂",
    "80218": "冰雪之魂",
    "80219": "巨大冰雪之魂",
    "80220": "巨大冰雪之魂",
    "80301": "偽裝怪",
    "80302": "鬼魂偽裝怪",
    "80303": "虛弱的 偽裝怪",
    "80304": "模糊的 偽裝怪",
    "80305": "冠軍偽裝怪",
    "80306": "冠軍偽裝怪鬼魂",
    "80307": "偽裝怪",
    "80308": "偽裝怪鬼魂",
    "80309": "偽裝怪",
    "80310": "活動 偽裝怪",
    "80401": "骸骨蝶",
    "80402": "冰頭怪",
    "80403": "骸骨蝶",
    "80404": "綠寶石冰頭怪",
    "80501": "巨大飛蛾",
    "80502": "巨大飛蛾",
    "80503": "巨大女王飛蛾",
    "80601": "紅色面具幻影",
    "80602": "黑色面具幻影",
    "80603": "白色面具幻影",
    "80701": "狼之魂",
    "80702": "熊之魂",
    "80703": "馬之魂",
    "80704": "狼之魂",
    "80801": "石頭面具",
    "80802": "小石頭面具",
    "80803": "寶藏石製面具",
    "80901": "黃寶石甲蟲",
    "80902": "綠寶石甲蟲",
    "80903": "紫水晶甲蟲",
    "80904": "小綠寶石甲蟲",
    "81001": "黃蜘蛛黃蜂",
    "81002": "紅蜘蛛黃蜂",
    "81003": "白蜘蛛黃蜂",
    "81004": "紅蜘蛛黃蜂",
    "81005": "白蜘蛛黃蜂",
    "81006": "黃蜘蛛黃蜂",
    "81101": "紙蝴蝶",
    "81201": "巨大雄性黃蜂",
    "81202": "巨大黃蜂士兵",
    "81203": "巨大雌性黃蜂",
    "81204": "巨大黃蜂女王",
    "81205": "巨大雄性黃蜂",
    "81206": "巨大黃蜂士兵",
    "81207": "巨大雌性黃蜂",
    "81208": "巨大黃蜂女王",
    "81209": "極地大胡蜂",
    "81210": "極地大胡蜂",
    "90001": "寶箱怪",
    "90002": "古老的 寶箱怪",
    "90003": "巨大寶箱怪",
    "90004": "寶箱怪之王",
    "90005": "寶箱怪",
    "90006": "棺材寶箱怪",
    "90007": "寶箱怪",
    "90008": "石頭寶箱怪",
    "90009": "沙漠寶箱怪",
    "90010": "古老的 沙漠寶箱怪",
    "90011": "冰雪寶箱怪",
    "90012": "古老的 冰雪寶箱怪",
    "90013": "古老的 寶箱怪",
    "90014": "古老的 寶箱怪",
    "90015": "寶箱怪",
    "90016": "巨大寶箱怪",
    "90017": "寶箱怪",
    "90018": "防護壁",
    "90019": "毀壞的 棺材寶箱怪",
    "90020": "被遺忘的寶箱怪",
    "90029": "棺材寶箱怪",
    "100001": "食人魔",
    "100002": "巨大食人魔",
    "100003": "食人魔戰士",
    "100004": "食人魔戰士",
    "100005": "食人魔戰士",
    "100006": "食人魔戰士",
    "100007": "食人魔戰士",
    "100008": "食人魔戰士",
    "100009": "食人魔戰士",
    "100010": "食人魔屠夫",
    "100011": "食人魔戰士",
    "100012": "食人魔戰士",
    "100013": "食人魔戰士",
    "100014": "食人魔戰士",
    "100015": "食人魔戰士",
    "100016": "食人魔戰士",
    "100017": "食人魔戰士",
    "100018": "食人魔戰士",
    "100019": "食人魔屠夫",
    "100020": "骷髏食人魔",
    "100021": "鎧甲骷髏食人魔",
    "100022": "全鎧甲骷髏食人魔",
    "100023": "巨大食人魔",
    "100024": "活動 食人魔戰士",
    "100025": "活動 食人魔屠夫",
    "100026": "活動 巨大食人魔",
    "100027": "鎧甲骷髏食人魔",
    "100028": "全鎧甲骷髏食人魔",
    "100029": "食人魔屠夫",
    "100080": "로떼 유령",
    "100081": "샤론 유령",
    "100082": "두두 유령",
    "100083": "제레미 유령",
    "100084": "노베르 유령",
    "100090": "爺爺幽靈",
    "100091": "爸爸幽靈",
    "100092": "媽媽幽靈",
    "100093": "幽靈兒子",
    "100094": "幽靈女兒",
    "100095": "爸爸幽靈",
    "100096": "媽媽幽靈",
    "100097": "幽靈兒子",
    "100098": "幽靈女兒",
    "100101": "巨大無頭怪",
    "100201": "獨眼巨人",
    "100202": "獨眼巨人",
    "100203": "獨眼巨人",
    "100204": "小獨眼巨人",
    "100205": "獨眼巨人",
    "100206": "獨眼巨人",
    "100207": "獨眼巨人",
    "100208": "活動 獨眼巨人",
    "100209": "媽媽獨眼巨人",
    "100210": "幼小獨眼巨人",
    "100211": "幼小獨眼巨人",
    "100212": "爸爸獨眼巨人",
    "100301": "百眼巨人",
    "100302": "百眼巨人",
    "100303": "百眼巨人",
    "100304": "百眼巨人",
    "100305": "百眼巨人",
    "100306": "百眼巨人",
    "100307": "小百眼巨人",
    "100308": "小百眼巨人",
    "100309": "活動 百眼巨人",
    "100310": "活動 百眼巨人",
    "100311": "活動 百眼巨人",
    "100312": "活動 百眼巨人",
    "100401": "伊弗烈特",
    "100402": "活動 伊弗烈特",
    "100501": "<mini>NPC</mini> 巨人守衛",
    "100502": "<mini>NPC</mini> 巨人守衛",
    "100503": "<mini>NPC</mini> 巨人守衛",
    "100504": "<mini>NPC</mini> 巨人守衛",
    "100505": "巨人守衛",
    "100506": "巨人守衛",
    "100507": "巨人守衛",
    "100508": "<mini>NPC</mini> 巨人守衛",
    "100509": "<mini>NPC</mini> 巨人守衛",
    "100510": "<mini>NPC</mini> 巨人守衛",
    "100511": "<mini>NPC</mini> 巨人守衛",
    "100601": "雪怪",
    "100602": "雪怪",
    "106101": "冰雪妖魔",
    "106111": "冰雪妖魔",
    "106121": "冰雪妖魔",
    "106201": "鬼怪",
    "106202": "藍色鬼怪",
    "106203": "紅色鬼怪",
    "106204": "活動 鬼怪",
    "106205": "活動 藍色鬼怪",
    "106206": "活動 紅色鬼怪",
    "106301": "大師巫妖",
    "110001": "黃牛",
    "110002": "乳牛",
    "110003": "乳牛",
    "110004": "羊",
    "110005": "公雞",
    "110006": "母雞",
    "110007": "小雞",
    "110008": "克萊克巨獸",
    "110009": "克萊克巨獸",
    "110010": "克萊克巨獸",
    "110011": "克萊克巨獸",
    "110012": "克萊克巨獸",
    "110013": "迷你乳牛",
    "110014": "克萊克巨獸",
    "110101": "戈耳戈",
    "110102": "戈耳戈",
    "110103": "戈耳戈",
    "110104": "戈耳戈",
    "110201": "短角牛羚",
    "110202": "長角牛羚",
    "110203": "幼小短角牛羚",
    "110204": "幼小長角牛羚",
    "110205": "巨大短角牛羚",
    "110206": "巨大長角牛羚",
    "110207": "巨大短角牛羚",
    "110208": "巨大長角牛羚",
    "110209": "活動 巨大長角牛羚",
    "110301": "石頭野牛",
    "110302": "石頭野牛-牙齒發光",
    "110303": "石頭野牛-尾巴發光",
    "110304": "石頭野牛-蹄發光",
    "110305": "石頭野牛-角發光",
    "110306": "發光石頭野牛",
    "110307": "石頭野牛",
    "110308": "石頭野牛",
    "110309": "石頭野牛",
    "110310": "發光石頭野牛",
    "110311": "石頭野牛",
    "110401": "幼小沙漠犀牛",
    "110402": "沙漠犀牛",
    "110501": "幼小黑色水牛",
    "110502": "黑色水牛",
    "110503": "幼小白色水牛",
    "110504": "白色水牛",
    "110601": "幼小棕色馴鹿",
    "110602": "棕色馴鹿",
    "110603": "幼小苔原馴鹿",
    "110604": "苔原馴鹿",
    "110701": "幼小灰色馴鹿",
    "110702": "灰色馴鹿",
    "110703": "幼小紅角馴鹿",
    "110704": "紅角馴鹿",
    "110705": "幼小白色馴鹿",
    "110706": "白色馴鹿",
    "110801": "聖誕糜鹿",
    "110901": "冰晶野牛",
    "110902": "綠寶石野牛",
    "111001": "黑毛水牛",
    "111002": "黃毛水牛",
    "120001": "巨鼠",
    "120002": "棕鼠",
    "120003": "灰鼠",
    "120004": "鄉村老鼠",
    "120005": "黑鼠",
    "120006": "小田鼠",
    "120007": "巨大野鼠",
    "120008": "月兔鼠",
    "120009": "袋鼠",
    "120010": "黑梨鼠",
    "120011": "地鼠",
    "120012": "紅鼠",
    "120013": "雪鼠",
    "120014": "地鼠",
    "120015": "紅鼠",
    "120016": "鄉村老鼠",
    "120017": "小田鼠",
    "120018": "灰鼠",
    "120019": "紅鼠",
    "120020": "黑梨鼠",
    "120021": "下水道老鼠",
    "120022": "王城老鼠",
    "120023": "王城老鼠",
    "120024": "灰鼠",
    "120025": "棕鼠",
    "120026": "王城老鼠",
    "120027": "咬走信件的王城老鼠",
    "120028": "艾希諾老鼠",
    "120029": "巨大艾希諾老鼠",
    "120030": "艾希諾老鼠",
    "120031": "圓滾滾老鼠",
    "120032": "廣場老鼠",
    "120033": "圓滾滾老鼠",
    "120034": "圓滾滾老鼠",
    "120035": "溝鼠",
    "120036": "圓滾滾老鼠",
    "120037": "圓滾滾老鼠",
    "120038": "溝鼠",
    "120039": "紅老鼠",
    "120040": "巨大紅老鼠",
    "120041": "被黑暗氣息蠶食的老鼠",
    "120042": "吃了藍色魔法藥水的老鼠",
    "120043": "吃了紅色魔法藥水的老鼠",
    "120044": "吃了綠色魔法藥水的老鼠",
    "120101": "幼小緋紅豪豬",
    "120102": "緋紅豪豬",
    "120103": "幼小棕色豪豬",
    "120104": "棕色豪豬",
    "120105": "幼小黑色豪豬",
    "120106": "黑色豪豬",
    "120201": "幼小灰色犰狳",
    "120202": "灰色犰狳",
    "120203": "幼小白色犰狳",
    "120204": "白色犰狳",
    "120205": "幼小黑色犰狳",
    "120206": "黑色犰狳",
    "120207": "幼小灰色犰狳",
    "121001": "哥布林",
    "121002": "劇毒哥布林",
    "121003": "哥布林弓箭手",
    "121004": "黃金哥布林",
    "121005": "紅哥布林弓箭手",
    "121006": "紅哥布林",
    "121007": "哥布林獵人",
    "121008": "哥布林獵人弓箭手",
    "121009": "叢林哥布林戰士",
    "121010": "叢林哥布林弓箭手",
    "121011": "叢林哥布林咒術師",
    "121012": "叢林哥布林咒術師",
    "121013": "叢林哥布林咒術師",
    "121014": "叢林哥布林頭目",
    "121015": "叢林哥布林頭目",
    "122001": "棕蛇",
    "122002": "青蛇",
    "122003": "綠蛇",
    "122004": "巨大白蛇",
    "122005": "巨大黑蛇",
    "122006": "沙華魚人士兵",
    "122007": "沙華魚人鬥士",
    "122008": "沙華魚人遊俠",
    "122009": "沙華魚人戰士",
    "122010": "迷失沙華魚人",
    "122011": "淡水沙華魚人遊俠",
    "122012": "淡水沙華魚人鬥士",
    "122013": "洞穴沙華魚人魔法師",
    "122014": "洞穴沙華魚人戰士",
    "122015": "洞穴沙華魚人戰士",
    "122016": "小精靈",
    "122017": "小精靈",
    "123001": "鎧甲骷髏",
    "123002": "鎧甲骷髏",
    "123003": "紅骷髏",
    "123004": "紅骷髏",
    "123005": "金屬骷髏",
    "123006": "金屬骷髏",
    "123007": "骷髏自爆兵",
    "123008": "骷髏地獄看門犬",
    "123009": "黑色鎧甲骷髏",
    "123010": "巨蛇士兵",
    "123011": "巨蛇咒術師",
    "123012": "骸骨槍騎兵",
    "123013": "骸骨弓箭手",
    "123014": "骸骨戰士",
    "123015": "骷髏劇毒蜘蛛",
    "123016": "鎧甲骷髏食人魔",
    "123017": "全鎧甲骷髏食人魔",
    "123018": "全鎧甲骷髏食人魔",
    "123019": "全鎧甲骷髏食人魔",
    "124001": "火焰魅魔",
    "124002": "雷電魅魔",
    "124003": "寒冰魅魔",
    "124004": "劇毒魅魔",
    "124006": "遊魂",
    "124007": "鬼魂",
    "124008": "藍色鬼魂",
    "124009": "紅色鬼魂",
    "124010": "藍色鬼魂之王",
    "124011": "紅色鬼魂之王",
    "124012": "鬼魂之王",
    "124013": "骷髏幽靈",
    "124014": "綠色骷髏幽靈",
    "124015": "藍色骷髏幽靈",
    "124016": "紅色骷髏幽靈",
    "124017": "紅色骷髏幽靈",
    "124018": "偽裝怪",
    "124019": "鬼魂偽裝怪",
    "124020": "夢靨",
    "124021": "黑色牢獄鬼魂",
    "124022": "鬼魂之鎧",
    "125001": "達斯拉姆",
    "125002": "火焰史萊姆",
    "125003": "寒冰史萊姆",
    "125004": "雷電史萊姆",
    "125005": "幻象火蜥蜴",
    "125006": "幻象殭屍",
    "125007": "幻象殭屍",
    "125008": "格蘭帝爾",
    "125009": "格蘭帝爾",
    "125010": "黑月教團團員",
    "125011": "地獄貓",
    "125012": "蜘蛛戰士",
    "125013": "駭骨蝶",
    "125014": "黑月教團團員",
    "125015": "黑月教團團員",
    "125016": "黑月教團團員",
    "125017": "炸彈蝙蝠",
    "125018": "紅腳狼蛛",
    "126001": "霜角鹿",
    "126002": "斯奈塔",
    "126003": "斯奈塔",
    "126004": "斯奈塔",
    "126005": "夜靈",
    "126006": "被雪覆蓋的食人植物",
    "126007": "被雪覆蓋的食蟲植物",
    "126008": "被雪覆蓋的食蟲植物",
    "126009": "異質體遊魂",
    "126010": "霜紋靈貓",
    "126011": "冰脊野狼",
    "126012": "冰花之靈",
    "126013": "冰花之靈",
    "126014": "凱薩兔",
    "126015": "霜紋靈貓",
    "126016": "凱薩兔",
    "126017": "冰脊野狼",
    "130001": "巨魔像",
    "130002": "巨魔像",
    "130003": "小巨魔像",
    "130004": "小巨魔像",
    "130005": "巨魔像",
    "130006": "巨魔像",
    "130007": "巨魔像",
    "130008": "巨魔像",
    "130009": "巨魔像",
    "130010": "巨魔像",
    "130011": "巨魔像",
    "130012": "巨魔像",
    "130013": "巨魔像",
    "130014": "小巨魔像",
    "130015": "巨魔像",
    "130016": "巨魔像",
    "130017": "巨魔像",
    "130018": "巨魔像",
    "130019": "巨魔像",
    "130020": "巨魔像",
    "130021": "巨魔像",
    "130022": "巨魔像",
    "130023": "硫磺巨魔像",
    "130024": "硫磺巨魔像",
    "130025": "巨魔像",
    "130026": "岩石巨魔像",
    "130027": "森林巨魔像",
    "130028": "硫磺巨魔像",
    "130029": "白色巨魔像",
    "130030": "奎林巨魔像",
    "130031": "白色巨魔像",
    "130032": "巨魔像",
    "130033": "巨魔像",
    "130034": "岩石巨魔像",
    "130035": "森林巨魔像",
    "130036": "硫磺巨魔像",
    "130037": "白色巨魔像",
    "130038": "岩石巨魔像",
    "130039": "岩石巨魔像",
    "130040": "森林巨魔像",
    "130041": "硫磺巨魔像",
    "130042": "白色巨魔像",
    "130043": "巨大白色巨魔像",
    "130044": "巨大硫磺巨魔像",
    "130045": "岩石巨魔像",
    "130046": "巨魔像",
    "130047": "城牆巨魔像",
    "130048": "巨大城牆巨魔像",
    "130049": "小巨魔像",
    "130050": "城牆巨魔像",
    "130051": "水晶巨魔像",
    "130052": "紫水晶巨魔像",
    "130053": "水晶巨魔像",
    "130054": "紫水晶巨魔像",
    "130055": "水晶巨魔像",
    "130056": "紫水晶巨魔像",
    "130057": "水晶巨魔像",
    "130058": "紫水晶巨魔像",
    "130059": "巨魔像",
    "130060": "白色巨魔像",
    "130061": "硫磺巨魔像",
    "130062": "水晶巨魔像",
    "130063": "紫水晶巨魔像",
    "130064": "綠寶石巨魔像",
    "130065": "巨魔像",
    "130101": "魔法巨魔像",
    "130102": "黃寶石魔法巨魔像",
    "130103": "綠寶石魔法巨魔像",
    "130104": "紫水晶魔法巨魔像",
    "130105": "魔法巨魔像",
    "130106": "影子巨魔像",
    "130107": "影子巨魔像",
    "130108": "影子巨魔像",
    "130109": "影子巨魔像",
    "130110": "影子巨魔像",
    "140001": "棕蛇",
    "140002": "青蛇",
    "140003": "白蛇",
    "140004": "黑蛇",
    "140005": "綠蛇",
    "140006": "綠蛇",
    "140007": "巨大白蛇",
    "140008": "青蛇",
    "140009": "棕蛇",
    "140010": "白蛇",
    "140011": "黑蛇",
    "140012": "綠蛇",
    "140013": "青毒蛇",
    "140014": "白毒蛇",
    "140015": "黑毒蛇",
    "140016": "白毒蛇",
    "140017": "紅毒蛇",
    "140018": "幼小白毒蛇",
    "140019": "幼小紅毒蛇",
    "140101": "尖刺蚯蚓",
    "140201": "紅角眼鏡蛇",
    "140202": "藍角眼鏡蛇",
    "140203": "灰角眼鏡蛇",
    "140204": "綠角眼鏡蛇",
    "140301": "幼小洞穴千足蟲",
    "140302": "洞穴千足蟲",
    "140303": "幼小努比斯蜈蚣",
    "140304": "努比斯蜈蚣",
    "140305": "叢林蜈蚣",
    "140306": "巨大叢林蜈蚣",
    "140401": "幼小沙漠千足蟲",
    "140402": "沙漠千足蟲",
    "140501": "黑尾蟒蛇",
    "140502": "藍尾蟒蛇",
    "140503": "白色蟒蛇",
    "140504": "小藍尾蟒蛇",
    "140505": "黑尾蟒蛇",
    "140601": "幼蟲",
    "140602": "幼蟲",
    "140603": "巨大幼蟲",
    "140604": "幼蟲",
    "140605": "幼蟲",
    "140701": "叢林眼鏡蛇",
    "140702": "沼澤眼鏡蛇",
    "140703": "草蛇",
    "150001": "巨大地蟲",
    "150002": "巨大地蟲",
    "150003": "巨大地蟲",
    "150004": "巨大地蟲",
    "150005": "巨大地蟲",
    "150101": "黃金面具幽靈",
    "150201": "小肺魚",
    "150202": "肺魚",
    "150301": "冰雪地蟲",
    "150302": "冰雪地蟲",
    "150303": "冰雪地蟲",
    "150304": "冰雪地蟲",
    "150305": "冰雪地蟲",
    "150306": "小冰雪地蟲",
    "150307": "小冰雪地蟲",
    "150308": "小冰雪地蟲",
    "150309": "突變的魚",
    "160001": "狂暴翼魔",
    "160002": "雷電翼魔",
    "160003": "被召喚的 翼魔",
    "160004": "被召喚的 翼魔",
    "160005": "雷電翼魔",
    "160006": "守衛翼魔",
    "160007": "暗影搗蛋鬼",
    "160008": "暗影搗蛋鬼",
    "160009": "暗影搗蛋鬼",
    "160010": "模範生 暗影搗蛋鬼",
    "160011": "暗影搗蛋鬼",
    "160012": "暗影搗蛋鬼",
    "160013": "暗影搗蛋鬼",
    "160014": "100戰 150敗的 暗影搗蛋鬼",
    "160015": "活動 狂暴翼魔",
    "160016": "活動 雷電翼魔",
    "160101": "灰色搗蛋鬼",
    "160102": "綠色搗蛋鬼",
    "160103": "棕色搗蛋鬼",
    "160104": "武裝搗蛋鬼",
    "160105": "藍色搗蛋鬼之王",
    "160106": "粉紅搗蛋鬼之王",
    "160107": "綠色搗蛋鬼之王",
    "160108": "白色搗蛋鬼之王",
    "160109": "黑色搗蛋鬼之王",
    "160110": "綠色搗蛋鬼",
    "160111": "搗蛋鬼",
    "160201": "石頭翼魔",
    "160202": "石頭翼魔-護肩發光",
    "160203": "石頭翼魔-手套發光",
    "160204": "石頭翼魔-靴子發光",
    "160205": "發光石頭翼魔",
    "160301": "棕色遺跡翼魔",
    "160302": "黑色遺跡翼魔",
    "160303": "白色遺跡翼魔",
    "160501": "炎魔",
    "160502": "炎魔",
    "160503": "炎魔",
    "160504": "炎魔",
    "160505": "活動 炎魔",
    "170001": "夢靨",
    "170101": "萊肯",
    "170102": "萊肯",
    "170103": "萊肯",
    "170104": "萊肯",
    "170105": "萊肯",
    "170106": "萊肯",
    "170107": "萊肯",
    "170108": "萊肯",
    "170201": "狼人",
    "170202": "灰狼人",
    "170203": "藍狼人",
    "170204": "狼人",
    "170205": "灰狼人",
    "170206": "巨大狼人",
    "170301": "鼠人",
    "170302": "藍鼠人",
    "170303": "暗黑鼠人",
    "170304": "暗黑鼠人",
    "170305": "暗黑鼠人",
    "170306": "暗黑鼠人",
    "170307": "暗黑鼠人",
    "170308": "巨大暗黑鼠人",
    "170309": "鼠人",
    "170310": "藍鼠人",
    "170311": "暗黑鼠人",
    "170312": "活動 暗黑鼠人",
    "170313": "活動 巨大暗黑鼠人",
    "170314": "活動 暗黑鼠人",
    "170315": "活動 巨大暗黑鼠人",
    "170316": "活動 巨大妖魔",
    "170317": "活動 巨大白狼",
    "170318": "活動 哥布林",
    "170319": "活動 哥布林弓箭手",
    "170320": "活動 妖魔",
    "170321": "活動 地靈",
    "170322": "活動 地靈弓箭手",
    "170323": "活動 黑暗騎士團",
    "170324": "活動 白狼",
    "170325": "活動 奧拉克妮",
    "170326": "活動 百眼巨人",
    "170327": "活動 百眼巨人",
    "170328": "活動 百眼巨人",
    "170329": "活動 百眼巨人",
    "170330": "活動 白魅魔",
    "170331": "活動 炸彈殭屍",
    "170332": "活動 炸彈殭屍",
    "170333": "活動 炸彈殭屍",
    "170334": "活動 殭屍",
    "170335": "活動 巨大長角牛羚",
    "170336": "活動 巨大母獅子",
    "170337": "活動 哥布林",
    "170338": "活動 哥布林弓箭手",
    "170339": "活動 奧拉克妮",
    "170340": "活動 獨眼巨人",
    "170341": "活動 狂暴翼魔",
    "170342": "活動 叢林哥布林弓箭手",
    "170343": "活動 叢林哥布林戰士",
    "170344": "活動 叢林哥布林頭目",
    "170345": "活動 妖魔",
    "170346": "活動 地靈",
    "170347": "活動 地靈弓箭手",
    "170348": "活動 雷電翼魔",
    "170349": "活動 獅子",
    "170350": "活動 殭屍",
    "170351": "活動 食人魔戰士",
    "170352": "活動 食人魔屠夫",
    "170353": "活動 暗影巫師",
    "170354": "活動 黑暗騎士團",
    "170355": "活動 黑暗骷髏士兵",
    "170356": "活動 炎魔",
    "170357": "活動 報喪女妖",
    "170358": "活動 黑豹",
    "170359": "活動 炸彈殭屍",
    "170360": "活動 炸彈殭屍",
    "170361": "活動 炸彈殭屍",
    "170362": "活動 殭屍之王",
    "170363": "活動 偽裝怪",
    "170364": "活動 暗黑鼠人",
    "170365": "活動 半巫妖",
    "170366": "活動 沙漠龍",
    "170367": "活動 殭屍",
    "170368": "活動 鬼怪",
    "170369": "活動 藍色鬼怪",
    "170370": "活動 紅色鬼怪",
    "170371": "活動 食屍鬼",
    "170372": "活動 巨大獅子",
    "170373": "活動 哥布林",
    "170374": "活動 哥布林弓箭手",
    "170375": "活動 蜘蛛弓箭手",
    "170376": "活動 叢林哥布林爆破兵",
    "170377": "活動 虛無騎士",
    "170378": "活動 伊弗烈特",
    "170379": "活動 妖魔",
    "170380": "活動 惡翅魅魔",
    "170381": "活動 地靈",
    "170382": "活動 地靈弓箭手",
    "170383": "活動 平原龍",
    "170384": "活動 紅色巨龍",
    "170385": "活動 黑暗騎士團",
    "170386": "活動 屍妖",
    "170387": "披著羊皮的狼",
    "170388": "披著羊皮的狼",
    "170389": "披著羊皮的狼",
    "170390": "牧羊犬",
    "170391": "披著羊皮的狼",
    "170392": "羊",
    "170393": "世界樹精靈",
    "170394": "犛牛",
    "170395": "突變的山羊",
    "170397": "沃爾加姆",
    "170398": "沃爾加姆",
    "170399": "沃爾加姆",
    "170400": "菜月昴",
    "170401": "薩提洛斯",
    "170402": "沃爾加姆",
    "170403": "沃爾加姆",
    "170404": "沃爾加姆",
    "170405": "魔女教徒",
    "170415": "彩虹紅羊",
    "170416": "彩虹橙羊",
    "170417": "彩虹黃羊",
    "170418": "彩虹綠羊",
    "170419": "彩虹藍羊",
    "170420": "松鼠",
    "170421": "披著羊皮的狼",
    "170422": "迷失的蜘蛛座",
    "170423": "迷失的巨魔像座",
    "170424": "迷失的大熊座",
    "170425": "迷失的山羊座",
    "170426": "迷失的狐狸座",
    "170427": "迷失的獨角獸座",
    "170428": "迷失的毒蛇座",
    "170429": "迷失的美洲豹座",
    "170430": "迷失的翼龍座",
    "170431": "草莓糖寶",
    "170432": "香橙糖寶",
    "170433": "檸檬糖寶",
    "170434": "萊姆糖寶",
    "170435": "蘇打糖寶",
    "170436": "葡萄糖寶",
    "170437": "軟糖熊",
    "170438": "軟糖熊",
    "170439": "甜甜的薑餅人餅乾",
    "170440": "可口的薑餅人餅乾",
    "170441": "油膩的薑餅人餅乾",
    "170442": "酥脆的薑餅人餅乾",
    "170443": "故障的警衛兔子玩偶",
    "170444": "人偶工坊玩偶",
    "170445": "歸來的搗蛋鬼",
    "170446": "糖寶王哇咖-恰嘎",
    "170447": "巨大薑餅人",
    "170448": "餅乾魔女",
    "170449": "凱爾",
    "170450": "柯爾頓",
    "170451": "威廉",
    "170452": "加奈芃的記憶成像",
    "170453": "加奈芃的惡夢成像",
    "180001": "殭屍",
    "180002": "殭屍",
    "180003": "殭屍士兵",
    "180004": "殭屍士兵",
    "180005": "殭屍",
    "180006": "殭屍",
    "180007": "幼童殭屍",
    "180008": "少女殭屍",
    "180009": "炸彈殭屍",
    "180010": "殭屍之王",
    "180011": "殭屍",
    "180012": "殭屍",
    "180013": "幼童殭屍",
    "180014": "少女殭屍",
    "180015": "炸彈殭屍",
    "180016": "殭屍",
    "180017": "殭屍",
    "180018": "幼童殭屍",
    "180019": "少女殭屍",
    "180020": "炸彈殭屍",
    "180021": "入伍300年的 殭屍士兵",
    "180022": "入伍300年的 殭屍士兵",
    "180023": "連手都沒牽過的殭屍",
    "180024": "連手都沒牽過的殭屍",
    "180025": "單身殭屍",
    "180026": "德瑞歐",
    "180027": "活動 殭屍",
    "180028": "活動 殭屍",
    "180029": "活動 炸彈殭屍",
    "180030": "活動 炸彈殭屍",
    "180031": "活動 炸彈殭屍",
    "180032": "活動 殭屍之王",
    "180033": "惡夢的 殭屍",
    "180034": "惡夢的 殭屍",
    "180035": "惡夢的 石頭殭屍",
    "180036": "惡夢的 殭屍士兵",
    "180037": "惡夢的 殭屍士兵",
    "180038": "惡夢的 雪人殭屍",
    "180039": "惡夢的 冰晶殭屍",
    "180040": "惡夢的 炸彈殭屍",
    "180041": "惡夢的 黑色牢獄殭屍",
    "180042": "惡夢的 白色牢獄殭屍",
    "180043": "惡夢的 半巫妖",
    "180044": "惡夢的 大師巫妖",
    "180045": "惡夢的 古代巫妖",
    "180046": "惡夢的 鬼魂",
    "180047": "惡夢的 鬼怪",
    "180048": "惡夢的 藍色鬼怪",
    "180049": "惡夢的 紅色鬼怪",
    "180050": "惡夢的 夜遊魂",
    "180051": "殭屍",
    "180052": "殭屍",
    "180053": "殭屍士兵",
    "180054": "殭屍士兵",
    "180055": "炸彈殭屍",
    "180056": "黑色牢獄殭屍",
    "180057": "白色牢獄殭屍",
    "180058": "綠寶石土狼",
    "180059": "綠寶石冰頭怪",
    "180060": "半巫妖",
    "180061": "大師巫妖",
    "180062": "古代巫妖",
    "180063": "鬼魂",
    "180064": "鬼怪",
    "180065": "藍色鬼怪",
    "180066": "紅色鬼怪",
    "180067": "夜遊魂",
    "180068": "惡夢殭屍",
    "180069": "惡夢殭屍",
    "180070": "惡夢的洛可",
    "180071": "惡夢王城警衛兵",
    "180072": "惡夢人類士兵",
    "180073": "惡夢人類士兵",
    "180074": "惡夢人類士兵",
    "180075": "惡夢人類士兵",
    "180076": "突變的狼",
    "180077": "復活的屍體",
    "180078": "阿瓦隆祭司亡靈",
    "180101": "灰狗",
    "180201": "石頭殭屍",
    "180202": "石頭殭屍-頭環發光",
    "180203": "石頭殭屍-頭飾發光",
    "180204": "石頭殭屍-眼睛發光",
    "180205": "石頭殭屍-護肩發光",
    "180206": "石頭殭屍-腰帶發光",
    "180207": "石頭殭屍-手飾發光",
    "180208": "發光石頭殭屍",
    "180209": "石頭殭屍",
    "180210": "石頭殭屍",
    "180211": "石頭殭屍",
    "180212": "石頭殭屍",
    "180213": "石頭殭屍",
    "180301": "陶瓷娃娃",
    "180401": "灰色牢獄殭屍",
    "180402": "黑色牢獄殭屍",
    "180403": "白色牢獄殭屍",
    "180501": "冰晶殭屍",
    "180502": "冰晶殭屍",
    "180503": "巨人冰晶殭屍",
    "180504": "冰晶殭屍",
    "180601": "雪人殭屍",
    "180602": "雪人殭屍",
    "180603": "雪殭屍",
    "180604": "雪人殭屍",
    "180605": "雪怪殭屍",
    "180606": "復活的屍體",
    "180701": "獨角獸",
    "180702": "獨角獸",
    "180703": "獨角獸",
    "180801": "大耳兔",
    "180901": "突變的飛龍",
    "190001": "魔劍",
    "190002": "魔劍",
    "190003": "魔劍",
    "190004": "魔劍",
    "190005": "魔劍",
    "190006": "禁錮魔劍",
    "190007": "魔劍",
    "190008": "魔劍",
    "190009": "生鏽的魔劍",
    "190010": "生鏽的魔劍",
    "190011": "冰鏡魔女",
    "190021": "冰鏡魔女",
    "190101": "銅製餐具",
    "190102": "銀製餐具",
    "190103": "金製餐具",
    "190104": "銀製餐具",
    "190105": "防禦訓練用木偶",
    "190106": "重擊訓練用木偶",
    "190107": "訓練用反擊木偶",
    "190108": "旋風擺蓮腿訓練用木偶",
    "190109": "訓練用 白蜘蛛",
    "190110": "訓練用 罈壺蜘蛛",
    "190111": "訓練用 幼小棕狐狸",
    "190112": "訓練用 紅狐狸",
    "190113": "訓練用 紅蜘蛛",
    "190114": "訓練用 巨大蜘蛛",
    "190115": "訓練用 幼小棕惡狼",
    "190116": "訓練用 披著羊皮的狼",
    "190117": "訓練用 棕色野狼",
    "190118": "訓練用 骷髏狼",
    "190119": "訓練用 黑狼",
    "190120": "訓練用 芬里爾",
    "190121": "訓練用 幼小哥布林",
    "190122": "訓練用 叢林哥布林弓箭手",
    "190123": "訓練用 叢林哥布林戰士",
    "190124": "訓練用 地靈盜賊",
    "190125": "訓練用 劇毒地靈",
    "190126": "訓練用 叢林哥布林爆破兵",
    "190127": "訓練用 叢林哥布林咒術師",
    "190128": "訓練用 骷髏",
    "190129": "訓練用 茶壺士兵",
    "190130": "訓練用 燭臺士兵",
    "190131": "訓練用 骷髏士兵",
    "190132": "訓練用 海盜骷髏",
    "190133": "訓練用 骷髏船長",
    "190134": "訓練用 幼小黑色半月熊",
    "190135": "訓練用 黑色半月熊",
    "190136": "堅硬的訓練用木偶",
    "190137": "訓練用 人偶弓箭手",
    "190138": "分身幻像",
    "190139": "訓練兵",
    "190140": "基本訓練用木偶",
    "190141": "訓練兵",
    "190142": "訓練兵",
    "190143": "訓練兵",
    "190144": "訓練兵",
    "190145": "訓練兵",
    "190146": "訓練兵",
    "190147": "트릭 좀비 병사",
    "190148": "트릭 스노우 좀비",
    "190149": "트릭 스톤 좀비",
    "190150": "트릭 밴더스내치",
    "190151": "트릭 좀비 병사",
    "190152": "트릭 스노우 좀비",
    "190153": "트릭 스톤 좀비",
    "190154": "트릭 밴더스내치",
    "190155": "트릭 좀비 병사",
    "190156": "트릭 스노우 좀비",
    "190157": "트릭 스톤 좀비",
    "190158": "트릭 밴더스내치",
    "190159": "트릭 좀비 병사",
    "190160": "트릭 스노우 좀비",
    "190161": "트릭 스톤 좀비",
    "190162": "트릭 밴더스내치",
    "190163": "防禦訓練用木偶",
    "190164": "重擊訓練用木偶",
    "190165": "訓練用反擊木偶",
    "190166": "旋風擺蓮腿訓練用木偶",
    "190167": "堅硬的訓練用木偶",
    "190168": "길 잃은 좀비 병사",
    "190169": "길 잃은 스노우 좀비",
    "190170": "길 잃은 스톤 좀비",
    "190171": "길 잃은 밴더스내치",
    "190172": "길 잃은 좀비 병사",
    "190173": "길 잃은 스노우 좀비",
    "190174": "길 잃은 스톤 좀비",
    "190175": "길 잃은 밴더스내치",
    "190176": "길 잃은 거대 좀비 병사",
    "190177": "길 잃은 거대 스노우 좀비",
    "190178": "길 잃은 거대 스톤 좀비",
    "190179": "길 잃은 거대 밴더스내치",
    "190180": "길 잃은 좀비 병사",
    "190181": "길 잃은 스노우 좀비",
    "190182": "길 잃은 스톤 좀비",
    "190183": "길 잃은 밴더스내치",
    "190184": "傭兵浣熊",
    "190185": "傭兵紅狐狸",
    "190186": "傭兵白狼",
    "190187": "傭兵黑熊",
    "190188": "黑灰熊",
    "190189": "獅子",
    "190190": "萬聖節 炸彈殭屍",
    "190191": "司令野貓",
    "190192": "司令野貓",
    "190193": "司令野貓",
    "190194": "司令野貓",
    "190195": "司令野貓",
    "190196": "司令野貓",
    "190197": "司令村子小貓",
    "190198": "司令骷髏狼",
    "190199": "司令食人魔戰士",
    "190200": "黑魅魔",
    "190201": "白魅魔",
    "190202": "紅魅魔",
    "190203": "黃魅魔",
    "190204": "褐魅魔",
    "190205": "粉紅魅魔",
    "190206": "松鼠布偶",
    "190207": "沙漠狐狸布偶",
    "190208": "熊寶寶布偶",
    "190209": "老虎布偶",
    "190210": "兔子布偶",
    "190211": "松鼠布偶",
    "190212": "熊寶寶布偶",
    "190213": "老虎布偶",
    "190214": "兔子布偶",
    "190215": "小兵兔子",
    "190216": "迅速的 兔子",
    "190217": "最高等兔子隊長",
    "190218": "Archer",
    "190219": "Saber",
    "190220": "Archer",
    "190221": "Saber",
    "190222": "吉爾伽美什",
    "190223": "Berserker",
    "190224": "只擅長防禦的 田鼠",
    "190225": "只懂重擊的 灰狼",
    "190226": "反擊的高手 棕蛇",
    "190227": "魯特琴小偷的部下",
    "190228": "魯特琴小偷的部下",
    "190229": "偷走魯特琴的小偷",
    "190230": "骯髒的 鴿子",
    "190231": "浣熊",
    "190232": "幼小浣熊",
    "190233": "訓練用 木人偶",
    "190234": "洛根",
    "190235": "可娜",
    "190236": "戴伊",
    "190237": "艾樂莉絲",
    "190238": "寇爾",
    "190239": "艾希",
    "190246": "小熊貓縫紉娃娃",
    "190247": "幼貓縫紉娃娃",
    "190248": "香氛熊熊 (蜘蛛)",
    "190249": "鹿布偶",
    "191001": "活動 哥布林",
    "191002": "活動 哥布林弓箭手",
    "191003": "活動 叢林哥布林爆破兵",
    "191004": "活動叢林哥布林爆破兵",
    "191005": "活動 叢林哥布林弓箭手",
    "191006": "活動 地靈",
    "191007": "活動 地靈弓箭手",
    "191008": "活動 叢林哥布林戰士",
    "191009": "活動叢林哥布林頭目",
    "191010": "活動 白魅魔",
    "191011": "活動 妖魔",
    "191012": "活動 巨大妖魔",
    "191013": "活動 屍妖",
    "191014": "活動 食屍鬼",
    "191015": "活動 黑暗骷髏士兵",
    "191016": "活動 惡翅魅魔",
    "191017": "活動 半巫妖",
    "191018": "活動 虛無騎士",
    "191019": "活動 報喪女妖",
    "191020": "活動 暗影巫師",
    "191021": "活動 奧拉克妮",
    "191022": "活動 奧拉克妮",
    "191023": "活動 白狼",
    "191024": "活動 巨大白狼",
    "191025": "活動 偽裝怪",
    "191026": "活動 食人魔戰士",
    "191027": "活動 食人魔屠夫",
    "191028": "活動 巨大食人魔",
    "191029": "活動 獨眼巨人",
    "191030": "活動 百眼巨人",
    "191031": "活動 百眼巨人",
    "191032": "活動 百眼巨人",
    "191033": "活動 百眼巨人",
    "191034": "活動 伊弗烈特",
    "191035": "活動 鬼怪",
    "191036": "活動 藍色鬼怪",
    "191037": "活動 紅色鬼怪",
    "191038": "活動 巨大長角牛羚",
    "191039": "活動 狂暴翼魔",
    "191040": "活動 雷電翼魔",
    "191041": "活動 炎魔",
    "191042": "活動 暗黑鼠人",
    "191043": "活動巨人暗黑鼠人",
    "191044": "活動 殭屍",
    "191045": "活動 殭屍",
    "191046": "活動 炸彈殭屍",
    "191047": "活動 炸彈殭屍",
    "191048": "活動 炸彈殭屍",
    "191049": "活動 殭屍之王",
    "191050": "活動 沙漠龍",
    "191051": "活動 平原龍",
    "191052": "活動 獅子",
    "191053": "活動 巨大母獅子",
    "191054": "活動 巨大獅子",
    "191055": "活動 黑豹",
    "191056": "活動 紅色巨龍",
    "191057": "活動 黑暗騎士團",
    "191058": "活動 蜘蛛弓箭手",
    "191101": "持有枕頭 闇黑巫師",
    "191102": "持有枕頭 暗黑戰士",
    "191103": "持有枕頭 黑魅魔",
    "191104": "持有枕頭 紅魅魔",
    "191105": "持有枕頭 魔女",
    "191106": "持有枕頭 屍妖",
    "191107": "持有枕頭 食屍鬼",
    "191108": "持有枕頭 惡翅魅魔",
    "191109": "持有枕頭 惡翅魅魔",
    "191110": "持有枕頭 貓妖精騎士",
    "191111": "持有枕頭 貓妖精騎士",
    "191112": "持有枕頭 暗影巫師",
    "191113": "持有枕頭 暗影巫師",
    "191114": "持有枕頭 暗影鍊金術師",
    "191115": "持有枕頭 冰鏡魔女",
    "191116": "持有枕頭 狼人",
    "191117": "持有枕頭 殭屍",
    "191118": "持有枕頭 殭屍",
    "191119": "幼小溫泉獼猴",
    "191120": "成年溫泉獼猴",
    "191121": "凶惡的 溫泉獼猴",
    "191122": "首領溫泉獼猴",
    "191123": "溫泉神靈",
    "191201": "撲克士兵",
    "191202": "撲克巨人士兵",
    "191203": "撲克死神",
    "191204": "撲克士兵",
    "191205": "撲克巨人士兵",
    "191206": "勃蘭登堡",
    "191207": "不敗之劍",
    "191208": "提赫拉",
    "191209": "塔巴勒塔斯",
    "191210": "巨大無頭怪",
    "191211": "火爆熊",
    "191212": "鎧甲骷髏食人魔",
    "191213": "石頭翼魔",
    "191214": "古代巫妖",
    "191215": "奧拉克妮",
    "191216": "伊弗烈特",
    "191217": "烏龜",
    "191218": "蜘蛛絲木乃伊",
    "191219": "兔子布偶",
    "191220": "沙漠狐狸布偶",
    "191221": "松鼠布偶",
    "191222": "虛弱的 勃蘭登堡",
    "191223": "虛弱的 不敗之劍",
    "191224": "虛弱的 提赫拉",
    "191225": "虛弱的 塔巴勒塔斯",
    "191226": "虛弱的 巨大無頭怪",
    "191227": "虛弱的 火爆熊",
    "191228": "虛弱的 鎧甲骷髏食人魔",
    "191229": "虛弱的 石頭翼魔",
    "191230": "虛弱的 古代巫妖",
    "191231": "虛弱的 奧拉克妮",
    "191232": "虛弱的 伊弗烈特",
    "191233": "虛弱的 烏龜",
    "191234": "虛弱的 蜘蛛絲木乃伊",
    "191235": "虛弱的 兔子布偶",
    "191236": "虛弱的 沙漠狐狸布偶",
    "191237": "虛弱的 松鼠布偶",
    "191238": "白銀骸骨槍騎兵",
    "191239": "白銀骸骨鬥士",
    "191240": "白銀骸骨弓箭手",
    "191241": "黃金骸骨槍騎兵",
    "191242": "黃金骸骨戰士",
    "191243": "黃金骸骨弓箭手",
    "191244": "夜遊魂",
    "191245": "骷髏自爆兵",
    "191246": "鬼怪",
    "191247": "藍色鬼怪",
    "191248": "紅色鬼怪",
    "191249": "維羅納黑色牢獄鬼魂",
    "191250": "鬼怪",
    "191251": "藍鬼怪",
    "191252": "紅色鬼怪",
    "191253": "獨眼怪",
    "191254": "戰士 陶瓷娃娃",
    "191255": "槍騎兵 陶瓷娃娃",
    "191256": "武鬥家 陶瓷娃娃",
    "191257": "弓箭手 陶瓷娃娃",
    "191258": "雹暴 陶瓷娃娃",
    "191259": "冰魔法 陶瓷娃娃",
    "191260": "雷電 陶瓷娃娃",
    "191261": "火之鍊金術師 陶瓷娃娃",
    "191262": "水之鍊金術師 陶瓷娃娃",
    "191263": "掠奪團 暗黑鼠人",
    "191264": "掠奪團 巨大暗黑鼠人",
    "191265": "掠奪團 巨大妖魔",
    "191266": "掠奪團 巨大白狼",
    "191267": "掠奪團 哥布林",
    "191268": "掠奪團 哥布林弓箭手",
    "191269": "掠奪團 妖魔",
    "191270": "掠奪團 地靈",
    "191271": "掠奪團 地靈弓箭手",
    "191272": "掠奪團 黑暗騎士團",
    "191273": "掠奪團 白狼",
    "191274": "掠奪團 奧拉克妮",
    "191275": "掠奪團 百眼巨人",
    "191276": "掠奪團 百眼巨人",
    "191277": "掠奪團 百眼巨人",
    "191278": "掠奪團 百眼巨人",
    "191279": "掠奪團 白魅魔",
    "191280": "掠奪團 炸彈殭屍",
    "191281": "掠奪團 炸彈殭屍",
    "191282": "掠奪團 炸彈殭屍",
    "191283": "掠奪團 殭屍",
    "191284": "掠奪團 巨大長角牛羚",
    "191285": "掠奪團 巨大母獅子",
    "191286": "掠奪團哥布林",
    "191287": "掠奪團哥布林弓箭手",
    "191288": "掠奪團奧拉克妮",
    "191289": "掠奪團 獨眼巨人",
    "191290": "掠奪團 狂暴翼魔",
    "191291": "掠奪團 叢林哥布林弓箭手",
    "191292": "掠奪團 叢林哥布林戰士",
    "191293": "掠奪團 叢林哥布林頭目",
    "191294": "掠奪團妖魔",
    "191295": "掠奪團地靈",
    "191296": "掠奪團地靈弓箭手",
    "191297": "掠奪團 雷電翼魔",
    "191298": "掠奪團 獅子",
    "191299": "掠奪團 殭屍",
    "191300": "掠奪團 食人魔戰士",
    "191301": "掠奪團 食人魔屠夫",
    "191302": "掠奪團 暗影巫師",
    "191303": "掠奪團黑暗騎士團",
    "191304": "掠奪團 黑暗骷髏士兵",
    "191305": "掠奪團 炎魔",
    "191306": "掠奪團 報喪女妖",
    "191307": "掠奪團 黑豹",
    "191308": "掠奪團 炸彈殭屍",
    "191309": "掠奪團 炸彈殭屍",
    "191310": "掠奪團 炸彈殭屍",
    "191311": "掠奪團 殭屍之王",
    "191312": "掠奪團 偽裝怪",
    "191313": "掠奪團暗黑鼠人",
    "191314": "掠奪團 半巫妖",
    "191315": "掠奪團 沙漠龍",
    "191316": "掠奪團 殭屍",
    "191317": "掠奪團 鬼怪",
    "191318": "掠奪團 藍色鬼怪",
    "191319": "掠奪團 紅色鬼怪",
    "191320": "掠奪團 食屍鬼",
    "191321": "掠奪團 巨大獅子",
    "191322": "掠奪團 哥布林",
    "191323": "掠奪團 哥布林弓箭手",
    "191324": "掠奪團 蜘蛛弓箭手",
    "191325": "掠奪團 叢林哥布林爆破兵",
    "191326": "掠奪團 虛無騎士",
    "191327": "掠奪團 伊弗烈特",
    "191328": "掠奪團 妖魔",
    "191329": "掠奪團 惡翅魅魔",
    "191330": "掠奪團 地靈",
    "191331": "掠奪團 地靈弓箭手",
    "191332": "掠奪團 平原龍",
    "191333": "掠奪團 紅色巨龍",
    "191334": "掠奪團 黑暗騎士團",
    "191335": "掠奪團 屍妖",
    "191336": "掠奪團 地靈",
    "191337": "掠奪團 地靈弓箭手",
    "191338": "掠奪團 叢林哥布林戰士",
    "191339": "掠奪團 叢林哥布林頭目",
    "191340": "掠奪團 哥布林",
    "191341": "掠奪團 哥布林弓箭手",
    "191342": "掠奪團 叢林哥布林爆破兵",
    "191343": "掠奪團 叢林哥布林爆破兵",
    "191344": "掠奪團 叢林哥布林弓箭手",
    "191345": "掠奪團白狼",
    "191346": "掠奪團巨大白狼",
    "191347": "掠奪團 妖魔",
    "191348": "掠奪團巨大妖魔",
    "191349": "掠奪團 黑暗騎士團",
    "191350": "掠奪團 蜘蛛弓箭手",
    "191351": "掠奪團 暗黑鼠人",
    "191352": "掠奪團 巨大暗黑鼠人",
    "191353": "掠奪團 食人魔戰士",
    "191354": "掠奪團 食人魔屠夫",
    "191355": "掠奪團 巨大食人魔",
    "191356": "掠奪團 狂暴翼魔",
    "191357": "掠奪團 雷電翼魔",
    "191358": "掠奪團 獅子",
    "191359": "掠奪團 巨大母獅子",
    "191360": "掠奪團 巨大獅子",
    "191361": "掠奪團 黑豹",
    "191362": "掠奪團 殭屍",
    "191363": "掠奪團 殭屍",
    "191364": "掠奪團 炸彈殭屍",
    "191365": "掠奪團 炸彈殭屍",
    "191366": "掠奪團 炸彈殭屍",
    "191367": "掠奪團 殭屍之王",
    "191368": "掠奪團 黑暗骷髏士兵",
    "191369": "掠奪團 暗影巫師",
    "191370": "掠奪團 獨眼巨人",
    "191371": "掠奪團百眼巨人",
    "191372": "掠奪團百眼巨人",
    "191373": "掠奪團百眼巨人",
    "191374": "掠奪團百眼巨人",
    "191375": "掠奪團 巨大長角牛羚",
    "191376": "掠奪團 奧拉克妮",
    "191377": "掠奪團 奧拉克妮",
    "191378": "掠奪團 偽裝怪",
    "191379": "掠奪團 虛無騎士",
    "191380": "掠奪團 報喪女妖",
    "191381": "掠奪團 惡翅魅魔",
    "191382": "掠奪團 屍妖",
    "191383": "掠奪團 食屍鬼",
    "191384": "掠奪團 沙漠龍",
    "191385": "掠奪團 平原龍",
    "191386": "掠奪團 紅色巨龍",
    "191387": "掠奪團 半巫妖",
    "191388": "掠奪團 伊弗烈特",
    "191389": "단진",
    "191390": "만진",
    "191391": "아린",
    "191392": "포킨",
    "191393": "카딘",
    "191394": "生命樹",
    "191395": "公爵",
    "191396": "黃色珍島犬",
    "191397": "生命樹",
    "191398": "史萊姆",
    "191399": "幼蟲",
    "191400": "幼蟲",
    "191401": "巨大蜈蚣",
    "191402": "蜈蚣",
    "191403": "紅蜈蚣",
    "191404": "豺狼",
    "191405": "大山貓",
    "191406": "蜘蛛黃蜂",
    "191407": "巨大黃蜂",
    "191408": "紅眼蜘蛛",
    "191409": "綠角眼鏡蛇",
    "191410": "基因突變食蟲植物",
    "191411": "基因突變食蟲植物種子",
    "191412": "食蟲植物",
    "191413": "雷電之魂",
    "191414": "火焰之魂",
    "191415": "冰雪之魂",
    "191416": "巨大雷電之魂",
    "191417": "巨大火焰之魂",
    "191418": "巨大冰雪之魂",
    "191419": "森林巨魔像",
    "191420": "綠色食蟲植物",
    "191421": "黃色食蟲植物",
    "191422": "粉紅食蟲植物",
    "191423": "紅色食蟲植物",
    "191424": "鼠人",
    "191425": "藍螃蟹",
    "191426": "郊狼",
    "191427": "豺狼",
    "191428": "蜻蜓",
    "191429": "巨大蜻蜓",
    "191430": "巨大蜻蜓",
    "191431": "殭屍",
    "191432": "殭屍",
    "191433": "殭屍",
    "191434": "殭屍",
    "191435": "殭屍",
    "191436": "殭屍",
    "191437": "殭屍",
    "191438": "殭屍",
    "191439": "殭屍",
    "191440": "殭屍",
    "191441": "殭屍",
    "191442": "殭屍",
    "191443": "食屍鬼",
    "191444": "食屍鬼",
    "191445": "灰色牢獄殭屍",
    "191446": "黑色牢獄殭屍",
    "191447": "白色牢獄殭屍",
    "191448": "炸彈殭屍",
    "191449": "盔甲骷髏",
    "191450": "鎧甲骷髏",
    "191451": "骷髏食人魔",
    "191452": "鎧甲骷髏食人魔",
    "191453": "鎧甲食人魔骷髏",
    "191454": "骷髏自爆兵",
    "191455": "紅骷髏",
    "191456": "紅骷髏",
    "191457": "金屬骷髏",
    "191458": "金屬骷髏",
    "191459": "紅骷髏船長",
    "191460": "骷髏船長",
    "191461": "海盜骷髏船長",
    "191462": "海盜骷髏",
    "191463": "海盜骷髏",
    "191464": "海盜紅骷髏",
    "191465": "海盜紅骷髏",
    "191466": "海盜骷髏船員",
    "191467": "海盜骷髏船員",
    "191468": "德瑞特",
    "191469": "骷髏地獄犬",
    "191470": "骷髏地獄犬",
    "191471": "骷髏狼",
    "191472": "幽靈軍首領",
    "191473": "幽靈軍鬥士",
    "191474": "幽靈軍戰士",
    "191475": "幽靈軍弓箭手",
    "191476": "偽裝怪",
    "191477": "鬼魂偽裝怪",
    "191478": "鬼魂",
    "191479": "藍色鬼魂",
    "191480": "紅色鬼魂",
    "191481": "藍色鬼魂王",
    "191482": "紅色鬼魂王",
    "191483": "鬼魂王",
    "191484": "骷髏幽靈",
    "191485": "綠色骷髏幽靈",
    "191486": "藍色骷髏幽靈",
    "191487": "紅色骷髏幽靈",
    "191488": "暗影鬼魂",
    "191489": "棕色牢獄鬼魂",
    "191490": "紅色牢獄鬼魂",
    "191491": "藍色牢獄鬼魂",
    "191492": "面具幽靈",
    "191493": "棕色鬼魂僕人",
    "191494": "黑色鬼魂僕人",
    "191495": "白色鬼魂僕人",
    "191496": "狼之魂",
    "191497": "熊之魂",
    "191498": "馬之魂",
    "191499": "紅色面具幻影",
    "191500": "黑色面具幻影",
    "191501": "白色面具幻影",
    "191502": "魔劍",
    "191503": "魔劍",
    "191504": "禁錮魔劍",
    "191505": "生鏽的魔劍",
    "191506": "搗蛋鬼",
    "191507": "灰色搗蛋鬼",
    "191508": "綠色搗蛋鬼",
    "191509": "棕色搗蛋鬼",
    "191510": "藍色搗蛋鬼之王",
    "191511": "綠色搗蛋鬼之王",
    "191512": "白色搗蛋鬼之王",
    "191513": "黑色搗蛋鬼之王",
    "191514": "狂暴翼魔",
    "191515": "雷電翼魔",
    "191516": "守衛翼魔",
    "191517": "棕色遺跡翼魔",
    "191518": "黑色遺跡翼魔",
    "191519": "白色遺跡翼魔",
    "191520": "鬼怪",
    "191521": "藍色鬼怪",
    "191522": "紅色鬼怪",
    "191523": "蜘蛛絲木乃伊",
    "191524": "紅木乃伊僕人",
    "191525": "黑木乃伊僕人",
    "191526": "白木乃伊僕人",
    "191527": "熊地精",
    "191528": "巨魔",
    "191529": "荒野巨魔",
    "191530": "夢靨",
    "191531": "虛無騎士",
    "191532": "白鹿",
    "191533": "黑鹿",
    "191534": "夜遊魂",
    "191535": "報喪女妖",
    "191536": "炎魔",
    "191537": "黑色蝙蝠",
    "191538": "듀크(임시)",
    "191539": "冰龍",
    "191540": "雪原殺手",
    "191541": "桐人",
    "191542": "那伊德",
    "191543": "搗蛋鬼",
    "191544": "歸來的搗蛋鬼",
    "191545": "萬聖節 殭屍",
    "191546": "貝莉莎",
    "191547": "貝莉莎",
    "191548": "萬聖節動畫門",
    "191549": "著魔的 老虎娃娃",
    "191550": "著魔的 兔娃娃",
    "191551": "壞老鼠",
    "191552": "大老鼠",
    "191553": "惡臭的 食人魔",
    "191554": "骯髒的 巨魔",
    "191555": "書房亡靈",
    "191556": "一般殭屍",
    "191557": "變種殭屍",
    "191558": "一般殭屍",
    "191559": "變種殭屍",
    "191560": "一般殭屍",
    "191561": "變種殭屍",
    "191562": "萬聖節 女殭屍",
    "191563": "叢林哥布林頭目",
    "191564": "叢林哥布林頭目",
    "191565": "情侶愛心銅像",
    "191566": "塔巴勒塔斯",
    "191567": "不敗之劍",
    "191568": "梅魯",
    "191569": "畫中死神",
    "191570": "格里斯貝恩",
    "191571": "巨大蜘蛛",
    "191572": "小巨魔像",
    "191573": "魔女",
    "191574": "黑魅魔",
    "191575": "大師巫妖",
    "191576": "黑色異變的熊",
    "191577": "紅色異變的熊",
    "191578": "黃色異變的熊",
    "191579": "藍色異變的熊",
    "191580": "白色異變的熊",
    "191581": "地靈",
    "191582": "地靈弓箭手",
    "191583": "黑蜘蛛",
    "191584": "灰鼠",
    "191585": "地獄犬",
    "191586": "紅地靈",
    "191587": "紅地靈弓箭手",
    "191588": "小巨魔",
    "191589": "骷髏地獄犬",
    "191590": "冰雪之魂",
    "191591": "巨大骷髏地獄犬",
    "191592": "骷髏吟遊詩人",
    "191593": "金屬骷髏吟遊詩人",
    "191594": "聖誕搗蛋鬼",
    "191595": "세피로트",
    "191596": "巨大披著羊皮的狼",
    "191597": "雷諾",
    "191598": "貝伊",
    "191599": "信",
    "191600": "披著羊皮的狼",
    "191601": "달콤한 진저맨쿠키",
    "191602": "고소한 진저맨쿠키",
    "191603": "느끼한 진저맨쿠키",
    "191604": "바삭한 진저맨쿠키",
    "191605": "抓尾巴板岩國王",
    "191606": "抓尾巴板岩箭手",
    "191607": "抓尾巴板岩鬥士",
    "191608": "抓尾巴雷電之魂",
    "191609": "抓尾巴火焰之魂",
    "191610": "抓尾巴冰雪之魂",
    "191611": "骷髏",
    "191612": "骷髏",
    "191613": "殭屍",
    "191614": "羊",
    "191615": "豬",
    "191616": "公雞",
    "191617": "母雞",
    "191618": "小雞",
    "191619": "紙蝴蝶",
    "191620": "棕兔",
    "191621": "Archer",
    "191622": "Saber",
    "191623": "吉爾伽美什",
    "191624": "Lancer",
    "191625": "伊莉亞絲菲爾",
    "191626": "凜",
    "191627": "Archer",
    "191628": "Saber",
    "191629": "Berserker",
    "191630": "吉爾伽美什",
    "191631": "黃金骸骨槍騎兵",
    "191632": "黃金骸骨戰士",
    "191633": "黃金骸骨弓箭手",
    "191634": "骷髏狼",
    "191635": "骷髏",
    "191636": "骷髏地獄犬",
    "191637": "杜羅",
    "191638": "Berserker",
    "191639": "吉爾伽美什",
    "191640": "結界水晶",
    "191641": "骷髏狼",
    "191642": "骷髏",
    "191643": "骷髏地獄犬",
    "191644": "黃金骸骨槍騎兵",
    "191645": "黃金骸骨戰士",
    "191646": "黃金骸骨弓箭手",
    "191647": "危險的骷髏",
    "191648": "骷髏自爆兵",
    "191649": "骷髏食人魔",
    "191650": "鎧甲骷髏食人魔",
    "191651": "全鎧甲骷髏食人魔",
    "191652": "骷髏幽靈",
    "191653": "骷髏食人魔",
    "191654": "鎧甲骷髏食人魔",
    "191655": "全鎧甲骷髏食人魔",
    "191656": "德瑞特",
    "191657": "吉爾伽美什",
    "191658": "骷髏食人魔",
    "191659": "鎧甲骷髏食人魔",
    "191660": "全鎧甲骷髏食人魔",
    "191661": "骷髏幽靈",
    "191662": "德瑞特",
    "191663": "骷髏吟遊詩人",
    "191664": "戰鬥船員骷髏",
    "191665": "骷髏",
    "191666": "戰鬥病痛骷髏",
    "191667": "骸骨弓箭手",
    "191668": "殭屍",
    "191669": "殭屍",
    "191670": "殭屍",
    "191671": "殭屍",
    "191672": "蜘蛛絲木乃伊",
    "191673": "梅莉爾",
    "191674": "拉格玲奈",
    "191675": "橡木桶",
    "191676": "橡木桶",
    "191677": "橡木桶",
    "191678": "克莉絲",
    "191679": "骷髏食人魔",
    "191680": "蜘蛛絲木乃伊",
    "191681": "魅魔女王",
    "191682": "骷髏死靈法師",
    "191683": "蘿莉魅魔",
    "191684": "遊魂",
    "191685": "石像翼魔",
    "191686": "石像翼魔石座",
    "191687": "黑色鎧甲骷髏",
    "191688": "黑色鎧甲骷髏食人魔",
    "191689": "緋紅骷髏劇毒蜘蛛",
    "191690": "黑色骷髏狼",
    "191691": "巨大緋紅飛蛾",
    "191692": "火焰魅魔",
    "191693": "雷電魅魔",
    "191694": "寒冰魅魔",
    "191695": "劇毒魅魔",
    "191696": "魔幻小精靈",
    "191697": "逃跑的薑餅人",
    "191698": "蘿莉魅魔",
    "191699": "魅魔女王",
    "191700": "糖寶王哇咖-恰嘎",
    "191701": "草莓糖寶",
    "191702": "香橙糖寶",
    "191703": "檸檬糖寶",
    "191704": "萊姆糖寶",
    "191705": "蘇打糖寶",
    "191706": "葡萄糖寶",
    "191707": "白巧克力棒",
    "191708": "軟糖熊",
    "191709": "軟糖熊",
    "191710": "巨大薑餅人",
    "191711": "餅乾魔女",
    "191712": "甜甜的薑餅人",
    "191713": "可口的薑餅人",
    "191714": "油膩的薑餅人",
    "191715": "酥脆的薑餅人",
    "191716": "加奈芃",
    "191717": "加奈芃",
    "191718": "加奈芃",
    "191719": "加奈芃",
    "191720": "加奈芃",
    "191722": "<mini>NPC</mini>糖寶王哇咖-恰嘎",
    "191723": "<mini>NPC</mini>糖寶",
    "191724": "魅魔女王",
    "191725": "珮西",
    "191726": "提亞",
    "191727": "肚子餓的高筒帽熊貓",
    "191728": "杜羅",
    "191729": "俄羅斯娃娃",
    "191730": "神秘的箱子",
    "191731": "神秘的箱子",
    "191732": "神秘的箱子",
    "191733": "神秘的箱子",
    "191734": "神秘的箱子",
    "191735": "神秘的箱子",
    "191736": "神秘的箱子",
    "191737": "神秘的箱子",
    "191738": "神秘的箱子",
    "191739": "神秘的箱子",
    "191740": "白蜘蛛黃蜂",
    "191741": "幼蟲",
    "191742": "黑狼蛛",
    "191743": "蜘蛛弓箭手",
    "191744": "格蘭帝爾",
    "191745": "綠蛇",
    "191746": "暗黑鼠人",
    "191747": "紅色鐮刀劇毒蜘蛛",
    "191748": "紅色釘刺劇毒蜘蛛",
    "191749": "熊地精",
    "191750": "冰雪之魂",
    "191751": "紅地靈",
    "191752": "骷髏地獄犬",
    "191753": "紅地靈弓箭手",
    "191754": "小巨魔",
    "191755": "骷髏狼",
    "191756": "骷髏自爆兵",
    "191757": "紅骷髏",
    "191758": "骷髏劇毒蜘蛛",
    "191759": "金屬骷髏",
    "191760": "妖魔",
    "191761": "骸骨蝶",
    "191762": "尖刺蚯蚓",
    "191763": "綠色搗蛋鬼",
    "191764": "巨大地蟲",
    "191765": "火焰之魂",
    "191766": "綠色搗蛋鬼",
    "191767": "狼人",
    "191768": "紅熊",
    "191769": "戈耳戈",
    "191770": "巨大森林豺狼",
    "191771": "巨大棕熊",
    "191772": "巨大狼人",
    "191773": "巨大山豬",
    "191774": "百眼巨人",
    "191775": "黑蜘蛛",
    "191776": "小百眼巨人",
    "191777": "海盜紅骷髏",
    "191778": "海盜紅骷髏船長",
    "191779": "魔劍",
    "191780": "迅速的 吸血蝙蝠",
    "191781": "鬼魂之王",
    "191782": "固執的 屍妖",
    "191783": "巨大女王飛蛾",
    "191784": "鬼怪",
    "191785": "巨大黃金蜘蛛",
    "191786": "巨魔像",
    "191787": "金屬骷髏吟遊詩人",
    "191788": "紅魅魔",
    "191789": "綠色搗蛋鬼之王",
    "191790": "巨大無頭怪",
    "191791": "鎧甲熊",
    "191792": "獨眼巨人",
    "191793": "大師巫妖",
    "191794": "浣熊",
    "191795": "結界水晶",
    "191796": "巨大雷電之魂",
    "191797": "俄羅斯娃娃",
    "191798": "俄羅斯娃娃",
    "191799": "俄羅斯娃娃",
    "191800": "俄羅斯娃娃",
    "191803": "魅魔女王",
    "191804": "骷髏死靈法師",
    "191805": "蘿莉魅魔",
    "191806": "遊魂",
    "191807": "石像翼魔",
    "191808": "石像翼魔石座",
    "191809": "黑色鎧甲骷髏",
    "191810": "黑色鎧甲骷髏食人魔",
    "191811": "緋紅骷髏劇毒蜘蛛",
    "191812": "黑色骷髏狼",
    "191813": "巨大緋紅飛蛾",
    "191814": "火焰魅魔",
    "191815": "雷電魅魔",
    "191816": "寒冰魅魔",
    "191817": "劇毒魅魔",
    "191818": "魔幻小精靈",
    "191819": "蘿莉魅魔",
    "191820": "松鼠",
    "191821": "公爵",
    "191822": "黑蜘蛛",
    "191823": "灰鼠",
    "191824": "地靈弓箭手",
    "191825": "骷髏吟遊詩人",
    "191826": "紅骷髏吟遊詩人",
    "191827": "黃金骷髏吟遊詩人",
    "191829": "弗魔族吟遊詩人",
    "191830": "弗魔族吟遊詩人",
    "191831": "看不見的人",
    "191832": "賈柏休的意念",
    "191833": "凱爾的僕人",
    "191834": "監視者偽裝怪",
    "191835": "藍色魅影",
    "191836": "紅色魅影",
    "191837": "魅影",
    "191838": "幽靈彈",
    "191839": "幽靈彈",
    "191840": "石像",
    "191841": "石像_透明",
    "191842": "小幽靈",
    "191843": "凱爾",
    "191844": "柯爾頓",
    "191845": "威廉",
    "191846": "柯爾頓",
    "191847": "小幽靈",
    "191848": "凱爾",
    "191849": "柯爾頓",
    "191850": "威廉",
    "191851": "幽靈彈",
    "191852": "幽靈彈",
    "191853": "幽靈彈",
    "191854": "幽靈彈",
    "191855": "威廉",
    "191856": "小幽靈",
    "191857": "沉默的形象",
    "191858": "痛苦的形象",
    "191859": "憂鬱的形象",
    "191860": "不和諧的形象",
    "191861": "不和諧的形象",
    "191862": "不和諧的形象",
    "191863": "不安的形象",
    "191864": "不安的形象",
    "191865": "不安的形象",
    "191866": "恐怖的形象",
    "191867": "恐怖的形象",
    "191868": "恐怖的形象",
    "191869": "惡夢的形象",
    "191870": "空虛的形象",
    "191871": "憤怒的形象",
    "191872": "渾沌的形象",
    "191873": "安",
    "191874": "安",
    "191875": "梅林",
    "191876": "Diva",
    "191877": "教授J",
    "191878": "悲嘆之歌",
    "191879": "勇猛的形象",
    "191880": "智慧的形象",
    "191881": "忍耐的形象",
    "191882": "協調的形象",
    "191883": "悲嘆的痛苦",
    "191884": "和諧的形象",
    "191885": "惡夢的形象",
    "191886": "惡夢的形象",
    "191887": "惡夢的形象",
    "191888": "覺醒的形象",
    "191889": "憤怒的形象",
    "191890": "憤怒的形象",
    "191891": "憤怒的形象",
    "191892": "空虛的形象",
    "191893": "渾沌的形象",
    "191894": "悲嘆之歌",
    "191895": "悲嘆之歌",
    "191896": "悲嘆之歌",
    "191897": "悲嘆之歌",
    "191898": "艾亞莉",
    "191899": "艾亞莉",
    "191900": "被奧絲希侵蝕的艾亞莉",
    "191901": "水藍色長袍的弗魔族",
    "191902": "綠色搗蛋鬼",
    "191903": "雷電翼魔",
    "191904": "狂暴翼魔",
    "191905": "魔劍",
    "191906": "妖魔",
    "191907": "小精靈",
    "191908": "沙華魚人士兵",
    "191909": "沙華魚人鬥士",
    "191910": "沙華魚人遊俠",
    "191911": "沙華魚人戰士",
    "191912": "萊肯",
    "191913": "暗黑鼠人",
    "191914": "水晶",
    "191915": "水晶",
    "191916": "水晶",
    "191917": "黑毒蛇",
    "191918": "暗影搗蛋鬼",
    "191919": "暗影搗蛋鬼",
    "191920": "暗影搗蛋鬼",
    "191921": "雷電之魂",
    "191922": "火焰之魂",
    "191923": "冰雪之魂",
    "191924": "巨大雷電之魂",
    "191925": "巨大火焰之魂",
    "191926": "巨大冰雪之魂",
    "191927": "水晶巨魔像",
    "191928": "紫水晶巨魔像",
    "191929": "硫磺蜘蛛",
    "191930": "暗影夏爾馬",
    "191931": "暗影戰士",
    "191932": "暗影鬥士",
    "191933": "暗影弓箭手",
    "191934": "暗影巫師",
    "191935": "暗影槍騎兵",
    "191936": "暗影巫師",
    "191937": "暗影鍊金術師",
    "191938": "獨眼怪",
    "191939": "迷失沙華魚人",
    "191940": "勇敢的狗",
    "191941": "灰狼",
    "191942": "來自庭院的母雞",
    "191943": "棕狐狸",
    "191944": "有毅力的小雞",
    "191945": "紅熊",
    "191946": "紅哥布林",
    "191947": "巨大史萊姆",
    "191948": "史萊姆",
    "191949": "迷你史萊姆",
    "191950": "紅色鬼怪",
    "191951": "鬼怪",
    "191952": "殭屍",
    "191953": "優等生 妖魔",
    "191954": "棕色搗蛋鬼",
    "191955": "食人魔戰士",
    "191956": "有毅力的小雞",
    "191957": "有毅力的小雞",
    "191958": "享受挑戰的米列希安",
    "191959": "亢奮的小鬼",
    "191960": "尋找閃亮物品的小鬼",
    "191961": "胃不舒服的米列希安",
    "191962": "棒球社少年",
    "191963": "虛弱的精靈",
    "191964": "黑色搗蛋鬼之王",
    "191965": "綠色搗蛋鬼之王",
    "191966": "藍色搗蛋鬼之王",
    "191967": "食人魔戰士",
    "191968": "食人魔戰士",
    "191969": "獨眼巨人",
    "191970": "獨眼巨人",
    "191971": "哥布林獵人",
    "191972": "哥布林獵人弓箭手",
    "191973": "幼小棕狐狸",
    "191974": "幼小紅狐狸",
    "191975": "幼小灰狐狸",
    "191976": "梅林",
    "191977": "Diva",
    "191978": "教授J",
    "191979": "粉紅鬼魂",
    "191980": "黃色鬼魂",
    "191981": "黑紋蜘蛛",
    "191982": "蜘蛛鬥士",
    "191983": "蜘蛛絲木乃伊",
    "191984": "幼小巨大黃金蜘蛛",
    "191985": "巨大黃金蜘蛛",
    "191986": "豺狼人",
    "191987": "只想玩的狗",
    "191988": "糊里糊塗跟著出來的母雞",
    "191989": "純真無邪的小雞",
    "191990": "被奧絲希侵蝕的艾亞莉",
    "191991": "被奧絲希侵蝕的自我",
    "191992": "艾亞莉",
    "191993": "地獄貓",
    "191994": "偽裝怪",
    "191995": "悲嘆之歌",
    "191996": "杜羅",
    "191998": "吸血蝙蝠",
    "191999": "黃色鬼魂",
    "192007": "神秘寶箱",
    "192008": "放出的綠色奇異鳥",
    "192009": "放出的白色奇異鳥",
    "192010": "愚蠢的兼職員亞特",
    "192011": "保安要員托爾維斯",
    "192012": "偷懶的兼職員卡茲遠",
    "192013": "禮物包裝兼職員艾薇琳",
    "192014": "紀念品店兼職員畢奈",
    "192015": "熟練的兼職員洛維林",
    "192016": "露水商人開心果妖精",
    "192017": "達斯拉姆",
    "192018": "邪眼石像",
    "192019": "達斯拉姆",
    "192020": "達斯拉姆",
    "192021": "火焰史萊姆",
    "192022": "火焰史萊姆",
    "192023": "火焰史萊姆",
    "192024": "寒冰史萊姆",
    "192025": "寒冰史萊姆",
    "192026": "寒冰史萊姆",
    "192027": "雷電史萊姆",
    "192028": "雷電史萊姆",
    "192029": "雷電史萊姆",
    "192030": "幻象火蜥蜴",
    "192031": "幻象火蜥蜴",
    "192032": "幻象火蜥蜴",
    "192033": "幻象殭屍",
    "192034": "幻象殭屍",
    "192035": "幻象殭屍",
    "192036": "黑月教團成員",
    "192037": "黑月教團成員",
    "192038": "黑月教團成員",
    "192039": "巴羅爾的幻象",
    "192040": "達斯拉姆",
    "192041": "泰赫圖殷之門",
    "192042": "泰赫圖殷之門",
    "192043": "泰赫圖殷之門",
    "192044": "火蜥蜴",
    "192045": "格蘭帝爾",
    "192046": "紅色蜥蜴魔法師",
    "192047": "黑月教團成員",
    "192048": "地獄貓",
    "192049": "蜘蛛戰士",
    "192050": "駭骨蝶",
    "192051": "黑月教團成員",
    "192052": "黑月教團成員",
    "192053": "黑月教團成員",
    "192054": "炸彈蝙蝠",
    "192055": "紅腳狼蛛",
    "192056": "泰赫圖殷之門",
    "192057": "巴羅爾的分身",
    "192058": "黑月教團成員",
    "192059": "黑月教團成員",
    "192060": "邪眼石像",
    "192061": "邪眼石像",
    "192062": "邪眼石像",
    "192063": "邪眼石像",
    "192064": "邪眼石像",
    "192065": "邪眼石像",
    "192066": "黑月教團聖職者",
    "192067": "泰赫圖殷之門",
    "192068": "泰赫圖殷之門",
    "192069": "泰赫圖殷之門",
    "192070": "克赫蓮的集魔杖",
    "192071": "火蜥蜴",
    "192072": "黑月教團成員",
    "192073": "黑月教團成員",
    "192074": "黑月教團成員",
    "192075": "幻象殭屍",
    "192076": "克赫蓮",
    "192089": "摩格梅爾之門",
    "192090": "摩格梅爾之門",
    "192091": "摩格梅爾之門",
    "192092": "芬奇",
    "192093": "芬奇",
    "192094": "芬奇",
    "192095": "芬奇",
    "192096": "卡泰爾",
    "192097": "卡泰爾",
    "192098": "卡泰爾",
    "192099": "菲尼芬",
    "192100": "水豚",
    "192101": "水豚(不出現)",
    "192102": "犄角野豬",
    "192103": "雪吉拉",
    "192104": "白色雪原熊",
    "192105": "巨大獅子",
    "192106": "巨大母獅子",
    "192107": "獅子",
    "192108": "母獅子",
    "192109": "巨大獅子",
    "192110": "巨大母獅子",
    "192111": "芙露亞",
    "192112": "幸運草藥草牛羚",
    "192113": "幸運草藥草豬",
    "192114": "小精靈",
    "192115": "世界樹小精靈",
    "192116": "花",
    "192117": "花",
    "192118": "流浪小貓",
    "192119": "優等生 妖魔",
    "192120": "達斯拉姆",
    "192121": "火焰史萊姆",
    "192122": "寒冰史萊姆",
    "192123": "雷電史萊姆",
    "192124": "幻象火蜥蜴",
    "192125": "幻象殭屍",
    "192126": "泰赫圖殷之門",
    "192127": "泰赫圖殷之門",
    "192130": "巴羅爾的幻象(突發僵直免疫)",
    "192131": "芙露亞",
    "192132": "芙露亞",
    "192133": "深林大山貓",
    "192134": "深林大山貓",
    "192135": "深林大山貓",
    "192136": "貪心鬼妖魔",
    "192137": "貪心鬼妖魔",
    "192138": "貪心鬼妖魔",
    "192139": "摩格梅爾守護靈",
    "192140": "摩格梅爾守護靈",
    "192141": "摩格梅爾守護靈",
    "192142": "摩格梅爾枯木靈",
    "192143": "摩格梅爾枯木靈",
    "192144": "摩格梅爾枯木靈",
    "192145": "裝扮成幽靈的妖精",
    "192146": "裝扮成幽靈的妖精",
    "192147": "裝扮成幽靈的妖精",
    "192148": "摩格梅爾警衛隊長",
    "192149": "摩格梅爾警衛隊長",
    "192150": "凱倫",
    "192151": "凱倫",
    "192155": "訓練用之門",
    "192156": "守護靈之門",
    "192157": "枯木靈之門",
    "192158": "警衛貓之門",
    "192159": "幽靈之門",
    "192160": "浣熊",
    "192161": "大耳兔",
    "192162": "白色犰狳",
    "192163": "火焰之魂",
    "192164": "黃金奇異鳥",
    "192165": "妖魔",
    "192166": "黑色犰狳",
    "192167": "巨角駝鹿",
    "192168": "水豚",
    "192169": "冰雪之魂",
    "192170": "青蛇",
    "192171": "灰狼",
    "192172": "藍狼",
    "192173": "棕蛇",
    "192174": "白狼",
    "192175": "白蛇",
    "192176": "骷髏狼",
    "192177": "黑蛇",
    "192178": "綠蛇",
    "192179": "披著羊皮的狼",
    "192180": "喜歡打賭的巨大妖魔",
    "192181": "芙露亞(AI用1)",
    "192182": "芙露亞(AI用2)",
    "192183": "芙露亞(AI用3)",
    "192184": "摩格梅爾枯木靈",
    "192185": "摩格梅爾枯木靈",
    "192186": "摩格梅爾枯木靈",
    "192187": "變身為狼人的妖精",
    "192188": "變身為狼人的妖精",
    "192189": "變身為狼人的妖精",
    "192190": "裝作是格蘭帝爾的妖精們",
    "192191": "裝作是格蘭帝爾的妖精們",
    "192192": "裝作是格蘭帝爾的妖精們",
    "192193": "模仿百眼巨人的妖精",
    "192194": "模仿百眼巨人的妖精",
    "192195": "模仿百眼巨人的妖精",
    "192196": "摩格梅爾魔法守護靈",
    "192197": "凱倫的召喚靈",
    "192198": "凱倫的召喚靈",
    "192199": "凱倫的召喚靈",
    "192200": "來看熱鬧的警衛守護靈",
    "192201": "來看熱鬧的警衛守護靈",
    "192202": "凱倫的警衛守護靈",
    "192203": "凱倫的警衛守護靈",
    "192204": "凱倫的警衛守護靈",
    "192205": "摩格梅爾警衛貓",
    "192206": "摩格梅爾警衛貓",
    "192207": "摩格梅爾警衛貓",
    "192208": "裝扮成幽靈的妖精",
    "192209": "裝扮成幽靈的妖精",
    "192210": "裝扮成幽靈的妖精",
    "192211": "凱倫的警衛守護靈",
    "192212": "凱倫的警衛守護靈",
    "192213": "凱倫的警衛守護靈",
    "192214": "狼之門",
    "192215": "格蘭帝爾之門",
    "192216": "百眼巨人之門",
    "192217": "幽靈之門",
    "192218": "摩格梅爾枯木靈",
    "192219": "摩格梅爾枯木靈",
    "192220": "凱倫的盾牌",
    "192221": "凱倫的盾牌",
    "192226": "鹿",
    "192227": "暗影夏爾馬",
    "192228": "格蘭帝爾",
    "192229": "狼人",
    "192230": "芙露亞(AI用1)",
    "192231": "芙露亞(AI用2)",
    "192232": "芙露亞(AI用3)",
    "192233": "深林大山貓",
    "192234": "深林大山貓",
    "192235": "深林大山貓",
    "192236": "貪心鬼妖魔",
    "192237": "貪心鬼妖魔",
    "192238": "貪心鬼妖魔",
    "192239": "摩格梅爾守護靈",
    "192240": "摩格梅爾守護靈",
    "192241": "摩格梅爾守護靈",
    "192242": "摩格梅爾枯木靈",
    "192243": "摩格梅爾枯木靈",
    "192244": "摩格梅爾枯木靈",
    "192245": "青蛇",
    "192246": "灰狼",
    "192247": "藍狼",
    "192248": "棕蛇",
    "192249": "白狼",
    "192250": "白蛇",
    "192251": "骷髏狼",
    "192252": "黑蛇",
    "192253": "綠蛇",
    "192254": "披著羊皮的狼",
    "192255": "喜歡打賭的巨大妖魔",
    "192500": "諾亞達",
    "192501": "科隆克斯亞",
    "192502": "斯雷",
    "192503": "影子任務透明我軍怪物無敵",
    "192504": "影子任務透明我軍怪物",
    "192505": "影子任務透明敵軍怪物無敵",
    "192506": "影子任務透明敵軍怪物",
    "192507": "畢勒波樂軍魔法師",
    "192508": "畢勒波樂軍弓箭手",
    "192509": "畢勒波樂軍步兵",
    "192510": "畢勒波樂軍弓箭手",
    "192511": "畢勒波樂軍步兵",
    "192512": "畢勒波樂軍弓箭手",
    "192513": "畢勒波樂軍魔法師",
    "192514": "可疑石像",
    "192515": "可疑石像",
    "192516": "槍兵",
    "192517": "鬥士",
    "192518": "步兵",
    "192519": "達南步兵",
    "192520": "可疑石像發現位置",
    "192521": "可疑石像",
    "192522": "補給品馬車",
    "192523": "弗魔族戰士",
    "192524": "補給品馬車",
    "192525": "斯雷",
    "192526": "闇影石",
    "192527": "畢勒波樂軍吟遊詩人",
    "192528": "游擊隊長",
    "192529": "鼻子上有傷痕的游擊隊員",
    "192530": "俏鬍子游擊隊員",
    "192531": "長腿游擊隊員",
    "192532": "一把山羊鬍的游擊隊員",
    "192533": "臉上有傷疤的副官",
    "192534": "鬍子濃密的副官",
    "192535": "一臉神經質的副官",
    "192536": "短白髮副官",
    "192537": "達南軍步兵",
    "192538": "達南軍弓箭手",
    "192539": "畢勒波樂軍步兵",
    "192540": "畢勒波樂軍弓箭手",
    "192541": "茉麗安",
    "192542": "錫古",
    "192543": "畢勒波樂軍步兵",
    "192544": "畢勒波樂軍弓箭手",
    "192545": "游擊隊長",
    "192546": "諾亞達",
    "192547": "諾亞達",
    "192548": "游擊隊預定會合點",
    "192549": "斯雷",
    "192550": "結界石像",
    "192551": "結界用石像",
    "192552": "可疑石像",
    "192553": "游擊隊長",
    "192554": "游擊隊長",
    "192555": "游擊隊長",
    "192556": "游擊隊長",
    "192557": "諾亞達",
    "193000": "大魔法師加奈芃",
    "193001": "實體化之想像中的瑪麗",
    "193002": "實體化之想像中的魯艾利",
    "193003": "實體化之想像中的特拉克",
    "193004": "挨餓的狐狸",
    "193005": "稀有道具商人杜羅",
    "193006": "實體化之想像中的托爾維斯",
    "193007": "實體化之想像中的亞特",
    "193008": "實體化之想像中的艾薇琳",
    "193009": "實體化之想像中的畢奈",
    "193010": "實體化之想像中的卡茲遠",
    "193011": "實體化之想像中的洛維林",
    "193012": "吉拉克",
    "193013": "吉拉克",
    "193014": "布麗爾",
    "193015": "人偶吉拉克",
    "193016": "皮諾",
    "193017": "奇歐",
    "193018": "魔法師的鍋爐",
    "193019": "異常行為的乳牛",
    "193020": "異常行為的羊",
    "193021": "FREE SEASON 小幫手夏天",
    "193022": "摩根特",
    "193023": "凱薩首領",
    "193024": "身分不明的男子",
    "193025": "斐埃爾",
    "193026": "布莉恩",
    "193027": "莫爾坎",
    "193028": "持有枕頭 闇黑巫師",
    "193029": "持有枕頭 暗黑戰士",
    "193030": "持有枕頭 黑魅魔",
    "193031": "持有枕頭 紅魅魔",
    "193032": "持有枕頭 魔女",
    "193033": "持有枕頭 屍妖",
    "193034": "持有枕頭 食屍鬼",
    "193035": "持有枕頭 惡翅魅魔",
    "193036": "持有枕頭 惡翅魅魔",
    "193037": "持有枕頭 貓妖精騎士",
    "193038": "持有枕頭 貓妖精騎士",
    "193039": "持有枕頭 暗影巫師",
    "193040": "持有枕頭 暗影巫師",
    "193041": "持有枕頭 暗影鍊金術師",
    "193042": "持有枕頭 冰鏡魔女",
    "193043": "持有枕頭 狼人",
    "193044": "持有枕頭 殭屍",
    "193045": "持有枕頭 殭屍",
    "193047": "小棉花糖羊",
    "193048": "一般棉花糖羊",
    "193049": "巨大的棉花糖羊",
    "193050": "活動巨大的披著羊皮的狼",
    "193051": "巨大的披著羊皮的狼",
    "193052": "披著羊皮的狼",
    "193053": "棉花糖羊",
    "193054": "史萊姆天藍怪",
    "193055": "史萊姆天藍怪",
    "193056": "史萊姆天藍怪",
    "193057": "史萊姆天藍怪",
    "193058": "史萊姆天藍怪",
    "193059": "史萊姆天藍怪",
    "193060": "史萊姆天藍怪",
    "193061": "史萊姆天藍怪",
    "193062": "史萊姆天藍怪",
    "193063": "史萊姆天藍怪",
    "193064": "史萊姆天藍怪",
    "193065": "史萊姆天藍怪",
    "193066": "史萊姆天藍怪",
    "193067": "史萊姆天藍怪",
    "193068": "史萊姆天藍怪",
    "193069": "史萊姆天藍怪",
    "193070": "史萊姆天藍怪",
    "193071": "史萊姆天藍怪",
    "193072": "史萊姆天藍怪",
    "193073": "史萊姆天藍怪",
    "193074": "史萊姆天藍怪",
    "193075": "史萊姆天藍怪",
    "193076": "史萊姆天藍怪",
    "193077": "史萊姆天藍怪",
    "193078": "史萊姆天藍怪",
    "193079": "史萊姆天藍怪",
    "193080": "史萊姆天藍怪",
    "193081": "動物的痕跡",
    "193082": "史萊姆天藍怪",
    "193083": "史萊姆天藍怪",
    "193084": "史萊姆天藍怪",
    "193085": "史萊姆天藍怪",
    "193086": "史萊姆天藍怪",
    "193087": "史萊姆天藍怪",
    "193088": "史萊姆天藍怪",
    "193089": "史萊姆天藍怪",
    "193090": "史萊姆天藍怪",
    "193091": "史萊姆天藍怪",
    "193092": "史萊姆天藍怪",
    "193093": "史萊姆天藍怪",
    "193094": "史萊姆天藍怪",
    "193095": "動物們的痕跡",
    "193096": "史萊姆天藍怪",
    "193097": "史萊姆天藍怪",
    "193098": "史萊姆天藍怪",
    "193099": "史萊姆天藍怪",
    "193100": "史萊姆天藍怪",
    "193101": "史萊姆天藍怪",
    "193102": "史萊姆天藍怪",
    "193103": "史萊姆天藍怪",
    "193104": "史萊姆天藍怪",
    "193105": "史萊姆天藍怪",
    "193106": "史萊姆天藍怪",
    "193107": "史萊姆天藍怪",
    "193108": "史萊姆天藍怪",
    "193109": "史萊姆天藍怪",
    "193110": "史萊姆天藍怪",
    "193111": "史萊姆天藍怪",
    "193112": "史萊姆天藍怪",
    "193113": "史萊姆天藍怪",
    "193114": "史萊姆天藍怪",
    "193115": "史萊姆天藍怪",
    "193116": "史萊姆天藍怪",
    "193117": "史萊姆天藍怪",
    "193118": "史萊姆天藍怪",
    "193119": "史萊姆天藍怪",
    "193120": "史萊姆天藍怪",
    "193121": "史萊姆天藍怪",
    "193122": "史萊姆天藍怪",
    "193123": "史萊姆天藍怪",
    "193124": "史萊姆天藍怪",
    "193125": "史萊姆天藍怪",
    "193126": "史萊姆天藍怪",
    "193127": "史萊姆天藍怪",
    "193128": "史萊姆天藍怪",
    "193129": "史萊姆天藍怪",
    "193130": "史萊姆天藍怪",
    "193131": "史萊姆天藍怪",
    "193132": "史萊姆天藍怪",
    "193133": "動物的痕跡",
    "193134": "史萊姆天藍怪",
    "193135": "史萊姆天藍怪",
    "193136": "史萊姆天藍怪",
    "193137": "史萊姆天藍怪",
    "193138": "史萊姆天藍怪",
    "193139": "史萊姆天藍怪",
    "193140": "史萊姆天藍怪",
    "193141": "史萊姆天藍怪",
    "193142": "史萊姆天藍怪",
    "193143": "史萊姆天藍怪",
    "193144": "史萊姆天藍怪",
    "193145": "史萊姆天藍怪",
    "193146": "史萊姆天藍怪",
    "193147": "史萊姆天藍怪",
    "193148": "史萊姆天藍怪",
    "193149": "史萊姆天藍怪",
    "193150": "史萊姆天藍怪",
    "193151": "史萊姆天藍怪",
    "193152": "史萊姆天藍怪",
    "193153": "史萊姆天藍怪",
    "193154": "史萊姆天藍怪",
    "193155": "史萊姆天藍怪",
    "193156": "史萊姆天藍怪",
    "193157": "史萊姆天藍怪",
    "193158": "史萊姆天藍怪",
    "193159": "史萊姆天藍怪",
    "193160": "可疑的動物的痕跡",
    "193161": "拖拉機天藍怪",
    "193162": "拖拉機天藍怪",
    "193163": "人類",
    "193164": "氣球魁儡",
    "193165": "氣球魁儡",
    "193166": "氣球魁儡",
    "193167": "氣球魁儡",
    "193168": "氣球魁儡",
    "193169": "夏天的芙露亞",
    "193170": "比妮",
    "193171": "布雷迪安",
    "193172": "卡屋奈爾",
    "193173": "傑克·克魯奇",
    "193174": "靈魂",
    "193175": "靈魂",
    "193176": "靈魂",
    "193177": "村莊居民",
    "193178": "村莊居民",
    "193179": "村莊居民",
    "193180": "村莊居民",
    "193181": "村莊居民",
    "193182": "村莊居民",
    "193183": "管家",
    "193184": "傑克·克魯奇",
    "193185": "野蠻的靈魂",
    "193186": "野蠻的靈魂",
    "193187": "野蠻的靈魂",
    "193188": "布蘿妮",
    "193189": "南瓜",
    "193190": "被丟棄的神聖雙手劍",
    "193191": "南瓜",
    "193192": "布蘿妮",
    "193193": "棕色韓國短毛貓",
    "193194": "初級冒險家柯基",
    "193195": "部屬職員",
    "193196": "部屬職員",
    "193197": "路霸",
    "193198": "俄羅斯娃娃",
    "193199": "艾希",
    "193200": "洛根",
    "193201": "哥布林",
    "193202": "哥布林弓箭手",
    "193203": "巨大蜘蛛",
    "193204": "巨魔像",
    "193205": "食人魔戰士",
    "193206": "白龍",
    "193207": "布蘿妮",
    "193208": "白色大山貓",
    "193209": "紅色大山貓",
    "193210": "叢林蜈蚣",
    "193211": "蜻蜓",
    "193212": "威爾斯柯基",
    "193213": "紅熊貓",
    "193214": "撒拉布蘭道馬",
    "193220": "變異的實驗體",
    "193221": "紅色監獄殭屍",
    "193222": "綠色監獄殭屍",
    "193223": "藍色監獄殭屍",
    "193224": "影子任務透明怪物1",
    "193225": "影子任務透明怪物2",
    "193273": "藍色鬼魂之王",
    "193274": "紅色鬼魂之王",
    "193275": "鬼魂之王",
    "193350": "羅納溫",
    "193351": "冰凍的卡麗",
    "193352": "因斯加德",
    "193353": "格瓦斯戈夫",
    "193354": "史萊姆維尼",
    "193355": "梅西迪亞弗",
    "193356": "追隨者",
    "193357": "伊魯夏",
    "193358": "完成體格里斯貝恩",
    "193359": "終極格里斯貝恩",
    "193360": "甜點界的油輪甜蜜掃把",
    "193361": "砂糖的代謝劑棉花糖羊",
    "193362": "愛爾琳的石頭拳頭棉花糖",
    "193363": "街舞大師甜美餅乾",
    "193364": "伊魯夏",
    "193365": "追隨者",
    "193366": "追隨者",
    "193367": "勇猛的幽靈",
    "193368": "喀輪巴斯的痕跡",
    "193369": "佩洛姆",
    "193370": "布麗爾",
    "193371": "吉拉克",
    "193372": "在哭的幽靈",
    "193373": "備受驚嚇的幽靈",
    "193374": "沉默的幽靈",
    "193375": "發抖的幽靈",
    "193376": "站在懸崖的幽靈",
    "193377": "小精靈",
    "193378": "黑灰熊",
    "193379": "小精靈",
    "193380": "黑灰熊",
    "193381": "食人魔",
    "193382": "灰狼",
    "193383": "伊魯夏",
    "193384": "少年",
    "193385": "某個人",
    "193386": "某個人",
    "193387": "某個人",
    "193388": "某個自我",
    "193389": "某個少女",
    "193390": "艾萊斯特倫",
    "193391": "某個人",
    "193392": "某個人",
    "193393": "某個人",
    "193394": "小黑貓",
    "193395": "喀輪巴斯偵查隊員",
    "193396": "喀輪巴斯偵查隊員",
    "193397": "布麗爾",
    "193398": "追隨者",
    "193399": "羅納溫",
    "193400": "喀輪巴斯透明怪物",
    "193401": "巨大凱爾特小精靈",
    "193402": "佩洛姆",
    "193403": "冰凍的卡麗",
    "193404": "因斯加德",
    "193405": "格瓦斯戈夫",
    "193406": "史萊姆維尼",
    "193407": "梅西迪亞弗",
    "193408": "喀輪巴斯調查隊營地",
    "193409": "喀輪巴斯調查隊營地",
    "193410": "喀輪巴斯調查隊營地",
    "193411": "深淵的珠子",
    "193412": "追隨者",
    "193413": "羅納溫",
    "193414": "冰凍的卡麗",
    "193415": "因斯加德",
    "193416": "格瓦斯戈夫",
    "193417": "史萊姆維尼",
    "193418": "小雞",
    "193419": "黑暗的羅納溫",
    "193420": "黑暗的卡麗",
    "193421": "黑暗的因斯加德",
    "193422": "黑暗的格瓦斯戈夫",
    "193423": "黑暗的維尼",
    "193424": "黑暗的追隨者",
    "193425": "黑暗的追隨者",
    "193426": "黑暗的追隨者",
    "193427": "終極格里斯貝恩",
    "193428": "貝爾法斯特偵查隊員",
    "193429": "貝爾法斯特偵查隊員",
    "193430": "貝爾法斯特警衛隊員",
    "193431": "貝爾法斯特醫務隊員",
    "193432": "佩洛姆",
    "193433": "掠奪隊員",
    "193434": "掠奪隊員",
    "193435": "掠奪隊員",
    "193436": "小幽靈",
    "193437": "黑暗的冰頭怪",
    "193438": "紅光追隨者",
    "193439": "藍光追隨者",
    "193440": "白光追隨者",
    "193441": "黃光追隨者",
    "193442": "善於近距離的紅光追隨者",
    "193443": "善於遠距離的藍光追隨者",
    "193444": "善於魔法的白光追隨者",
    "193445": "對寵物脆弱的黃光追隨者",
    "193451": "克赫蓮",
    "193452": "粉紅色星星糖元素之魂",
    "193453": "黃色星星糖元素之魂",
    "193454": "綠色星星糖元素之魂",
    "193455": "紫色星星糖元素之魂",
    "193456": "狐狸洛特技能用透明怪物",
    "193457": "哥布林",
    "193458": "劇毒哥布林",
    "193459": "哥布林弓箭手",
    "193460": "黃金哥布林",
    "193461": "紅哥布林弓箭手",
    "193462": "紅哥布林",
    "193463": "哥布林獵人",
    "193464": "哥布林獵人弓箭手",
    "193465": "叢林哥布林戰士",
    "193466": "叢林哥布林弓箭手",
    "193467": "叢林哥布林咒術師",
    "193468": "叢林哥布林咒術師",
    "193469": "叢林哥布林咒術師",
    "193470": "叢林哥布林頭目",
    "193471": "巨魔像",
    "193472": "蜻蜓",
    "193473": "巨大蜻蜓",
    "193474": "棕蛇",
    "193475": "青蛇",
    "193476": "白蛇",
    "193477": "黑蛇",
    "193478": "綠蛇",
    "193479": "黑毒蛇",
    "193480": "白毒蛇",
    "193481": "紅毒蛇",
    "193482": "巨大白蛇",
    "193483": "巨大黑蛇",
    "193484": "鱷魚",
    "193485": "猛毒尖刺鱷魚",
    "193486": "蛇蜥",
    "193487": "巨鱷",
    "193488": "灰色搗蛋鬼",
    "193489": "綠色搗蛋鬼",
    "193490": "棕色搗蛋鬼",
    "193491": "狂暴翼魔",
    "193492": "雷電翼魔",
    "193493": "棕色遺跡翼魔",
    "193494": "黑色遺跡翼魔",
    "193495": "白色遺跡翼魔",
    "193496": "石像翼魔",
    "193497": "石像翼魔石座",
    "193498": "石頭翼魔",
    "193499": "炎魔",
    "193500": "科魯米納",
    "193501": "鎧甲骷髏",
    "193502": "鎧甲骷髏",
    "193503": "紅骷髏",
    "193504": "紅骷髏",
    "193505": "金屬骷髏",
    "193506": "金屬骷髏",
    "193507": "骷髏自爆兵",
    "193508": "骷髏地獄犬",
    "193509": "黑色鎧甲骷髏",
    "193510": "巨蛇士兵",
    "193511": "巨蛇咒術師",
    "193512": "巨蛇騎士",
    "193513": "銜尾蛇",
    "193514": "銜尾蛇",
    "193515": "銜尾蛇",
    "193516": "銜尾蛇",
    "193517": "殭屍",
    "193518": "殭屍",
    "193519": "食屍鬼",
    "193520": "食屍鬼",
    "193521": "灰色牢獄殭屍",
    "193522": "黑色牢獄殭屍",
    "193523": "白色牢獄殭屍",
    "193524": "人類",
    "193525": "虛無騎士",
    "193526": "虛無騎士",
    "193527": "鬼怪",
    "193528": "藍色鬼怪",
    "193529": "紅色鬼怪",
    "193530": "巫妖",
    "193531": "重生的巫妖",
    "193532": "骷髏死靈法師",
    "193533": "火焰魅魔",
    "193534": "雷電魅魔",
    "193535": "寒冰魅魔",
    "193536": "劇毒魅魔",
    "193537": "蘿莉魅魔",
    "193538": "遊魂",
    "193539": "鬼魂",
    "193540": "藍色鬼魂",
    "193541": "紅色鬼魂",
    "193542": "藍色鬼魂之王",
    "193543": "紅色鬼魂之王",
    "193544": "鬼魂之王",
    "193545": "骷髏幽靈",
    "193546": "綠色骷髏幽靈",
    "193547": "藍色骷髏幽靈",
    "193548": "紅色骷髏幽靈",
    "193549": "暗影鬼魂",
    "193550": "女妖",
    "193551": "魅魔女王",
    "193552": "法默思遺跡",
    "193553": "沙華魚人士兵",
    "193554": "沙華魚人鬥士",
    "193555": "沙華魚人遊俠",
    "193556": "沙華魚人戰士",
    "193557": "迷失沙華魚人",
    "193558": "淡水沙華魚人遊俠",
    "193559": "淡水沙華魚人鬥士",
    "193560": "洞穴沙華魚人魔法師",
    "193561": "洞穴沙華魚人戰士",
    "193562": "小精靈",
    "193563": "魔女",
    "193564": "梅魯",
    "193565": "火山蜥蜴",
    "193566": "火山蜥蜴",
    "193567": "火山犄角野豬",
    "193568": "地獄犬",
    "193569": "火蜥蜴",
    "193570": "伊弗烈特",
    "193571": "骸骨槍騎兵",
    "193572": "骸骨弓箭手",
    "193573": "骸骨戰士",
    "193574": "骷髏劇毒蜘蛛",
    "193575": "鎧甲骷髏食人魔",
    "193576": "全鎧甲骷髏食人魔",
    "193577": "不敗之劍",
    "193578": "都拉漢",
    "193579": "地獄馬",
    "193580": "幽靈軍鬥士",
    "193581": "幽靈軍戰士",
    "193582": "幽靈軍弓箭手",
    "193583": "半巫妖",
    "193584": "偽裝怪",
    "193585": "鬼魂偽裝怪",
    "193586": "夢靨",
    "193587": "黑色牢獄鬼魂",
    "193588": "鬼魂之鎧",
    "193589": "使用道具的掠奪者精靈",
    "193590": "使用道具的掠奪者人類",
    "193591": "使用道具的掠奪者巨人",
    "193592": "使用道具的掠奪團頭目",
    "193593": "生疏的掠奪者人類",
    "193594": "見習掠奪者精靈",
    "193595": "見習掠奪者精靈",
    "193596": "見習掠奪者人類",
    "193597": "見習掠奪者巨人",
    "193598": "見習掠奪團頭目",
    "193599": "見習掠奪團頭目",
    "193600": "見習掠奪團頭目",
    "193601": "2年資歷的掠奪者精靈",
    "193602": "2年資歷的掠奪者精靈",
    "193603": "2年資歷的掠奪者人類",
    "193604": "2年資歷的掠奪者巨人",
    "193605": "2年資歷的掠奪團頭目",
    "193606": "2年資歷的掠奪團頭目",
    "193607": "2年資歷的掠奪團頭目",
    "193608": "熟能生巧的掠奪者精靈",
    "193609": "熟能生巧的掠奪者精靈",
    "193610": "熟能生巧的掠奪者人類",
    "193611": "熟能生巧的掠奪者巨人",
    "193612": "熟能生巧的掠奪團頭目",
    "193613": "熟能生巧的掠奪團頭目",
    "193614": "熟能生巧的掠奪團頭目",
    "193615": "老練的掠奪者精靈",
    "193616": "老練的掠奪者精靈",
    "193617": "老練的掠奪者人類",
    "193618": "老練的掠奪者巨人",
    "193619": "老練的掠奪團頭目",
    "193620": "老練的掠奪團頭目",
    "193621": "老練的掠奪團頭目",
    "193622": "一流掠奪者精靈",
    "193623": "一流掠奪者精靈",
    "193624": "一流掠奪者人類",
    "193625": "一流掠奪者巨人",
    "193626": "一流掠奪團頭目",
    "193627": "一流掠奪團頭目",
    "193628": "一流掠奪團頭目",
    "193629": "老練的掠奪者精靈",
    "193630": "老練的掠奪者精靈",
    "193631": "老練的掠奪者人類",
    "193632": "老練的掠奪者巨人",
    "193633": "一流掠奪者精靈",
    "193634": "一流掠奪者精靈",
    "193635": "一流掠奪者人類",
    "193636": "一流掠奪者巨人",
    "193637": "孤獨的芬頓",
    "193638": "欠債的帕德里加",
    "193639": "做夢的德柏赫爾",
    "193640": "優雅的克里斯圖",
    "193641": "正直的莫爾",
    "193642": "心煩的歐因",
    "193643": "那個兔子",
    "193644": "孤獨的芬頓",
    "193645": "欠債的帕德里加",
    "193646": "做夢的德柏赫爾",
    "193647": "優雅的克里斯圖",
    "193648": "正直的莫爾",
    "193649": "心煩的歐因",
    "193650": "那個兔子",
    "193690": "妖魔芬",
    "193691": "妖魔坤",
    "193695": "伊魯夏",
    "193696": "小巨魔像",
    "193697": "糖寶王哇咖-恰嘎",
    "193698": "巨大薑餅人",
    "193699": "塔巴勒塔斯",
    "193700": "巨大黑梨鼠",
    "193701": "不敗之劍",
    "193702": "黑暗魅魔",
    "193703": "劇毒魅魔",
    "193704": "公爵",
    "193705": "死神",
    "193706": "悲嘆之歌",
    "193707": "大師巫妖",
    "193708": "被黑暗吞噬的加奈芃",
    "193709": "魅魔女王",
    "193710": "小巨魔像",
    "193711": "糖寶王哇咖-恰嘎",
    "193712": "巨大薑餅人",
    "193713": "塔巴勒塔斯",
    "193714": "巨大黑梨鼠",
    "193715": "不敗之劍",
    "193716": "黑暗魅魔",
    "193717": "劇毒魅魔",
    "193718": "公爵",
    "193719": "死神",
    "193720": "悲嘆之歌",
    "193721": "大師巫妖",
    "193722": "被黑暗吞噬的加奈芃",
    "193723": "魅魔女王",
    "193724": "伊魯夏",
    "193725": "加奈芃的黑暗魔杖",
    "193729": "哈西汀",
    "193730": "黑暗鼠人",
    "193731": "小嘍囉",
    "193732": "小嘍囉",
    "193733": "小嘍囉",
    "194000": "伊萬",
    "194001": "秘密的吟遊詩人",
    "194002": "伊萬",
    "194003": "亞倫",
    "194004": "亞倫",
    "194005": "記憶之鐘",
    "194006": "珊",
    "194007": "黑人",
    "194008": "內心之鏡",
    "194009": "亞倫",
    "194010": "內心之鏡",
    "194011": "雪鴞",
    "194012": "貓頭鷹",
    "194013": "亞倫",
    "194014": "亞倫",
    "194016": "失去光芒的記憶之鐘",
    "194017": "尤恩",
    "194018": "納莉",
    "194019": "尤恩",
    "194020": "納莉",
    "194021": "蔬果店",
    "194022": "魚肉舖",
    "194023": "透明",
    "194024": "公會石",
    "194025": "智能販賣機1號",
    "194026": "年邁的書中精靈",
    "194027": "書中的精靈",
    "194028": "書中的精靈",
    "194029": "傑茨",
    "194030": "白蜘蛛",
    "194031": "紅蜘蛛",
    "194032": "田鼠",
    "194033": "蝙蝠",
    "194034": "食屍鬼",
    "194035": "鬼魂偽裝怪",
    "194036": "藍色鬼魂",
    "194037": "紅色鬼魂",
    "194038": "巨大飛蛾",
    "194039": "半巫妖",
    "194040": "雷諾",
    "194041": "貝伊",
    "194042": "信",
    "194043": "雷諾",
    "194044": "貝伊",
    "194045": "信",
    "194047": "書中的精靈",
    "194051": "南瓜",
    "194052": "持有枕頭 闇黑巫師",
    "194053": "持有枕頭 暗黑戰士",
    "194054": "持有枕頭 黑魅魔",
    "194055": "持有枕頭 紅魅魔",
    "194056": "持有枕頭 魔女",
    "194057": "持有枕頭 屍妖",
    "194058": "持有枕頭 食屍鬼",
    "194059": "持有枕頭 惡翅魅魔",
    "194060": "持有枕頭 惡翅魅魔",
    "194061": "持有枕頭 貓妖精騎士",
    "194062": "持有枕頭 貓妖精騎士",
    "194063": "持有枕頭 暗影巫師",
    "194064": "持有枕頭 暗影巫師",
    "194065": "持有枕頭 暗影鍊金術師",
    "194066": "持有枕頭 冰鏡魔女",
    "194067": "持有枕頭 狼人",
    "194068": "持有枕頭 殭屍",
    "194069": "持有枕頭 殭屍",
    "194070": "凱薩兔",
    "194071": "凱薩兔",
    "194072": "投籃高手",
    "194076": "邊境牧羊犬",
    "194077": "任務用透明人",
    "194078": "尼爾",
    "194079": "迪莉妮",
    "194080": "占星術師帳篷",
    "194081": "尼爾",
    "194082": "星之祭壇",
    "194083": "營火",
    "194084": "尼爾",
    "194085": "迪莉妮",
    "194086": "負面的思緒",
    "194087": "尼爾",
    "194088": "迪莉妮",
    "194089": "皮納塔小馬",
    "194090": "皮納塔香氣熊",
    "194091": "皮納塔伊魯夏",
    "194092": "皮納塔小馬",
    "194093": "皮納塔香氣熊",
    "194094": "皮納塔伊魯夏",
    "194095": "飢餓貪吃鬼兔子",
    "194096": "人類男性模型",
    "194097": "人類女性模型",
    "194098": "精靈男性模型",
    "194099": "精靈女性模型",
    "194100": "巨人男性模型",
    "194101": "巨人女性模型",
    "195000": "吸血蝙蝠",
    "195001": "田鼠",
    "195002": "鎧甲骷髏",
    "195003": "紅骷髏",
    "195004": "金屬骷髏",
    "195005": "闇黑巫師",
    "195006": "鬼魂之鎧",
    "195007": "雷電翼魔",
    "195008": "狂暴翼魔",
    "195009": "錫古的追隨者",
    "195010": "錫古的追隨者",
    "195011": "錫古的追隨者",
    "195012": "魅魔女王",
    "195013": "被渲染成黑色的玫瑰",
    "195015": "紅魅魔露潔芬",
    "195016": "白魅魔愛里娜",
    "195017": "黃魅魔菲安",
    "195018": "粉紅魅魔克蘿拉",
    "195019": "紅魅魔露潔芬",
    "195020": "白魅魔愛里娜",
    "195021": "黃魅魔菲安",
    "195022": "粉紅魅魔克蘿拉",
    "200001": "黃色珍島犬",
    "200002": "白色珍島犬",
    "200003": "黃色珍島犬",
    "200011": "可卡犬",
    "200012": "花色長耳雷犬",
    "200013": "白色長耳雷犬",
    "200014": "花色長耳雷犬",
    "200015": "花色長耳雷犬",
    "200016": "花色長耳雷犬",
    "200021": "阿富汗獵犬",
    "200031": "白貴賓狗",
    "200032": "紅貴賓狗",
    "200033": "粉紅貴賓狗",
    "200101": "黃金獵犬",
    "200102": "拉不拉多拾獵犬",
    "200201": "大麥町",
    "200301": "邊境牧羊犬",
    "200401": "薩摩耶犬",
    "200402": "薩摩耶犬",
    "200403": "薩摩耶犬",
    "200404": "薩摩耶犬",
    "200501": "迷你杜賓犬",
    "200601": "灰狗",
    "200701": "蘇俄牧羊犬",
    "200801": "哈士奇",
    "200802": "阿拉斯加雪橇犬",
    "200803": "愛斯基摩雪橇犬",
    "200804": "愛斯基摩雪橇犬",
    "200805": "愛斯基摩雪橇犬",
    "200806": "愛斯基摩雪橇犬",
    "200807": "阿拉斯加雪橇犬",
    "200808": "愛斯基摩雪橇犬",
    "200901": "瑪比的可愛狗狗",
    "201001": "黃色韓國短毛貓",
    "201002": "棕色韓國短毛貓",
    "201003": "棕色韓國短毛貓",
    "201101": "標準日本短尾貓",
    "201201": "淺色俄羅斯藍貓",
    "201202": "暗色俄羅斯藍貓",
    "201203": "婚禮黑俄羅斯貓",
    "201301": "孟買貓",
    "201302": "幽靈貓",
    "201303": "古代沙漠守護者",
    "201304": "古代沙漠戰士",
    "201305": "古代沙漠守護者",
    "201306": "古代沙漠戰士",
    "201307": "夜之誓約貓咪娃娃",
    "201308": "夜之誓約兔子娃娃",
    "201309": "日月之神太陽之狼",
    "201310": "日月之神月亮貓咪",
    "201311": "愛爾琳信差熊玩偶",
    "201312": "愛爾琳信差沙漠狐狸玩偶",
    "201401": "孟加拉貓",
    "201501": "暹羅貓",
    "201601": "波斯貓",
    "201602": "波斯貓",
    "201603": "婚禮波絲貓",
    "201701": "流浪小貓",
    "201702": "길고양이",
    "201703": "길고양이",
    "201704": "길고양이",
    "201705": "길고양이",
    "201706": "길고양이",
    "201707": "길고양이",
    "201708": "마을고양이",
    "201801": "流浪小狗",
    "201901": "壞壞喵",
    "201902": "呆呆喵",
    "202001": "棕狐狸",
    "202101": "銀狐狸",
    "202201": "九尾狐",
    "202202": "九尾狐",
    "202203": "축제 훼방꾼 여우님",
    "202204": "축제 훼방꾼 여우님",
    "203001": "灰狼",
    "203101": "黑狼",
    "203102": "黑狼",
    "204001": "乳牛",
    "204002": "黃牛",
    "204003": "白牛",
    "204004": "대박나소",
    "204101": "幸運草藥草牛羚",
    "205001": "白羊",
    "205002": "黑綿羊",
    "206001": "火花紋白蜘蛛",
    "206101": "劇毒蜘蛛",
    "206201": "守護蜘蛛",
    "207001": "香料豬",
    "207101": "幸運草藥草豬",
    "207201": "幼小野豬",
    "207301": "金豬",
    "208001": "白化帝王蛇",
    "208101": "沙漠眼鏡蛇",
    "208102": "珊瑚眼鏡蛇",
    "210001": "迷你熊",
    "210002": "貝雅熊",
    "210003": "熊貓",
    "210004": "紅熊貓",
    "210005": "北極熊",
    "210006": "聖誕熊",
    "210007": "베야야 (이벤트)",
    "210008": "迷你熊抱",
    "210101": "小貓熊",
    "210102": "小貓熊",
    "213011": "冰晶土狼",
    "220001": "白刺蝟",
    "220002": "黑刺蝟",
    "220003": "雪原刺蝟",
    "230001": "白雪貂",
    "230002": "黑雪貂",
    "240001": "藍知更鳥",
    "240002": "烏鴉",
    "240003": "獵鷹",
    "240004": "金翅雀",
    "240005": "八色鳥",
    "240006": "翠鳥",
    "240007": "小蛋黃",
    "240008": "小檸檬",
    "240009": "小彩虹",
    "240010": "藍知更鳥",
    "240011": "八色鳥",
    "240012": "雪鴞",
    "240013": "八色鳥",
    "240014": "八色鳥",
    "240015": "八色鳥",
    "240016": "雪鴞",
    "240017": "雪鴞",
    "240018": "雪鴞",
    "240101": "河烏",
    "240201": "黑頭蒿雀",
    "240301": "鴿子",
    "240302": "鴿子",
    "240303": "藍知更鳥",
    "240304": "獵鷹",
    "240305": "金翅雀",
    "240306": "八色鳥",
    "250001": "地獄貓",
    "251001": "火蜥蜴",
    "251002": "翠綠蜥蜴",
    "251003": "黑曜蜥蜴",
    "251004": "火蜥蜴",
    "251101": "綠色森林蜥蜴",
    "251102": "黑色森林蜥蜴",
    "251103": "白色森林蜥蜴",
    "251104": "棕色森林蜥蜴",
    "251105": "金色森林蜥蜴",
    "251106": "金色森林蜥蜴",
    "251201": "仙人掌蜥蜴",
    "251202": "幼小仙人掌蜥蜴",
    "251203": "仙人掌蜥蜴",
    "251301": "克諾斯蜥蜴",
    "251302": "克諾斯蜥蜴王",
    "251401": "鱷魚",
    "251402": "巨鱷",
    "251501": "火山蜥蜴",
    "251502": "火山蜥蜴",
    "251503": "火山蜥蜴",
    "251508": "火山蜥蜴",
    "251601": "蛇蜥",
    "251602": "蛇蜥",
    "251701": "鬣蜥",
    "251702": "鬣蜥",
    "251703": "鬣蜥",
    "251704": "鬣蜥",
    "252001": "食人魔戰士",
    "252002": "食人魔戰士",
    "252003": "食人魔戰士",
    "252004": "食人魔戰士",
    "252005": "食人魔戰士",
    "252006": "藍色搗蛋鬼之王",
    "252007": "粉紅搗蛋鬼之王",
    "252008": "藍色搗蛋鬼之王",
    "252009": "粉紅搗蛋鬼之王",
    "252010": "綠色搗蛋鬼之王",
    "252011": "藍色搗蛋鬼之王",
    "252012": "粉紅搗蛋鬼之王",
    "252013": "綠色搗蛋鬼之王",
    "252014": "白色搗蛋鬼之王",
    "252015": "黑色搗蛋鬼之王",
    "252016": "狼人",
    "252017": "藍色搗蛋鬼之王",
    "252018": "粉紅搗蛋鬼之王",
    "252019": "綠色搗蛋鬼之王",
    "252020": "狼人",
    "252021": "地獄犬",
    "252022": "巨大骷髏地獄犬",
    "252023": "骷髏吟遊詩人",
    "252024": "地獄犬",
    "252025": "金屬骷髏吟遊詩人",
    "252026": "哥布林弓箭手",
    "252027": "黑魅魔",
    "252028": "哥布林",
    "252029": "紅魅魔",
    "252030": "黑魅魔",
    "252031": "白魅魔",
    "252032": "黃魅魔",
    "252033": "粉紅魅魔",
    "252034": "黑魅魔",
    "252035": "黃魅魔",
    "252036": "骷髏妖魔",
    "252037": "骷髏劇毒蜘蛛",
    "252038": "黃魅魔",
    "252039": "紅魅魔",
    "252040": "黃魅魔",
    "252041": "巨大雷電之魂",
    "252042": "黑魅魔",
    "252043": "紅魅魔",
    "252044": "紅魅魔",
    "252045": "萊肯",
    "252046": "萊肯",
    "252047": "黑魅魔",
    "252048": "骷髏妖魔",
    "252049": "骷髏劇毒蜘蛛",
    "252050": "巨大無頭怪",
    "252052": "綠色搗蛋鬼",
    "252053": "巨大無頭怪",
    "252055": "巨大無頭怪",
    "252056": "巨大火焰之魂",
    "252057": "獨眼巨人",
    "252058": "骷髏",
    "252059": "獨眼巨人",
    "252060": "魔劍",
    "252061": "骷髏船長",
    "252062": "貓妖精騎士",
    "252063": "貓妖精騎士",
    "252064": "貓妖精騎士",
    "252065": "貓妖精騎士",
    "252066": "獨眼巨人",
    "252067": "魔劍",
    "252068": "骷髏船長",
    "252069": "貓妖精騎士",
    "252070": "貓妖精騎士",
    "252071": "貓妖精騎士",
    "252072": "貓妖精騎士",
    "252073": "小巨魔像",
    "252074": "魔劍",
    "252075": "鎧甲熊",
    "252076": "小巨魔像",
    "252077": "綠色搗蛋鬼",
    "252078": "百眼巨人",
    "252079": "百眼巨人",
    "252080": "百眼巨人",
    "252081": "狼人",
    "252082": "巨大妖魔",
    "252083": "黑梨鼠",
    "252084": "半巫妖",
    "252085": "地獄貓",
    "252086": "女妖",
    "252087": "藍色鬼怪",
    "252088": "紅色鬼怪",
    "252089": "巫妖",
    "252090": "巨大蜘蛛",
    "252091": "紅蜘蛛",
    "252092": "奧拉克妮",
    "252093": "緋紅蜘蛛",
    "252094": "巨大黃金蜘蛛",
    "252095": "巨大黃金蜘蛛",
    "252096": "蜘蛛戰士",
    "252097": "巨大蜘蛛",
    "252098": "紅蜘蛛",
    "252099": "巨大紅蜘蛛",
    "252101": "萊肯",
    "252102": "戈耳戈",
    "252103": "奧拉克妮",
    "252104": "綻藍蜘蛛",
    "252105": "巨大紅蜘蛛",
    "252106": "綻藍蜘蛛",
    "252107": "巨大黑蜘蛛",
    "252109": "萊肯",
    "252110": "戈耳戈",
    "252111": "巨大黑蜘蛛",
    "252112": "巨大紅蜘蛛",
    "252113": "巨大白蜘蛛",
    "252114": "緋紅蜘蛛",
    "252115": "巨魔像",
    "252116": "金屬骷髏",
    "252117": "巨魔像",
    "252118": "暗黑鼠人",
    "252119": "巨魔像",
    "252120": "巨魔像",
    "252121": "巨大雷電之魂",
    "252122": "巨大雷電之魂",
    "252123": "巨魔像",
    "252124": "巨魔像",
    "252125": "巨魔像",
    "252126": "巨魔像",
    "252127": "巨魔像",
    "252128": "金屬骷髏",
    "252129": "金屬骷髏",
    "252130": "巨魔像",
    "252131": "巨魔像",
    "252132": "巨大雷電之魂",
    "252133": "巨魔像",
    "252134": "金屬骷髏",
    "252135": "巨魔像",
    "252136": "巨魔像",
    "252137": "巨魔像",
    "252138": "巨魔像",
    "252139": "金屬骷髏",
    "252140": "獨眼巨人",
    "252141": "金屬骷髏",
    "252142": "金屬骷髏吟遊詩人",
    "252143": "小巨魔像",
    "252144": "魔劍",
    "260001": "哈佛林格馬",
    "260002": "撒拉布蘭道馬",
    "260003": "夏爾馬",
    "260004": "獨角獸",
    "260005": "闇黑獨角獸",
    "260006": "獨角獸",
    "260007": "騎士競技大賽用馬",
    "260008": "騎士競技大賽用馬",
    "260009": "騎士競技大賽用馬",
    "260010": "王城馬",
    "260011": "撒拉布蘭道馬 (可選色)",
    "260012": "夏爾馬 (可選色)",
    "260013": "獨角獸 (可選色)",
    "260014": "迷你獨角獸",
    "260015": "서러브레드 (기간 제한)",
    "260016": "免費撒拉布蘭道馬(7日)",
    "260017": "新手用馬",
    "260018": "歸來的米列希安的獨角獸",
    "260019": "騎士競技大會用馬",
    "260020": "騎士競技大會用馬",
    "260021": "騎士競技大會用馬",
    "260022": "騎士競技大會用馬",
    "260023": "騎士競技大會用馬",
    "260024": "騎士競技大會用馬",
    "260025": "騎士競技大會用馬",
    "260026": "騎士競技大會用馬",
    "260027": "騎士競技大會用馬",
    "260028": "騎士競技大會用馬",
    "260101": "野生馬",
    "260102": "野生馬",
    "260103": "野生馬",
    "260104": "野生馬",
    "260105": "野生馬",
    "260106": "野生馬",
    "260107": "野生馬",
    "260108": "野生馬",
    "260109": "野生馬",
    "260110": "野生馬",
    "260111": "野生馬",
    "260112": "野生馬",
    "260113": "軍馬",
    "260114": "活動獨角獸 (可選色)",
    "260115": "活動獅鷲獸",
    "260116": "探險隊的馬",
    "270001": "石頭戰馬",
    "270101": "遺跡守護馬",
    "270102": "遺跡守護馬",
    "270201": "棕色伊克西翁",
    "270202": "白鹿",
    "270203": "黑鹿",
    "270301": "夜遊魂",
    "270401": "黃色羊駝",
    "270402": "白頭羊駝",
    "270403": "거대 노란 라마",
    "270501": "斑馬",
    "270502": "暗影夏爾馬",
    "270503": "暗影夏爾馬",
    "270504": "黑馬",
    "270505": "黑馬",
    "270506": "石頭寶箱怪",
    "270507": "黑馬",
    "270508": "古老的 冰雪寶箱怪",
    "270509": "石頭寶箱怪",
    "270510": "地獄馬",
    "270511": "地獄馬",
    "270512": "暗影夏爾馬",
    "270513": "火馬(紅色火焰)",
    "270514": "輸送馬車",
    "270515": "輸送馬車",
    "270516": "輸送馬車",
    "270517": "輸送馬車",
    "270518": "輸送馬車",
    "270519": "火馬(藍色火焰)",
    "270520": "火馬(白色火焰)",
    "270521": "火馬(黑色火焰)",
    "270522": "블랙 플레임메어",
    "270523": "火馬(黑色火焰)",
    "270524": "古老的 沙漠寶箱怪",
    "270525": "塔爾汀遠征隊補給馬車",
    "270526": "塔爾汀遠征隊補給馬車",
    "270527": "塔爾汀遠征隊補給馬車",
    "270528": "塔爾汀遠征隊補給馬車",
    "270529": "塔爾汀遠征隊補給馬車",
    "270530": "闇黑巫師",
    "270531": "掠奪團 輸送馬車",
    "270532": "掠奪團 輸送馬車",
    "270533": "掠奪團 輸送馬車",
    "270534": "掠奪團 輸送馬車",
    "270535": "掠奪團 輸送馬車",
    "270536": "暗影夏爾馬",
    "270601": "羊駝",
    "270602": "聖誕羊駝",
    "270603": "情人羊駝",
    "270701": "殭屍寶寶",
    "270702": "殭屍寶寶",
    "270703": "慶典搗蛋鬼 殭屍寶寶",
    "270704": "慶典搗蛋鬼 殭屍寶寶",
    "270705": "忠實粉小鬼殭屍",
    "270706": "小聖誕殭屍",
    "270707": "小聖誕殭屍",
    "270801": "고릴라",
    "270802": "고릴라",
    "270901": "마스터 셰프의 포장마차",
    "270902": "夢幻餐車",
    "270903": "精靈芙蘿菈",
    "270904": "활발한 플로라",
    "270905": "차분한 플로라",
    "271001": "可愛鬥牛犬",
    "271101": "可愛暹羅貓",
    "271201": "可愛折耳貓",
    "271301": "可愛黃金獵犬",
    "271401": "青馬",
    "271402": "青馬",
    "271403": "블랙 플레임메어(30일)",
    "271404": "화이트 플레임메어(30일)",
    "271405": "블루 플레임메어(30일)",
    "271406": "레드 플레임메어(30일)",
    "271407": "妖魔",
    "271408": "妖魔",
    "271409": "妖魔",
    "271410": "妖魔",
    "271411": "妖魔",
    "271412": "妖魔",
    "271413": "妖魔",
    "271414": "尼歐",
    "271415": "露艾",
    "271416": "歐麗芙",
    "271417": "斯卡",
    "271418": "夏米勒",
    "271419": "艾爾菲",
    "271420": "安比",
    "271421": "粉紅色星星糖",
    "271422": "黃色星星糖",
    "271423": "綠色星星糖",
    "271424": "紫色星星糖",
    "271425": "具威脅性的棕熊",
    "271426": "具威脅性的狼",
    "271427": "具威脅性的野豬",
    "271428": "有月亮碎片的熊",
    "271429": "漫步太空植栽精靈",
    "271430": "受到威脅的兔子",
    "271432": "需要幫助的小貓",
    "271433": "愛的觔斗雲",
    "271434": "浪漫馬車",
    "271435": "伊恩",
    "271436": "艾蜜莉亞",
    "271437": "蓓塔",
    "271438": "萊文",
    "271439": "魅魔杜巴莎",
    "271441": "蓓塔",
    "271442": "迷你骷髏",
    "271443": "迷你骷髏",
    "271444": "迷你骷髏",
    "271445": "迷你骷髏",
    "271446": "蓓塔",
    "271447": "迷你骷髏",
    "271448": "迷你骷髏",
    "271449": "迷你骷髏",
    "271450": "迷你骷髏",
    "271451": "迷你骷髏",
    "271452": "貓咪村莊金斯",
    "271454": "水球",
    "271455": "練習用卡丁車",
    "271457": "可疑的門",
    "271458": "長老斯坦",
    "271459": "芙莉蓮",
    "271460": "芙莉蓮",
    "271461": "芙莉蓮",
    "271462": "芙莉蓮",
    "271463": "芙莉蓮",
    "271464": "芙莉蓮",
    "271465": "芙莉蓮",
    "271466": "費倫",
    "271467": "費倫",
    "271468": "費倫",
    "271469": "費倫",
    "271470": "修塔爾克",
    "271471": "修塔爾克",
    "271472": "修塔爾克",
    "271473": "修塔爾克",
    "271474": "修塔爾克",
    "271475": "修塔爾克",
    "271476": "某人的銅像",
    "271486": "歐哈德",
    "271487": "浣熊",
    "280001": "綠色食蟲植物",
    "280002": "黃色食蟲植物",
    "280003": "粉紅食蟲植物",
    "280004": "紅色食蟲植物",
    "280101": "蜘蛛絲木乃伊",
    "280102": "蜘蛛絲木乃伊",
    "290001": "跳跳鼠",
    "290002": "金包鼠",
    "290101": "加卡利亞鼠",
    "290102": "加卡利亞鼠",
    "290103": "鼠人",
    "290104": "迷你加卡利亞鼠",
    "300001": "巨大沙蟲",
    "300002": "平原龍",
    "300003": "沙漠龍",
    "300004": "活動 沙漠龍",
    "300005": "活動 平原龍",
    "310001": "毒針沙漠蠍子",
    "310002": "紅色沙漠蠍子",
    "310003": "藍色沙漠蠍子",
    "310004": "黑色沙漠蠍子",
    "310101": "毒針岩石蠍子",
    "310102": "白色岩石蠍子",
    "310103": "灰色岩石蠍子",
    "310201": "鍬形蟲",
    "310202": "鍬形蟲",
    "310301": "火山岩石蠍子",
    "310302": "火山岩石蠍子",
    "310307": "火山岩石蠍子",
    "320001": "章魚",
    "330001": "棕色山羊",
    "330002": "白色山羊",
    "330101": "火山口山羊",
    "330102": "火山口山羊",
    "340103": "幼小藍眉國王企鵝",
    "340104": "藍眉國王企鵝",
    "340201": "國王企鵝",
    "340202": "阿德利企鵝",
    "340203": "淘氣的白企鵝",
    "340204": "淘氣的黑企鵝",
    "340205": "淘氣的紅企鵝",
    "340206": "攝影機企鵝H",
    "340207": "攝影機企鵝P",
    "350001": "雪人",
    "350002": "中毒的 大腳怪",
    "350003": "治療中的 大腳怪",
    "360001": "長毛象",
    "360101": "小象",
    "360102": "大象",
    "360103": "小象",
    "360104": "大象",
    "370001": "木製寶箱",
    "370002": "古董寶箱",
    "370003": "古董寶箱",
    "380001": "白兔",
    "380002": "棕兔",
    "380003": "巨大白兔",
    "380004": "巨大棕兔",
    "380005": "黑兔",
    "380006": "棕色斧頭",
    "380007": "基因突變兔子",
    "380008": "基因突變兔子",
    "390001": "棕色鴕鳥",
    "390002": "黑色鴕鳥",
    "390003": "白羽鴕鳥",
    "390004": "黑翼鴕鳥",
    "400001": "食蟲植物",
    "400002": "食蟲植物",
    "400003": "食蟲植物",
    "400004": "基因突變食蟲植物種子",
    "400005": "基因突變食蟲植物",
    "400101": "食蟲植物",
    "410001": "蜻蜓",
    "410002": "巨大蜻蜓",
    "410003": "巨大蜻蜓",
    "420001": "水獺",
    "430001": "雷鳥",
    "430002": "航空攝影隊T",
    "430003": "7週年紀念迷你雷鳥",
    "430004": "迷你雷鳥",
    "430005": "迷你雷鳥",
    "430101": "老鷹",
    "430102": "航空攝影隊E",
    "430103": "新手用老鷹",
    "430201": "大嘴鳥",
    "430202": "航空攝影隊P",
    "430203": "藍腳鰹鳥",
    "430204": "藍腳鰹鳥",
    "430205": "藍腳鰹鳥",
    "430206": "藍腳鰹鳥",
    "430207": "藍腳鰹鳥",
    "430301": "獅鷲獸",
    "430401": "安巴爾",
    "430402": "安巴爾",
    "430403": "安巴爾",
    "430404": "安巴爾",
    "430405": "安巴爾",
    "430406": "安巴爾",
    "430407": "安巴爾",
    "430408": "安巴爾",
    "430409": "安巴爾",
    "430410": "安巴爾",
    "430411": "安巴爾",
    "430412": "安巴爾",
    "430413": "安巴爾",
    "430414": "安巴爾",
    "430415": "安巴爾",
    "430501": "雷龍 (龍騎士套餐)",
    "430502": "火龍 (龍騎士套餐)",
    "430503": "雷龍",
    "430504": "火龍",
    "430505": "冰龍",
    "430506": "아이스 드래곤 (이벤트)",
    "430510": "雷龍 (2人用)",
    "430511": "썬더 드래곤 (2인승)(드래곤 라이더 세트))",
    "430512": "黑帝斯",
    "430513": "아이스 드래곤 (이벤트)",
    "430514": "파이어 드래곤 (이벤트)",
    "430515": "썬더 드래곤 (이벤트)",
    "430516": "아이스 드래곤 (이벤트)",
    "430517": "파이어 드래곤 (이벤트)",
    "430518": "썬더 드래곤 (이벤트)",
    "430519": "하데스 (이벤트)",
    "430520": "하데스 (이벤트)",
    "430521": "冰龍(活動)",
    "430522": "썬더 드래곤 (이벤트)",
    "430523": "파이어 드래곤 (이벤트)",
    "440001": "獅子",
    "440002": "活動 獅子",
    "440101": "母獅子",
    "440102": "巨大母獅子",
    "440103": "活動巨大母獅子",
    "440201": "巨大獅子",
    "440202": "活動巨大獅子",
    "440301": "黑豹",
    "440302": "黑豹",
    "440303": "活動 黑豹",
    "440304": "유령 흑표범",
    "440311": "豹",
    "440401": "幼小老虎",
    "440402": "幼小白虎",
    "440501": "西伯利亞老虎",
    "440502": "白虎座騎",
    "440504": "지상촬영팀T",
    "440505": "野生老虎",
    "440506": "野生白虎",
    "440507": "雲豹",
    "440508": "雲豹",
    "440509": "野生白虎",
    "440510": "野生白虎",
    "440511": "雲豹",
    "440512": "雲豹",
    "440513": "雲豹",
    "440514": "鳳凰",
    "440515": "藍鳳凰",
    "440516": "白鳳凰",
    "440517": "白鳳凰(期間制)",
    "440518": "藍鳳凰(期間制)",
    "440519": "블루 피닉스(30일)",
    "440520": "화이트 피닉스(30일)",
    "440521": "黑虎",
    "440522": "幼年黑虎",
    "450101": "梅花鹿",
    "450102": "玫瑰花環梅花鹿",
    "450201": "角鹿",
    "450202": "阿蘭特馴鹿",
    "450203": "阿蘭特馴鹿",
    "450204": "阿蘭特馴鹿",
    "450301": "巨角駝鹿",
    "450401": "尖角駝鹿",
    "450501": "公鹿",
    "450502": "母鹿",
    "450503": "小鹿",
    "450504": "公鹿",
    "450505": "母鹿",
    "450506": "小鹿",
    "450601": "水晶馴鹿",
    "460001": "食蟻獸",
    "460101": "火焰飛龍",
    "460102": "火焰飛龍",
    "460103": "火焰飛龍",
    "460104": "火焰飛龍",
    "460201": "閃電飛龍",
    "460202": "閃電飛龍",
    "460203": "閃電飛龍",
    "460204": "閃電飛龍",
    "460205": "閃電飛龍",
    "460301": "寒冰飛龍",
    "460302": "寒冰飛龍",
    "460303": "寒冰飛龍",
    "460304": "寒冰飛龍",
    "460305": "寒冰飛龍",
    "470001": "迷你骷髏",
    "470002": "冰雪骷髏",
    "470003": "迷你骷髏",
    "470101": "小幽靈",
    "470102": "小幽靈",
    "471001": "女僕骷髏",
    "471002": "探險家短毛貓",
    "471003": "花瓣杜賓犬",
    "471004": "女僕骷髏",
    "471005": "鯊魚長袍海狗",
    "471006": "女僕骷髏",
    "471007": "鯊魚長袍海狗",
    "471008": "粉紅雲豹",
    "471009": "彩虹筋斗雲",
    "471010": "白熊帽子海狗",
    "471011": "高筒帽海狗",
    "471012": "慶典哥布林",
    "471013": "慶典哥布林",
    "471014": "慶典哥布林",
    "471015": "小幽靈艾菲",
    "471016": "慶典哥布林",
    "471017": "花瓣杜賓犬",
    "471018": "暗黑雲豹",
    "471019": "海藍雲豹",
    "471020": "草綠雲豹",
    "471021": "紫羅蘭雲豹",
    "471022": "雪白雲豹",
    "480001": "紅色巨龍",
    "480002": "科魯米納",
    "480003": "科魯米納",
    "480004": "紅色巨龍",
    "480005": "活動 紅色巨龍",
    "480007": "[創造物]紅色巨龍",
    "490001": "飛星掃把",
    "490002": "橡樹掃把",
    "490003": "灌木掃把",
    "490004": "魔法飛毯",
    "490005": "魔法飛毯",
    "490006": "高級魔法飛毯",
    "490007": "高級魔法飛毯",
    "490008": "魔法飛毯",
    "490009": "魔法飛毯",
    "490010": "高級魔法飛毯",
    "490011": "高級魔法飛毯",
    "490012": "青蔥",
    "490013": "觔斗雲",
    "490014": "烏雲",
    "490015": "飛馬",
    "490016": "柏修斯",
    "490017": "觔斗雲",
    "490018": "摩托車",
    "490019": "青蔥",
    "490020": "觔斗雲",
    "490021": "스쿠터",
    "490022": "전투 페가수스",
    "490023": "플레임메어",
    "490024": "크리스탈 루돌프",
    "490025": "瞬間移動妖魔",
    "490026": "鳳凰",
    "490027": "夜晚的掃把",
    "490028": "勇敢的夜晚掃把",
    "490029": "害羞的夜晚掃把",
    "490030": "南瓜幽靈海狗",
    "490031": "針織帽企鵝",
    "490032": "聖誕節海狗",
    "490033": "耍小聰明的小羊",
    "490034": "夢想飛翔的羊咩咩",
    "490035": "愛出風頭的小羊",
    "490036": "即將爆氣的小羊",
    "490037": "喜歡撒嬌的小羊",
    "490038": "心情低落的小羊",
    "490039": "傲嬌任性的小羊",
    "490040": "亂發脾氣的小羊",
    "490041": "餅乾餐車",
    "490042": "圖安之魂",
    "490043": "高筒帽企鵝",
    "490044": "圖安之魂",
    "490045": "神通廣大的小羊",
    "490046": "波波小馬",
    "490047": "教官企鵝",
    "490048": "白鳳凰",
    "490049": "瞬間移動妖魔魔法師",
    "490050": "水晶叮噹馴鹿",
    "490051": "蒼藍白虎坐騎",
    "490052": "蒼白烈焰獨角獸",
    "490053": "安布利斯雷龍 (2人用)",
    "490054": "赤兔馬",
    "490055": "彩虹筋斗雲",
    "490056": "速克達",
    "490057": "紅梅殭屍寶寶",
    "490058": "愛心羊駝",
    "490059": "刨冰餐車",
    "490060": "花仙子芙蘿菈",
    "490061": "瞬間移動妖魔",
    "490062": "武裝飛馬",
    "490063": "絕影青馬",
    "490064": "緞帶小飛象",
    "490065": "深淵骨龍",
    "490066": "狄娜希",
    "490067": "赤兔馬",
    "490068": "水晶叮噹馴鹿",
    "490069": "알비노 백호",
    "490070": "화이트 유니콘 플레임메어",
    "490071": "앰블리쉬 썬더 드래곤 (2인승)",
    "490072": "白馬",
    "490073": "毛茸茸掃把",
    "490074": "순간이동 마법사 임프",
    "490075": "星雲青馬",
    "490076": "星雲飛馬",
    "490077": "星雲雲豹",
    "490078": "星雲觔斗雲",
    "490079": "星雲冰龍",
    "490080": "星雲雷龍(2人用)",
    "490081": "星雲摩托車",
    "490082": "星雲骨龍",
    "490083": "星雲馴鹿",
    "490084": "星雲狐狸",
    "490085": "棉花糖掃把",
    "490087": "魔族牌摩托車",
    "490089": "星雲青馬",
    "490090": "星雲飛馬",
    "490091": "星雲雲豹",
    "490092": "星雲觔斗雲",
    "490093": "星雲冰龍",
    "490094": "星雲雷龍 (2人用)",
    "490095": "星雲摩托車",
    "490096": "星雲骨龍",
    "490097": "星雲馴鹿",
    "490098": "星雲狐狸",
    "490099": "白馬",
    "490100": "高筒帽熊貓",
    "490101": "珮西",
    "490102": "提亞",
    "490103": "화이트 피닉스",
    "490104": "순간이동 마법사 임프",
    "490105": "蒼龍",
    "490106": "樂隊鼓手猴子",
    "490107": "樂隊音符妖魔",
    "490108": "樂隊搖鈴芙蘿拉",
    "490109": "樂隊作曲家羊駝",
    "490110": "樂隊指揮家小羊",
    "490111": "樂隊音響摩托車",
    "490112": "飛雷",
    "490113": "黑馬",
    "490114": "可可啵",
    "490115": "미르",
    "490116": "圖安之魂 (活動)",
    "490117": "黃金蒼龍",
    "490118": "可可波",
    "490121": "拍攝的小羊",
    "490122": "菲尼芬",
    "490123": "午夜掃帚",
    "490124": "咖啡師狄娜希",
    "490125": "咖啡師芙蘿菈",
    "490126": "耍小聰明的小羊",
    "490200": "興奮的艾蘿",
    "490201": "銀河摩托車",
    "490202": "銀河觔斗雲",
    "490203": "銀河骨龍",
    "490204": "銀河冰龍",
    "490205": "銀河飛馬",
    "490206": "帕特拉修",
    "490207": "帕特拉修",
    "490208": "興奮的艾蘿",
    "490209": "愉快的雷特",
    "490210": "抒情的吉歐",
    "490211": "幻想曲骨龍",
    "490212": "幻想曲飛馬",
    "490213": "幻想曲幸運草藥草牛羚",
    "490214": "幻想曲魔族牌摩托車",
    "490215": "幻想曲點心餐車",
    "490216": "幻想曲狄娜希",
    "490217": "幻想曲雲豹",
    "490218": "幻想曲鳳凰",
    "490219": "伴你一生小羊",
    "490221": "銀河飛馬(活動)",
    "490223": "銀河冰龍 (活動)",
    "490224": "高筒帽小馬",
    "490225": "慶典搗蛋鬼艾蘿",
    "490226": "安妞哈塞優小羊",
    "490227": "可愛的傑克",
    "490228": "有脾氣的傑克",
    "490229": "機靈的傑克",
    "490230": "愛笑的傑克",
    "490231": "灌木掃把",
    "490232": "高速灌木掃把",
    "490233": "水晶叮噹馴鹿",
    "490234": "聖誕糜鹿",
    "490235": "聖誕羊駝",
    "490236": "冰龍",
    "490240": "士官學校黑馬",
    "490241": "士官學校白馬",
    "490242": "噗嚕嚕波比",
    "490243": "布蘿妮",
    "490244": "阿囉哈北極熊",
    "490245": "阿囉哈白象",
    "490246": "喜歡撒嬌的小羊(30天)",
    "490247": "花仙子芙蘿菈(30天)",
    "490248": "骨龍(30日)",
    "490249": "圖安之魂(30天)",
    "490250": "玩水小狗",
    "490251": "奇異王國的鼬鼠",
    "490252": "축제즐길꺼양",
    "490253": "克勞諾斯",
    "490254": "紅眼克勞諾斯",
    "490255": "圓帽小馬",
    "490263": "骨龍(FREE SEASON用)",
    "490264": "熱狗波比",
    "490265": "눈사람",
    "490266": "魔族牌溫暖摩托車",
    "490267": "溫暖羊駝",
    "490269": "甜甜咖啡餐車",
    "490270": "甜甜咖啡摩托車",
    "490272": "觔斗雲",
    "490273": "魔術杖",
    "490274": "魔術卡片",
    "490275": "魔術卡片",
    "490277": "世界樹獨角獸",
    "490278": "神秘長袍珍島犬",
    "490279": "天使貓",
    "490280": "墮天使貓",
    "490282": "黃金克勞諾斯",
    "490283": "黃金餐車",
    "490284": "骨龍",
    "490285": "雪花馴鹿",
    "490286": "雪花哈士奇",
    "490287": "尖峰 X",
    "490288": "賣場推車",
    "490289": "皇家超跑",
    "490290": "魔光騎士 X",
    "490291": "黑騎士 X",
    "490292": "練習板車",
    "490294": "Japari 拖拉機",
    "490295": "Japari 巴士",
    "490296": "婚禮步道",
    "490297": "婚禮長花束",
    "490298": "婚禮步道",
    "490299": "赤焰火龍",
    "490301": "戰士柯基",
    "490302": "戰士柯基",
    "490303": "巫師柯基",
    "490304": "巫師柯基",
    "490305": "花朵糖果",
    "490306": "波波烏龜",
    "490307": "度假魔族牌摩托車",
    "490308": "幼年克勞諾斯",
    "490309": "小可卡犬",
    "490310": "小可愛暹羅貓",
    "490311": "小貝雅熊",
    "490312": "小銀狐狸",
    "490313": "小白海狗",
    "490314": "初級冒險家柯基",
    "490315": "初級冒險家柯基",
    "490318": "頂棚摩托車",
    "490319": "骨龍(90天)",
    "490320": "支援用觔斗雲",
    "490321": "支援用蒼龍",
    "490322": "支援用魔族牌摩托車",
    "490323": "支援用骨龍",
    "490325": "星星小白鯨",
    "490326": "花草小白鯨",
    "490327": "喵喵拳擊傑克",
    "490328": "冬季艾蘿",
    "490329": "小白鯨",
    "490330": "緞帶裝飾戰鬥飛馬",
    "490331": "緞帶裝飾雷龍 (2人用)",
    "490332": "將軍火龍",
    "490334": "浪漫散步飛毯",
    "490335": "浪漫散步飛毯",
    "490336": "成為富翁的小羊",
    "490337": "將軍火龍",
    "490338": "圖安之魂",
    "490339": "繁星小白鯨",
    "490340": "水晶小白鯨",
    "490341": "閃亮小白鯨",
    "490342": "櫻花小白鯨",
    "490343": "慶典紀念雲豹",
    "490344": "慶典紀念水晶馴鹿",
    "490345": "戲法小步狐-森林狐",
    "490346": "戲法小步狐-北極狐",
    "490347": "戲法小步狐-沙漠狐",
    "490348": "夏季度假戰士柯基",
    "490349": "夏季度假戰士柯基",
    "490350": "夏季度假巫師柯基",
    "490351": "夏季度假巫師柯基",
    "490352": "魔族牌摩托車(Free Season用)",
    "490353": "小白鯨(VIP服務)",
    "490357": "閃耀之星",
    "490358": "透明的氣球波比",
    "490359": "紅炎的精靈龍",
    "490360": "翠草的精靈龍",
    "490361": "蒼冰的精靈龍",
    "490362": "魔族牌摩托車(90天)哨子",
    "490363": "克勞諾斯(活動用)",
    "490364": "原初精靈龍",
    "490365": "陽光貓",
    "490366": "청명의 카트시",
    "490367": "克勞諾斯(活動用)",
    "490368": "克勞諾斯(90天)",
    "490369": "雪花小白鯨",
    "490370": "銀河小白鯨",
    "490371": "神秘時間的魔法掃把",
    "490372": "神秘空間的魔法掃把",
    "490373": "克勞諾斯(活動用)",
    "490375": "年獸",
    "490376": "糖糖",
    "490377": "甜甜",
    "490378": "乘載幸福的咖啡餐車",
    "490379": "克勞諾斯(活動用)",
    "490380": "蹭蹭喵醬",
    "490381": "蹭蹭喵醬",
    "490382": "踏踏喵醬",
    "490383": "踏踏喵醬",
    "490384": "蹭蹭探險家喵醬",
    "490385": "蹭蹭探險家喵醬",
    "490386": "踏踏密探喵醬",
    "490387": "踏踏密探喵醬",
    "490389": "霜之蒼龍",
    "490390": "霜之幼年克勞諾斯",
    "490391": "7000日紀念柯基",
    "490392": "7000日紀念柯基",
    "490393": "玉兔芙蘿拉",
    "490394": "給你點顏色瞧瞧羊",
    "490397": "將軍青龍",
    "490398": "閃耀星星圖安",
    "490399": "搖滾明星魔族牌摩托車",
    "490400": "警探柯基",
    "490401": "警探柯基",
    "490402": "墨西哥草帽柯基",
    "490403": "墨西哥草帽柯基",
    "490404": "狄娜希",
    "490405": "喜歡撒嬌的小羊",
    "490406": "深淵骨龍",
    "490407": "摩托車",
    "490408": "小克勞諾斯",
    "490410": "楓葉",
    "490411": "蹭蹭喵醬",
    "490412": "蹭蹭喵醬",
    "490413": "踏踏喵醬",
    "490414": "踏踏喵醬",
    "490417": "木製馬車",
    "490418": "魯道夫小馬",
    "490419": "愛心傑克",
    "490420": "聖誕鳳凰",
    "490423": "可愛青蛇(活動用)",
    "490425": "巫師柯基(活動用)",
    "490426": "巫師柯基(活動用)",
    "490427": "伊利亞大陸寶物地圖",
    "490428": "花朵髮箍的棉花糖羊",
    "490429": "花朵髮箍的貓咪",
    "490430": "皮納塔小馬",
    "490431": "害羞兔寶",
    "490432": "搞怪兔寶",
    "490433": "傲慢兔寶",
    "490434": "沉穩兔寶",
    "490439": "戰士柯基(活動用)",
    "490440": "戰士柯基(活動用)",
    "490441": "伊利亞大陸寶物地圖",
    "490442": "兔寶餅乾餐車",
    "490443": "兔子魔族牌摩托車",
    "490444": "我要讀書羊",
    "490445": "聰明的羊駝",
    "490446": "瞬間移動冒險家達魯",
    "490450": "紅炎的精靈龍(活動)",
    "490451": "蒼冰的精靈龍(活動)",
    "490452": "星星魔法師天使貓",
    "490467": "星星小白鯨(活動)",
    "490468": "花草小白鯨(活動)",
    "490469": "小白鯨(活動)",
    "490470": "翠草的精靈龍(活動)",
    "490471": "精靈龍(活動)",
    "490472": "火焰貓(活動)",
    "490473": "陽光貓(活動)",
    "490474": "天使貓(活動)",
    "490475": "墮天使貓(活動)",
    "490476": "害羞兔寶",
    "490477": "搞怪兔寶",
    "490478": "傲慢兔寶",
    "490479": "沉穩兔寶",
    "490480": "兔寶迷你寵物",
    "490481": "貨攤子",
    "490482": "福袋兔寶",
    "490484": "害羞兔寶迷你寵物",
    "490485": "搞怪兔寶迷你寵物",
    "490486": "傲慢兔寶迷你寵物",
    "490487": "沉穩兔寶迷你寵物",
    "490489": "啾啾格拉納",
    "490490": "嗶嗶格拉納",
    "490491": "啾啵- 格拉納",
    "490492": "新生柯基",
    "490493": "新生柯基",
    "490500": "軟呼小倉鼠鼠",
    "490501": "霸氣小倉鼠鼠",
    "490502": "呆萌小倉鼠鼠",
    "490503": "粗飽小倉鼠鼠",
    "490508": "料理師喵醬",
    "490509": "料理師喵醬",
    "490510": "觔斗雲",
    "490511": "蒼龍",
    "491001": "克勞諾斯(活動用)",
    "491004": "克勞諾斯(活動用)",
    "491005": "甜甜的咖啡麵包",
    "491006": "犬靈",
    "491007": "守護的犬靈",
    "491008": "審判的犬靈",
    "491012": "Saber X(活動用)",
    "491013": "賣場推車(活動用)",
    "491014": "皇家超跑(活動用)",
    "491015": "魔光騎士 X(活動用)",
    "491016": "黑騎士 X(活動用)",
    "491017": "練習板車(活動用)",
    "491018": "戰士柯基(活動用)",
    "491019": "戰士柯基(活動用)",
    "491020": "巫師柯基(活動用)",
    "491021": "巫師柯基(活動用)",
    "500001": "沙蟹",
    "500002": "花蟹",
    "500003": "迷你的白貴賓狗",
    "500004": "迷你的暹羅貓",
    "500005": "迷你的梅花鹿",
    "500006": "迷你的棕狐狸",
    "500007": "我要成為星星羊",
    "500008": "方正正波比",
    "500009": "閃電鳳凰",
    "500010": "迷路的畢修普",
    "500011": "叛逆的畢修普",
    "500012": "警官畢修普",
    "510001": "溫泉猴子",
    "511001": "台灣獼猴",
    "511002": "紅猴祖",
    "511003": "戰鬥飛馬",
    "520001": "暗影戰士",
    "520002": "暗影鬥士",
    "520003": "暗影鬥士",
    "520004": "暗影指揮官",
    "520005": "暗影戰士",
    "520006": "暗影鬥士",
    "520007": "提赫拉",
    "520008": "暗影指揮官",
    "520009": "暗影鬥士",
    "520010": "暗影戰士",
    "520011": "暗影鬥士",
    "520013": "黑暗指揮官",
    "520014": "黑暗指揮官",
    "520015": "暗影鬥士",
    "520016": "黑暗指揮官",
    "520017": "小暗影指揮官",
    "520018": "暗影鬥士",
    "520101": "骸骨戰士",
    "520102": "黃金骸骨戰士",
    "520103": "白銀骸骨鬥士",
    "520104": "青銅骸骨鬥士",
    "520105": "骸骨戰士",
    "520106": "青銅骸骨戰士",
    "520107": "被侵蝕的 黃金骸骨戰士",
    "520108": "骸骨戰士",
    "520109": "骸骨戰士",
    "520110": "骸骨戰士",
    "520111": "小骸骨戰士",
    "520201": "骷髏士兵",
    "520202": "無敵單身部隊骷髏士兵",
    "520209": "巨蛇士兵",
    "520210": "巨蛇咒術師",
    "520211": "被召喚的 巨蛇士兵",
    "520212": "被召喚的 巨蛇咒術師",
    "520213": "巨蛇士兵",
    "520214": "巨蛇咒術師",
    "520215": "巨蛇巫師",
    "520216": "巨蛇士兵",
    "520217": "巨蛇咒術師",
    "530001": "暗影槍騎兵",
    "530002": "暗影弓箭手",
    "530003": "暗影弓箭手",
    "530004": "暗影槍騎兵",
    "530005": "暗影弓箭手",
    "530006": "暗影槍騎兵",
    "530007": "暗影槍騎兵",
    "530008": "暗影弓箭手",
    "530009": "暗影弓箭手",
    "530010": "暗影弓箭手",
    "530011": "暗影槍騎兵",
    "530012": "暗影弓箭手",
    "530015": "暗影槍騎兵",
    "530016": "暗影弓箭手",
    "530017": "暗影弓箭手",
    "530018": "暗影槍騎兵",
    "530101": "骸骨槍騎兵",
    "530102": "黃金骸骨槍騎兵",
    "530103": "白銀骸骨槍騎兵",
    "530104": "青銅骸骨槍騎兵",
    "530105": "骸骨槍騎兵",
    "530106": "青銅骸骨槍騎兵",
    "530107": "被侵蝕的 黃金骸骨槍騎兵",
    "530108": "骸骨槍騎兵",
    "530109": "骸骨槍騎兵",
    "530110": "虛象的 骸骨槍騎兵",
    "530111": "小骸骨槍騎兵",
    "530201": "骸骨弓箭手",
    "530202": "黃金骸骨弓箭手",
    "530203": "白銀骸骨弓箭手",
    "530204": "青銅骸骨弓箭手",
    "530205": "骸骨弓箭手",
    "530206": "青銅骸骨弓箭手",
    "530207": "被侵蝕的 黃金骸骨弓箭手",
    "530208": "骸骨弓箭手",
    "530209": "骸骨弓箭手",
    "530210": "小骸骨弓箭手",
    "530211": "影子任務透明怪物",
    "530212": "殭屍士兵",
    "530213": "殭屍士兵",
    "540001": "不敗之劍",
    "540002": "不敗之劍",
    "540003": "不敗之劍",
    "540004": "不敗之劍",
    "540005": "不敗之劍",
    "550001": "小白象",
    "550002": "小藍象",
    "560001": "네이드",
    "570001": "角鴞",
    "570002": "雪鴞",
    "580001": "黑海狗",
    "580002": "白海狗",
    "580003": "黑海狗",
    "580004": "白海狗",
    "590001": "獨眼怪",
    "590002": "獨眼怪",
    "600001": "凱爾特小精靈",
    "600002": "凱爾特小精靈",
    "600003": "凱爾特小精靈",
    "600004": "巨大凱爾特小精靈",
    "600005": "凱爾特小精靈",
    "600006": "炸彈超人",
    "600007": "正在尋找寶物的巨大凱爾特小精靈",
    "600008": "尋找白銀的巨大凱爾特小精靈",
    "600009": "尋找黃金的巨大凱爾特小精靈",
    "600010": "尋找寶石的巨大凱爾特小精靈",
    "600011": "白霧",
    "600012": "黑霧",
    "600013": "生命之珠",
    "600014": "巴羅爾的幻象",
    "600015": "泰赫圖殷之門",
    "600016": "煉獄之扉",
    "600017": "提督的殘留意念",
    "600018": "冒出紅光的觸角",
    "600019": "冒出藍光的觸角",
    "600020": "冒出黃光的觸角",
    "600021": "冒出綠光的觸角",
    "600022": "克赫蓮的集魔杖",
    "600023": "月之碎片",
    "600024": "月之惡夢",
    "600025": "日之碎片",
    "600026": "日之惡夢",
    "600027": "日月之惡夢",
    "600028": "克赫蓮",
    "600029": "海怪雷克斯",
    "610001": "奇怪的書",
    "610002": "奇怪的書",
    "610003": "奇怪的書",
    "620001": "帕爾赫德族的幽靈",
    "620002": "帕爾赫德族的幽靈",
    "620003": "巨大帕爾赫德族的幽靈",
    "620004": "帕爾赫德族的幽靈",
    "630001": "銜尾蛇",
    "630002": "銜尾蛇",
    "630003": "銜尾蛇",
    "630004": "銜尾蛇",
    "630011": "銜尾蛇",
    "630012": "銜尾蛇",
    "630013": "銜尾蛇",
    "630014": "銜尾蛇",
    "630021": "銜尾蛇",
    "630022": "銜尾蛇",
    "630023": "銜尾蛇",
    "630024": "銜尾蛇",
    "630031": "銜尾蛇",
    "630032": "銜尾蛇",
    "630033": "銜尾蛇",
    "630034": "銜尾蛇",
    "630041": "銜尾蛇石像",
    "630101": "銜尾蛇",
    "630102": "銜尾蛇",
    "630103": "銜尾蛇",
    "630104": "銜尾蛇",
    "630111": "銜尾蛇",
    "630112": "銜尾蛇",
    "630113": "銜尾蛇",
    "630114": "銜尾蛇",
    "630121": "銜尾蛇",
    "630122": "銜尾蛇",
    "630123": "銜尾蛇",
    "630124": "銜尾蛇",
    "630131": "銜尾蛇",
    "630132": "銜尾蛇",
    "630133": "銜尾蛇",
    "630134": "銜尾蛇",
    "630201": "銜尾蛇",
    "630202": "銜尾蛇",
    "630203": "銜尾蛇",
    "640101": "叢林探險家妖魔",
    "640102": "火山探險家妖魔",
    "640103": "瞬間移動妖魔",
    "640104": "瞬間移動妖魔魔法師",
    "640105": "순간이동 마법사 임프 (이벤트)",
    "650101": "微笑南瓜",
    "650102": "生氣南瓜",
    "650202": "活動 黑暗騎士團",
    "650203": "活動 蜘蛛弓箭手",
    "660101": "烏龜",
    "660102": "烏龜",
    "660103": "烏龜",
    "670001": "白龍",
    "670002": "刀鋒飛龍",
    "670003": "雪原殺手",
    "670004": "柯西克雷德",
    "670005": "雪原殺手",
    "670006": "黑龍",
    "670007": "白龍",
    "670008": "共用透明怪物",
    "670009": "點擊滑鼠說明",
    "671001": "巨大獅子",
    "671002": "巨大母獅子",
    "671003": "巨大鱷魚",
    "671004": "平原龍",
    "671005": "沙漠龍",
    "671006": "紅色巨龍",
    "671007": "雪人",
    "671008": "長毛象",
    "671009": "伊弗烈特",
    "671010": "巨大沙蟲",
    "671011": "白龍",
    "671012": "莫克爾卡爾菲",
    "671013": "森林巨龍",
    "671014": "古代巨龜",
    "671015": "巨大地蟲",
    "671016": "蒂亞卡",
    "671017": "喀里格",
    "671018": "岩石",
    "671019": "岩石",
    "671020": "岩石",
    "671021": "世界樹小精靈",
    "671022": "祭壇柱子",
    "671023": "蒂亞卡",
    "671024": "喀里格",
    "671025": "喀里格",
    "671026": "古代巨龜",
    "671027": "蒂亞卡",
    "671028": "喀里格",
    "671029": "喀里格",
    "671030": "古代巨龜",
    "671031": "蒂亞卡",
    "671032": "喀里格",
    "671033": "喀里格",
    "671034": "蒂亞卡",
    "671035": "蒂亞卡",
    "671036": "哈西汀",
    "680000": "幼龍",
    "680001": "藍螃蟹",
    "680002": "黑色雪原熊",
    "680004": "巨人工人",
    "680005": "巨人工人",
    "680006": "巨人工人",
    "690000": "巨大獅子",
    "690001": "巨大母獅子",
    "690002": "沙漠龍",
    "690003": "莫克爾卡爾菲",
    "690004": "森林巨龍",
    "690005": "巨大地蟲",
    "690006": "世界樹小精靈",
    "705011": "冰晶灰熊",
    "730200": "夥伴角色",
    "730201": "夥伴 [女僕]",
    "730202": "夥伴 [執事]",
    "730203": "夥伴 [梅瑪]",
    "730204": "女僕夥伴",
    "730205": "執事夥伴",
    "730206": "貿易夥伴",
    "730207": "夥伴 [拉格玲奈]",
    "730208": "夥伴 [威廉]",
    "730209": "夥伴[雷姆]",
    "730210": "夥伴[拉姆]",
    "730211": "夥伴[雷姆]",
    "730212": "夥伴[拉姆]",
    "733200": "精靈",
    "733201": "精靈女性夥伴",
    "733202": "精靈男性夥伴",
    "736200": "巨人",
    "736201": "巨人女性夥伴",
    "736202": "巨人男性夥伴",
    "800001": "貴族馬車",
    "800002": "魔法掃把",
    "800003": "萬聖節 馬車",
    "800004": "羊駝貿易馬車",
    "800005": "拉格玲奈的方舟",
    "804021": "冰頭怪",
    "805001": "初音未來娃娃",
    "805002": "鏡音連娃娃",
    "805003": "鏡音鈴娃娃",
    "805004": "KAITO娃娃",
    "805005": "魅魔娃娃",
    "805006": "惡翅魅魔娃娃",
    "805007": "松鼠娃娃",
    "805008": "兔子娃娃",
    "805009": "沙漠狐狸娃娃",
    "805010": "熊寶寶娃娃",
    "805011": "老虎娃娃",
    "805012": "冒險家粉紅",
    "805013": "特拉克粉紅",
    "805014": "魯艾利粉紅",
    "805015": "蜜莉亞粉紅",
    "805016": "Saber娃娃",
    "805017": "Archer娃娃",
    "805018": "凜娃娃",
    "805019": "伊莉亞絲菲爾娃娃",
    "805020": "雷諾娃娃",
    "805021": "貝伊娃娃",
    "805022": "信娃娃",
    "805023": "梅林娃娃",
    "805024": "DIVA娃娃",
    "805025": "教授 J 娃娃",
    "805026": "總鋪師娃娃",
    "805027": "寶藏獵人娃娃",
    "805028": "松鼠娃娃",
    "805029": "托爾維斯娃娃",
    "805030": "艾薇琳娃娃",
    "805031": "亞特娃娃",
    "805032": "畢奈娃娃",
    "805033": "卡茲遠娃娃",
    "805034": "洛維林娃娃",
    "805035": "氣噗噗兔子娃娃",
    "805036": "拉姆娃娃",
    "805037": "雷姆娃娃",
    "805039": "帕克娃娃",
    "805040": "布麗爾娃娃",
    "805041": "布蘿妮娃娃",
    "805042": "摩勒愛德娃娃",
    "805043": "克赫蓮娃娃",
    "805044": "皮魯安娃娃",
    "805045": "貝仁娃娃",
    "805046": "摩勒愛德娃娃",
    "805047": "皮魯安娃娃",
    "805048": "巴圖魯娃娃",
    "805049": "米羅舞兒娃娃",
    "805050": "克赫蓮娃娃",
    "805051": "貝仁娃娃",
    "805052": "莫勒菲德莉亞娜絲娃娃",
    "805053": "達雷克娃娃",
    "805054": "塔妮莉姆娃娃",
    "805055": "米羅舞兒娃娃",
    "805056": "達雷克娃娃",
    "805057": "塔妮莉姆娃娃",
    "805058": "摩勒愛德娃娃",
    "805059": "克赫蓮娃娃",
    "805060": "皮魯安娃娃",
    "805061": "貝仁娃娃",
    "805062": "藪貓娃娃",
    "805063": "獰貓娃娃",
    "805064": "白臉角鴞博士娃娃",
    "805065": "雕鴞助手娃娃",
    "805066": "幸運獸-I型娃娃",
    "805067": "幸運獸-I型-車長類型娃娃",
    "805068": "幸運獸-I型-演奏類型娃娃",
    "805069": "幸運獸-格式編號不明-指揮娃娃",
    "805070": "西拉娃娃",
    "805071": "惡翅魅魔之主娃娃",
    "805072": "珀拉娃娃",
    "805073": "黛伊爾布拉娃娃",
    "805074": "艾亞莉娃娃",
    "805075": "재빠른 서큐버스 인형",
    "805076": "재빠른 인큐버스 인형",
    "805077": "재빠른 다람쥐 인형",
    "805078": "재빠른 토끼 인형",
    "805079": "재빠른 사막여우 인형",
    "805080": "재빠른 곰돌이 인형",
    "805081": "재빠른 호랑이 인형",
    "805082": "幸運獸-I型娃娃",
    "805083": "幸運獸-I型-車長類型娃娃",
    "805084": "幸運獸-I型-演奏類型娃娃",
    "805085": "幸運獸-格式編號不明-指揮娃娃",
    "805086": "度假小貓娃娃",
    "805087": "昆蟲採集小狗娃娃",
    "805088": "琳頓娃娃",
    "805089": "莎伊芙娃娃",
    "805090": "伊格爾娜娃娃",
    "805091": "奎維恩娃娃",
    "805092": "小兔娃娃",
    "805093": "沙漠小狐狸娃娃",
    "805094": "小熊寶寶娃娃",
    "805095": "艾德翰娃娃背包",
    "805096": "納里娃娃背包",
    "805097": "艾莉娜娃娃背包",
    "805098": "蘇娜娃娃背包",
    "805099": "兔子老師娃娃背包",
    "805100": "小熊學生娃娃背包",
    "805101": "艾蕾蒙娃娃背包",
    "805102": "雷伊璐娃娃背包",
    "805103": "布莉安娜娃娃背包",
    "805104": "錫妮娃娃背包",
    "805105": "歐哈德娃娃背包",
    "805106": "卡薇娜娃娃背包",
    "805115": "瓦爾特娃娃背包",
    "805116": "伊文娃娃背包",
    "805117": "蕾拉娃娃背包",
    "805118": "史帝華娃娃背包",
    "805119": "海灘郊遊小貓娃娃背包",
    "805120": "浮潛小狗娃娃背包",
    "805121": "蘿晚娃娃",
    "805122": "羅西尼娃娃",
    "805123": "伊歐拉娃娃",
    "805124": "馬特烏斯娃娃",
    "805125": "茉麗安娃娃",
    "805126": "錫古娃娃",
    "805127": "妮潘娃娃",
    "805128": "馬夏娃娃",
    "810001": "母雞",
    "810002": "小雞",
    "810003": "幼龍",
    "810004": "食人魔",
    "810005": "貝雅熊",
    "810006": "羊",
    "810007": "狐狸",
    "810008": "殭屍",
    "810009": "拉不拉多拾獵犬",
    "810010": "蛇",
    "810011": "公雞",
    "810012": "魯艾利娃娃",
    "810013": "瑪麗娃娃",
    "810014": "特拉克娃娃",
    "810015": "佛格斯娃娃",
    "810016": "年幼的特拉克娃娃",
    "810017": "克莉絲娃娃",
    "810018": "骷髏",
    "810019": "西瓜",
    "810020": "호박",
    "810021": "벨리사",
    "810022": "벨리사",
    "810023": "벨리사",
    "810024": "벨리사",
    "810025": "벨리사",
    "810026": "트릭스터",
    "810027": "돌아온 트릭스터",
    "810028": "달콤한 진저맨쿠키",
    "810029": "고소한 진저맨쿠키",
    "810030": "느끼한 진저맨쿠키",
    "810031": "바삭한 진저맨쿠키",
    "810032": "하기",
    "810033": "안즈",
    "810034": "勇敢的軟糖熊",
    "810035": "憤怒的軟糖熊",
    "810036": "膽小的軟糖熊",
    "810037": "與眾不同的軟糖熊",
    "810038": "巨大糖寶",
    "810039": "小糖寶",
    "810040": "珮西娃娃",
    "810041": "提亞娃娃",
    "810042": "珮西",
    "810043": "提亞",
    "810044": "할로윈 슬라임",
    "810045": "草莓朱古力",
    "810046": "小草莓朱古力",
    "810047": "小朱古力",
    "810048": "月光鐵鎚佛格斯娃娃",
    "810051": "녹여쩡",
    "810052": "마이쩡",
    "810053": "입어쩡",
    "810054": "호해쩡",
    "810055": "까까쩡",
    "810056": "阿瓦隆大耳兔",
    "810057": "氣噗噗兔子",
    "810058": "小隻氣噗噗兔子",
    "810059": "亞特娃娃",
    "810060": "畢奈娃娃",
    "810061": "托爾維斯娃娃",
    "810062": "艾薇琳娃娃",
    "810063": "卡茲遠娃娃",
    "810064": "洛維林娃娃",
    "810065": "布蘿妮娃娃",
    "810066": "눈사람 인형",
    "810067": "摩勒愛德娃娃",
    "810068": "克赫蓮娃娃",
    "810069": "皮魯安娃娃",
    "810070": "貝仁娃娃",
    "810071": "帕迪亞露露娃娃",
    "810072": "飢餓貪吃鬼兔子",
    "810073": "帕迪亞露露娃娃",
    "810074": "帕迪亞露露娃娃",
    "810075": "帕迪亞露露娃娃",
    "810076": "帕迪亞露露娃娃",
    "810077": "帕迪亞露露娃娃",
    "810078": "帕迪亞露露娃娃",
    "810079": "帕迪亞露露娃娃",
    "810080": "帕迪亞露露娃娃",
    "810081": "帕迪亞露露娃娃",
    "810082": "米羅舞兒娃娃",
    "810083": "巴圖魯娃娃",
    "810084": "塔妮莉姆娃娃",
    "810085": "莫勒菲德莉亞娜絲娃娃",
    "810086": "達雷克娃娃",
    "810087": "藪貓迷你寵物",
    "810088": "獰貓迷你寵物",
    "810089": "白臉角鴞博士迷你寵物",
    "810090": "雕鴞助手迷你寵物",
    "810091": "幸運獸-I型迷你寵物",
    "810092": "幸運獸-I型-車長類型迷你寵物",
    "810093": "幸運獸-I型-演奏類型迷你寵物",
    "810094": "幸運獸-格式編號不明-指揮迷你寵物",
    "810100": "星星小白鯨迷你寵物",
    "810101": "花草小白鯨迷你寵物",
    "810102": "芬奇娃娃",
    "810103": "卡泰爾娃娃",
    "810104": "埃坦娃娃",
    "810105": "恩雅娃娃",
    "810106": "梅溫娃娃",
    "810107": "繁星小白鯨 迷你寵物",
    "810108": "水晶小白鯨迷你寵物",
    "810109": "閃亮小白鯨迷你寵物",
    "810110": "櫻花小白鯨迷你寵物",
    "810111": "佩洛姆娃娃",
    "810112": "伊魯夏娃娃",
    "810113": "喀輪巴斯布麗爾娃娃",
    "810114": "喀輪巴斯吉拉克娃娃",
    "810115": "史萊姆維尼迷你寵物",
    "810116": "珀拉娃娃",
    "810117": "黛伊爾布拉娃娃",
    "810118": "西拉娃娃",
    "810119": "夢魘之王玩偶",
    "810120": "埃坦娃娃",
    "810121": "恩雅娃娃",
    "810122": "梅林娃娃",
    "810123": "DIVA娃娃",
    "810124": "教授 J 娃娃",
    "810125": "總舖師玩偶",
    "810126": "寶藏獵人玩偶",
    "810127": "艾亞莉娃娃",
    "810128": "守護者玩偶",
    "810129": "破壞者玩偶",
    "810130": "亞倫人偶",
    "810131": "雪花小白鯨迷你寵物",
    "810132": "銀河小白鯨迷你寵物",
    "810133": "白貴賓狗迷你寵物",
    "810134": "暹羅貓迷你寵物",
    "810135": "梅花鹿迷你寵物",
    "810136": "棕狐狸迷你寵物",
    "810137": "迷你的白貴賓狗迷你寵物",
    "810138": "迷你的暹羅貓迷你寵物",
    "810139": "迷你的梅花鹿迷你寵物",
    "810140": "迷你的棕狐狸迷你寵物",
    "810141": "潘娃娃",
    "810142": "迷路的畢修普迷你寵物",
    "810143": "叛逆的畢修普迷你寵物",
    "810144": "警官畢修普迷你寵物",
    "810145": "芙莉蓮娃娃",
    "810146": "費倫娃娃",
    "810147": "修塔爾克娃娃",
    "810148": "欣梅爾娃娃",
    "810149": "尤蓓爾娃娃",
    "810150": "賽莉耶娃娃",
    "810151": "飛行兔子玩偶",
    "810152": "飛行沙漠狐玩偶",
    "810153": "飛行小熊玩偶",
    "810155": "次元跳躍兔子玩偶",
    "810156": "次元跳躍沙漠狐狸娃娃",
    "810157": "次元跳躍熊娃娃",
    "900001": "羊(活動用)",
    "900002": "狗(活動用)",
    "900003": "紅熊(活動用)",
    "900004": "棕狐狸(活動用)",
    "900005": "白狼(活動用)",
    "900006": "雪球",
    "900007": "隱形的熊(攝影用)",
    "900008": "西瓜",
    "900009": "西瓜",
    "900010": "南瓜怪",
    "900011": "南瓜怪",
    "900012": "年獸",
    "900013": "幼小年獸",
    "900014": "妖魔",
    "900015": "哥布林",
    "900016": "地靈",
    "900017": "骷髏",
    "900018": "鼠人",
    "900019": "西瓜",
    "900020": "黃金鼠",
    "900021": "黃金鼠人",
    "900022": "巨大黃金鼠人",
    "900023": "稻草人",
    "900024": "阿樂祖的精銳修練弟子",
    "900025": "修練翻筋斗達10年的弟子",
    "900026": "阿樂祖",
    "900027": "阿樂祖的入門弟子",
    "900028": "阿樂祖的入門弟子",
    "900029": "阿樂祖的巨人弟子",
    "900030": "阿樂祖的巨人弟子",
    "900031": "阿樂祖的弟子",
    "900032": "阿樂祖的弟子",
    "900033": "阿樂祖的巨人弟子",
    "900034": "阿樂祖的巨人弟子",
    "900035": "掠奪團哥布林",
    "900036": "掠奪團哥布林弓箭手",
    "900037": "掠奪團妖魔",
    "900038": "掠奪團巨人",
    "900039": "掠奪團食人魔",
    "900040": "掠奪團人類",
    "900041": "掠奪團哥布林 一流弓箭手",
    "900042": "掠奪團哥布林 狙擊手",
    "900043": "掠奪團巨人 武鬥家",
    "900044": "掠奪團妖魔 雷魔法師",
    "900045": "掠奪團妖魔 火魔法師",
    "900046": "掠奪團妖魔 冰魔法師",
    "900047": "海賊 潘勞斯",
    "900048": "身分不明的 葛魯奇",
    "900049": "劇毒的 奇蘭",
    "900050": "吝嗇鬼 斯可路",
    "900051": "掠奪少女 德路比",
    "900052": "凶惡的 華拉杜魯",
    "900053": "搜刮一通的 克萊傑",
    "900054": "노란 진돗개",
    "900055": "골든 리트리버",
    "900056": "래브라도 리트리버",
    "900057": "迷失的蜘蛛座",
    "900058": "迷失的巨魔像座",
    "900059": "迷失的大熊座",
    "900060": "迷失的山羊座",
    "900061": "迷失的狐狸座",
    "900062": "迷失的獨角獸座",
    "900063": "迷失的毒蛇座",
    "900064": "迷失的美洲豹座",
    "900065": "迷失的翼龍座",
    "900066": "紅色掠奪團哥布林",
    "900067": "紅色掠奪團哥布林弓箭手",
    "900068": "紅色掠奪團妖魔",
    "900069": "紅色掠奪團巨人",
    "900070": "紅色掠奪團人類",
    "900071": "粗暴的 佩魯斯",
    "900072": "伊魯夏",
    "900073": "帕迪亞露露",
    "900074": "香氣熊熊",
    "900075": "戰場角色",
    "900076": "戰場角色",
    "900077": "戰場角色",
    "901001": "蜘蛛",
    "901002": "小雞",
    "901003": "白狼",
    "901004": "白色雪原熊",
    "901005": "棕鷹",
    "902000": "傑哈",
    "902001": "[見習指揮官] 安德拉絲",
    "902002": "[見習戰士] 崔弗",
    "902003": "[大師美食家] 古魯亞司",
    "902004": "[大師遺蹟王] 博伊特",
    "902005": "[大師廣告明星] 卡爾梵",
    "902006": "[職業航海士] 歐文提督",
    "902007": "[美食獵人] 食人魔屠夫",
    "902008": "[新手家管] 姬琳",
    "902009": "[大師鐵匠] 艾頓",
    "902010": "[新手鐵匠] 佛格斯",
    "902011": "[職業戰士] 雷納德",
    "902012": "[大師浪人] 派瑞克",
    "902013": "[大師美食家] 乞丐",
    "902014": "[大師家管] 鄰家管家",
    "902015": "[大師拉狄卡戰士] 哈吉爾",
    "902016": "[大師單身漢] 布洛斯",
    "902017": "[特級礦工] 史恩",
    "902018": "[職業單戀戰士] 佩丹",
    "902019": "[大師浪人] 布萊斯",
    "902020": "[大師戰士] 艾德翰",
    "902021": "[大師枕頭] 魔女",
    "902022": "[大師劇毒劍士] 路卡斯",
    "902023": "[職業家管] 陶恩斯",
    "902024": "[首席衝鋒隊長] 奈麗絲",
    "902025": "[職業聖槍兵] 柯洛恩",
    "902026": "[特級衝鋒隊長] 阿蘭雯",
    "902027": "[大師劊子手] 庫魯格",
    "902028": "[大師衝鋒隊長] 莉莉絲",
    "902029": "[大師工匠] 瓦爾特",
    "902030": "[大師讀者] 艾潔拉",
    "902031": "[一流花匠] 黛兒",
    "902032": "[特級花匠] 黛蓮",
    "902033": "[職業工匠] 艾琳",
    "902034": "[職業快槍手] 李奧卡德",
    "902035": "[職業神聖弓箭手] 安黛莉",
    "902036": "[特級射擊之星] 伊絲娜",
    "902037": "[職業劇毒弓箭手] 葛尼提斯",
    "902038": "[首席遊俠] 庫西娜",
    "902039": "[職業遊俠] 凱琳",
    "902040": "[大師射擊之星] 貝莉塔",
    "902041": "[大師劇毒弓箭手] 阿隬",
    "902042": "[見習珠寶工匠] 珍妮佛",
    "902043": "[大師弓箭手] 克拉納特",
    "902044": "[大師神射手] 德倫",
    "902045": "[大師遊俠] 沃夫卡",
    "902046": "[新手貴族] 妖魔雷魔法師",
    "902047": "[新手貴族] 妖魔火魔法師",
    "902048": "[新手貴族] 妖魔冰魔法師",
    "902049": "[見習德魯伊] 貝瑞克希德",
    "902050": "[職業魔法師] 惡翅魅魔",
    "902051": "[見習學生] 麗莎",
    "902052": "[特級魔法師] 史帝華",
    "902053": "[職業魔法師] 蓋維",
    "902054": "[大師女僕] 鄰家姐姐",
    "902055": "[一代魔法師] 白魅魔戰士",
    "902056": "[大師裁縫師] 奧拉克妮",
    "902057": "[大師德魯伊] 特拉克",
    "902058": "[大師訓犬師] 腓力特",
    "902059": "[大師水元素] 梅魯",
    "902060": "[新手戰鬥鍊金術師] 海蕾特",
    "902061": "[大師戰鬥鍊金術師] 阿依巴",
    "902062": "[職業吸血戰士] 暗影指揮官",
    "902063": "[見習征服者] 暗影戰士",
    "902064": "[職業指揮官] 提赫拉",
    "902065": "[職業貴族] 錫妮",
    "902066": "[大師鍊金術師] 多琳",
    "902067": "[冠軍武鬥家] 巨人武鬥家",
    "902068": "[冠軍武鬥家] 巨人武鬥家",
    "902069": "[一代武鬥家] 哥布林武鬥家",
    "902070": "[大師拳擊手] 薛希爾",
    "902071": "[大師武鬥家] 阿樂祖",
    "902072": "[大師牧羊人戰士] 迪恩",
    "902073": "[大師村長] 鄧肯",
    "902074": "哥布林",
    "902075": "地靈",
    "902076": "基因突變地靈",
    "902077": "叢林哥布林爆破兵",
    "902078": "基因突變爆破兵",
    "902079": "[職業聖騎士] 秘密騎士團",
    "902080": "[笨拙戰士] 食人魔戰士",
    "902081": "虛無騎士",
    "902082": "[一代戰士] 粉紅魅魔戰士",
    "902083": "[一代戰士] 黑魅魔戰士",
    "902084": "[一代戰士] 紅魅魔戰士",
    "902085": "[火花戰士] 伊弗烈特",
    "902086": "槍騎兵",
    "902087": "巨人槍騎兵",
    "902088": "槍騎兵 炎魔",
    "902089": "[職業劊子手] 食人魔屠夫",
    "902090": "[見習征服者] 暗影槍騎兵",
    "902091": "[業餘槍騎兵] 暗影槍騎兵",
    "902092": "[大師暗黑劊子手] 都拉漢",
    "902093": "蜘蛛弓箭手",
    "902094": "幽靈軍弓箭手",
    "902095": "巨大貓妖精弓箭手",
    "902096": "[大師暗黑弓箭手] 都拉漢",
    "902097": "[職業狙擊手] 哥布林一流射手",
    "902098": "[見習公主] 報喪女妖",
    "902099": "[職業術士] 半巫妖",
    "902100": "[大師精神病] 古代巫妖",
    "902101": "[大師魔法師] 大師巫妖",
    "902102": "[大師裁縫師] 西蒙",
    "902103": "王城鍊金術師",
    "902104": "王城鍊金術師",
    "902105": "[見習拇指公主] 報喪女妖",
    "902106": "[大師鍊金術師] 深淵的鍊金術師",
    "902107": "[見習祭司] 席爾普林",
    "902108": "[一流祭司] 安格妮絲",
    "902109": "[大師健忘症] 雅拉塔",
    "902110": "[特級賢者] 卡絲妮亞",
    "902111": "[大師聖職者] 康格",
    "902112": "[大師告解聖事] 卡爾汀",
    "902113": "[大師咒術師] 庫塞",
    "902114": "[大師獸王] 洛瓦伊",
    "902115": "[大師賢者] 潘賈斯特",
    "902116": "白狼",
    "902117": "巨大白狼",
    "902118": "巨大荒野野豬",
    "902119": "狼人",
    "902120": "基因突變狼人",
    "902121": "巨熊",
    "902122": "巨大長角牛羚",
    "902123": "巨大短角牛羚",
    "902124": "大象",
    "902125": "大象",
    "902126": "[大師年紀] 溫泉神靈",
    "902127": "溫泉獼猴",
    "902128": "[大師美食家] 溫泉獼猴",
    "902129": "[特級破壞者] 巨大獅子",
    "902130": "[一代音樂神童] 哥布林吟遊詩人",
    "902131": "[職業吟遊詩人] 納里",
    "902132": "[大師音樂家]布莉安娜",
    "902133": "[大師吟遊詩人] 里葆娜",
    "902134": "小巨魔像",
    "902135": "巨魔像",
    "902136": "森林巨魔像",
    "902137": "黃玉魔法巨魔像",
    "902138": "綠寶石魔法巨魔像",
    "902139": "紫水晶魔法巨魔像",
    "902140": "硫磺巨魔像",
    "902141": "城牆巨魔像",
    "902142": "巨大城牆巨魔像",
    "902143": "水晶巨魔像",
    "902144": "水晶巨魔像",
    "902145": "水晶巨魔像",
    "902146": "白色巨魔像",
    "902147": "白色巨大巨魔像",
    "902148": "塔巴勒塔斯",
    "902149": "沙華魚人魔法師",
    "902150": "精靈弓箭手",
    "902151": "人類士兵",
    "902152": "人類士兵",
    "902153": "秘密騎士團弓箭手",
    "902154": "修練武鬥家",
    "902155": "修練武鬥家",
    "902156": "地獄犬",
    "902157": "炸彈殭屍",
    "903000": "沙包娃娃",
    "903001": "沙包娃娃",
    "903002": "沙包娃娃",
    "903003": "報喪女妖布偶",
    "903500": "黑豹",
    "903501": "黑豹王",
    "903502": "黑豹(夏瑪拉)",
    "903503": "青蛇",
    "903504": "白蛇",
    "903505": "昇龍前的巨蛇",
    "903506": "藍尾蟒蛇",
    "903507": "白尾蟒蛇",
    "903508": "紅角眼鏡蛇",
    "903509": "叢林眼鏡蛇",
    "903510": "狼人",
    "903511": "地獄犬",
    "903512": "鬼魂",
    "903513": "夏瑪拉",
    "903514": "聚集惡靈的野豬",
    "903515": "巨人狼人",
    "903516": "大象裡的惡靈",
    "903517": "大象",
    "903518": "火蜥蜴",
    "903519": "巨大無頭怪",
    "903520": "夏瑪拉",
    "903521": "夏瑪拉",
    "903522": "蜜莉亞",
    "903523": "身分不明的男人",
    "903524": "沃沃卡",
    "903525": "圖派依",
    "903526": "庫西娜",
    "903527": "庫塞",
    "903528": "洛瓦伊",
    "903529": "水獺",
    "903530": "鴕鳥",
    "903531": "河馬",
    "903532": "伊莉莎白",
    "903533": "發光半神",
    "903534": "奧拉克妮",
    "903535": "沃沃卡",
    "903536": "庫塞",
    "903537": "洛瓦伊",
    "903538": "庫西娜",
    "903539": "圖派依",
    "903540": "水獺",
    "903541": "科爾居民",
    "903542": "科爾居民",
    "903543": "半巫妖",
    "903544": "半巫妖",
    "903545": "食屍鬼",
    "903546": "偽裝怪",
    "903547": "虛無騎士",
    "903548": "黑帝斯",
    "903549": "德瑞特",
    "903550": "祭祀用野豬",
    "903551": "祭物用野豬",
    "903552": "高原野豬",
    "903553": "黑色食蟻獸",
    "903554": "長角食蟻獸",
    "903555": "黑耳灌木野豬",
    "903556": "白色灌木野豬",
    "903557": "百眼巨人",
    "903558": "巨魔",
    "903559": "惡靈戰士",
    "903560": "惡靈弓箭手",
    "903561": "惡靈祭司",
    "903562": "惡靈大祭司",
    "903563": "惡靈祭司",
    "903564": "面具幽靈",
    "903565": "冰頭怪",
    "903566": "巨大無頭怪",
    "903567": "食屍鬼",
    "903568": "半巫妖",
    "903569": "半巫妖",
    "903570": "惡靈戰士",
    "903571": "惡靈弓箭手",
    "903572": "惡靈祭司",
    "903573": "惡靈大祭司",
    "903574": "惡靈弓箭手",
    "903575": "惡靈 吟遊詩人",
    "903576": "面具鬼魂",
    "903577": "冰頭怪",
    "903578": "巨大無頭怪",
    "903579": "爆彈殭屍",
    "903580": "伊弗烈特",
    "903581": "百眼巨人",
    "903582": "骷髏狼",
    "903583": "骷髏食人魔",
    "903584": "骷髏",
    "903585": "紅骷髏",
    "903586": "金屬骷髏",
    "903587": "骷髏士兵",
    "903588": "巨大骷髏",
    "903589": "海盜骷髏船員",
    "903590": "骷髏海盜船長",
    "903591": "鎧甲骷髏食人魔",
    "903592": "鎧甲骷髏",
    "903593": "海盜骷髏",
    "903594": "巨大骷髏地獄犬",
    "903595": "骷髏自爆兵",
    "903596": "幽靈軍首領",
    "903597": "幽靈軍鬥士",
    "903598": "幽靈軍戰士",
    "903599": "幽靈軍弓箭手",
    "903600": "骷髏幽靈",
    "903601": "骷髏地獄犬",
    "903602": "夏瑪拉",
    "903603": "百眼巨人",
    "903604": "報喪女妖",
    "903605": "鬼魂",
    "903606": "奧拉克妮",
    "903607": "幼小黑狼蛛",
    "903608": "分身幻像",
    "903609": "分身幻像",
    "903610": "食屍鬼",
    "903611": "牢獄魔劍",
    "903612": "白色鬼魂僕人",
    "903613": "維羅納黑色牢獄鬼魂",
    "903614": "惡靈 吟遊詩人",
    "903615": "見習 情報員",
    "903616": "見習 情報員",
    "903617": "見習 親衛隊員",
    "903618": "見習 親衛隊員",
    "903619": "情報員Q",
    "903620": "情報員 K",
    "903621": "指揮官",
    "903622": "情報官",
    "903623": "惡靈 無頭怪",
    "903624": "惡靈 食屍鬼",
    "903625": "惡靈 半巫妖",
    "903626": "惡靈 半巫妖",
    "903627": "惡靈戰士",
    "903628": "惡靈弓箭手",
    "903629": "惡靈弓箭手",
    "903630": "惡靈 吟遊詩人",
    "903631": "惡靈 幽靈軍領袖",
    "903632": "惡靈 幽靈軍戰士",
    "903633": "惡靈 骷髏幽魂",
    "903634": "惡靈 百眼巨人",
    "903635": "惡靈大祭司",
    "903636": "沃沃卡",
    "903637": "庫塞",
    "903638": "洛瓦伊",
    "903639": "庫西娜",
    "903640": "圖派依",
    "903641": "水獺",
    "903642": "科爾居民",
    "903643": "科爾居民",
    "903644": "柯西克雷德",
    "903645": "身分不明的男人",
    "903646": "情報員",
    "903647": "情報員",
    "903648": "親衛隊員",
    "903649": "親衛隊員",
    "903650": "巨人守衛",
    "903651": "巨人守衛",
    "903652": "巨人守衛",
    "903653": "精靈守衛",
    "903654": "精靈守衛",
    "903655": "雪原殺手",
    "903656": "雪原殺手",
    "903657": "掠奪團哥布林",
    "903658": "掠奪團哥布林弓箭手",
    "903659": "掠奪團妖魔",
    "903660": "白龍",
    "903661": "黑龍",
    "903662": "柯西克雷德",
    "903663": "掠奪團頭目",
    "903664": "庫魯格",
    "903665": "夏瑪拉",
    "903666": "巨人",
    "903667": "자이언트",
    "903668": "蜜莉亞",
    "903669": "蜜莉亞",
    "903670": "黑尾貓鼬",
    "903671": "又大又美的 黑尾貓鼬",
    "903672": "夏瑪拉",
    "903673": "黑龍",
    "903674": "阿庫垃",
    "903675": "蜜莉亞",
    "903676": "刀鋒飛龍",
    "903677": "枚伊克",
    "903678": "塔烏拉",
    "903679": "紅色惡靈戰士",
    "903680": "叢林哥布林爆破兵",
    "903681": "基因突變爆破兵",
    "903682": "充滿怨恨的惡靈",
    "903683": "掠奪少女",
    "903684": "精打細算的米列希安",
    "903685": "向休斯砍價的米列希安",
    "903686": "穿上神秘長袍的米列希安",
    "903687": "掠奪團哥布林",
    "903688": "掠奪團哥布林弓箭手",
    "903689": "掠奪團妖魔",
    "903690": "雪原殺手",
    "903691": "雪原殺手",
    "903692": "雪原野獸",
    "903693": "藍色半巫妖",
    "903694": "凱薩",
    "903695": "凱薩",
    "903696": "凱薩",
    "903697": "情報官",
    "903698": "魔法學者",
    "903699": "古代薩滿幽靈",
    "903700": "巴貝斯巴勒",
    "903701": "黑龍騎士",
    "903702": "黑龍騎士",
    "903703": "黑龍騎士",
    "903704": "黑龍騎士",
    "903705": "黑龍騎士的虛像",
    "903706": "薩滿戰士",
    "903707": "薩滿武鬥家",
    "903708": "薩滿弓箭手",
    "903709": "薩滿魔法師",
    "903710": "薩滿",
    "903711": "精打細算的米列希安",
    "903712": "向休斯砍價的米列希安",
    "903713": "穿上神秘長袍的米列希安",
    "903714": "情報員",
    "903715": "情報員",
    "903716": "親衛隊員",
    "903717": "親衛隊員",
    "903718": "巨人守衛",
    "903719": "巨人守衛",
    "903720": "巨人守衛",
    "903721": "精靈守衛",
    "903722": "精靈守衛",
    "903723": "凱薩",
    "903724": "受傷的魯艾利",
    "903725": "拉克里斯",
    "903726": "地鼠",
    "903727": "特拉克",
    "903728": "女神馬夏",
    "903729": "凱薩首領",
    "903730": "安巴爾",
    "903731": "女神馬夏",
    "903732": "火紅法利亞斯浮游石",
    "903733": "龍",
    "903734": "캐러반 조",
    "904001": "雷電翼魔",
    "904002": "守衛翼魔",
    "904003": "骷髏地獄看門犬",
    "904004": "紅眼刺腳蜘蛛",
    "904005": "巨大雌性黃蜂",
    "904006": "巨大骷髏",
    "904007": "巨大火焰之魂",
    "904008": "巨大黃金蜘蛛",
    "904009": "紅蜘蛛黃蜂",
    "904010": "戈耳戈",
    "904011": "哥布林劍術大師",
    "904012": "哥布林守衛",
    "904013": "哥布林守衛弓箭手",
    "904014": "哥布林獵人",
    "904015": "哥布林獵人弓箭手",
    "904016": "鬼魂",
    "904017": "巨魔像",
    "904018": "搗蛋鬼",
    "904019": "綠色食蟲植物",
    "904020": "黑色搗蛋鬼之王",
    "904021": "洞穴千足蟲",
    "904022": "巨大黑色洞穴蝙蝠",
    "904023": "野狗",
    "904024": "鬃毛食蟻獸",
    "904025": "白頭羊駝",
    "904026": "鼠人",
    "904027": "蒙面哥布林",
    "904028": "梅魯",
    "904029": "小巨魔像",
    "904030": "黑色水牛",
    "904031": "巨大紅眼刺腳蜘蛛",
    "904032": "綠角眼鏡蛇",
    "904033": "洞穴沙華魚人遊俠",
    "904034": "洞穴迷失沙華魚人",
    "904035": "洞穴沙華魚人魔法師",
    "904036": "洞穴沙華魚人戰士",
    "904037": "洞穴沙華魚人鬥士",
    "904038": "大象",
    "904039": "紅色大山貓",
    "904040": "鎧甲骷髏食人魔",
    "904041": "豺狼",
    "904042": "百眼巨人",
    "904043": "鱷魚",
    "904044": "烏龜",
    "904045": "野生馬",
    "904046": "披著羊皮的狼",
    "904047": "食人魔屠夫",
    "904048": "妖魔",
    "904049": "豺狼",
    "904050": "短角牛羚",
    "904051": "藍色螃蟹",
    "904052": "郊狼",
    "904053": "長角牛羚",
    "904054": "黃金奇異鳥",
    "904055": "隱形妖魔",
    "904056": "土狼首領",
    "904057": "海盜骷髏",
    "904058": "狂暴翼魔",
    "904059": "黑豹",
    "904060": "梅魯",
    "904061": "窺視者的眼睛",
    "904063": "掠奪者哥布林",
    "904064": "掠奪團哥布林弓箭手",
    "904065": "掠奪團妖魔",
    "904066": "掠奪者人類",
    "904067": "掠奪者巨人",
    "904068": "掠奪團頭目",
    "904069": "獨眼 佩勒斯",
    "904070": "不明身分 葛魯奇",
    "904071": "猛毒的 奇蘭",
    "904072": "搜刮 克萊傑",
    "904073": "掠奪少女 德路比",
    "904074": "兇惡的 華拉杜魯",
    "904075": "老練的 掠奪團哥布林",
    "904076": "老練的 掠奪團哥布林弓箭手",
    "904077": "老練的 掠奪團妖魔",
    "904078": "老練的 掠奪團人類",
    "904079": "老練的 掠奪團巨人",
    "904080": "一流 掠奪團哥布林",
    "904081": "一流 掠奪團哥布林弓箭手",
    "904082": "一流 掠奪團妖魔",
    "904083": "一流 掠奪團人類",
    "904084": "提督的殘留思念",
    "904085": "黑梨鼠",
    "904086": "灰鼠",
    "904087": "魔劍",
    "904088": "骷髏狼",
    "904089": "骷髏",
    "904090": "海盜骷髏",
    "904091": "海盜骷髏",
    "904092": "海盜紅骷髏",
    "904093": "海盜紅骷髏",
    "904094": "骷髏船長",
    "904095": "海盜紅骷髏船長",
    "904096": "骷髏吟遊詩人",
    "904097": "鎧甲骷髏食人魔",
    "904098": "黑梨鼠",
    "904099": "魔劍",
    "905000": "昇龍前的巨蛇",
    "905001": "藍色巨蛇騎士",
    "905002": "白色蟒蛇",
    "905003": "紅角眼鏡蛇",
    "905004": "叢林眼鏡蛇",
    "905005": "沼澤眼鏡蛇",
    "905006": "藍角眼鏡蛇",
    "905007": "灰角眼鏡蛇",
    "905008": "綠色眼鏡蛇",
    "905009": "棕蛇",
    "905010": "青蛇",
    "905011": "白蛇",
    "905012": "黑蛇",
    "905013": "綠蛇",
    "905014": "巨大白蛇",
    "905015": "黑毒蛇",
    "905016": "白毒蛇",
    "905017": "紅毒蛇",
    "905018": "昇龍前的巨蛇",
    "905019": "響尾蛇",
    "905020": "蛇龍",
    "905021": "蛇龍",
    "905022": "蛇龍",
    "905023": "蛇龍",
    "910001": "男性劍精靈",
    "910002": "女性劍精靈",
    "910003": "男性鈍器精靈",
    "910004": "女性鈍器精靈",
    "910005": "男性魔杖精靈",
    "910006": "女性魔杖精靈",
    "910007": "男性弓精靈",
    "910008": "女性弓精靈",
    "910009": "男性鋼瓶精靈",
    "910010": "女性鋼瓶精靈",
    "910011": "男性劍精靈",
    "910012": "女性劍精靈",
    "910013": "男性鈍器精靈",
    "910014": "女性鈍器精靈",
    "910015": "男性魔杖精靈",
    "910016": "女性魔杖精靈",
    "910017": "男性弓精靈",
    "910018": "女性弓精靈",
    "910019": "男性鋼瓶精靈",
    "910020": "女性鋼瓶精靈",
    "910090": "艾麗",
    "910099": "艾麗",
    "990001": "旅團",
    "990002": "望遠鏡",
    "990003": "露雅的弟弟",
    "990004": "觀覽鏡",
    "990005": "水晶球",
    "990006": "書櫃",
    "990007": "卡魯森林遺跡",
    "990008": "任務佈告欄",
    "990009": "祭壇",
    "990010": "侖格沙漠遺跡",
    "990011": "蔬果店",
    "990012": "魚肉舖",
    "990013": "巴雷斯冰河遺跡",
    "990014": "船匠",
    "990015": "閃電祭壇",
    "990016": "太陽祭壇",
    "990017": "雪花祭壇",
    "990018": "接受升等考試",
    "990019": "郵箱",
    "990020": "信箱",
    "990021": "郵箱",
    "990022": "火龍蛋",
    "990023": "影子作戰佈告牌",
    "990024": "妮潘",
    "990025": "吊燈",
    "990026": "地獄犬",
    "990027": "鐵鍋子",
    "990028": "地獄犬",
    "990029": "法拉伊斯浮游石",
    "990030": "大雪堆",
    "990031": "大土堆",
    "990032": "大雪堆",
    "990033": "大土堆",
    "990034": "大雪堆",
    "990035": "大土堆",
    "990036": "大雪堆",
    "990037": "大土堆",
    "990038": "大雪堆",
    "990039": "大土堆",
    "990040": "巨大肉團",
    "990041": "背包客",
    "990042": "背包客",
    "990043": "手拉車",
    "990044": "手拉車",
    "990045": "運送用馬車",
    "990046": "運送用大象",
    "990047": "新手戰鬥講座佈告欄",
    "990048": "手拉車",
    "990049": "許願樹",
    "990050": "[파트너] 등짐",
    "990051": "[파트너] 손수레",
    "990052": "[파트너] 운송용 마차",
    "990053": "[파트너] 운송용 코끼리",
    "990054": "通緝犯佈告欄",
    "990055": "雪人",
    "990056": "閃亮的物體",
    "990057": "特里歐納的墳墓",
    "990058": "碰撞檢查雪堆",
    "990059": "藍隊雪人",
    "990060": "紅隊雪人",
    "990061": "浮游石",
    "990062": "浮游石",
    "990063": "浮游石",
    "990064": "浮游石",
    "990065": "浮游石",
    "990066": "怪異雪球",
    "990067": "怪異雪球",
    "990068": "固定木偶",
    "990069": "無限生命模型",
    "990070": "無生命模型",
    "990071": "守護柱",
    "990072": "守護柱",
    "990073": "守護柱",
    "990074": "倒榻的守護柱",
    "990075": "倒榻的守護柱",
    "990076": "倒榻的守護柱",
    "990077": "薩滿的守護者",
    "990078": "蘑菇王",
    "990079": "加奈芃沙雕第1階段",
    "990080": "加奈芃沙雕第2階段",
    "990081": "加奈芃沙雕第3階段",
    "990082": "加奈芃沙雕第4階段",
    "990083": "加奈芃沙雕第5階段",
    "990084": "獨角獸沙雕第1階段",
    "990085": "獨角獸沙雕第2階段",
    "990086": "獨角獸沙雕第3階段",
    "990087": "獨角獸沙雕第4階段",
    "990088": "獨角獸沙雕第5階段",
    "990089": "人魚沙雕第1階段",
    "990090": "人魚沙雕第2階段",
    "990091": "人魚沙雕第3階段",
    "990092": "人魚沙雕第4階段",
    "990093": "人魚沙雕第5階段",
    "990094": "태양의 제단",
    "990095": "임시 캠프",
    "990096": "愛的火炬",
    "990097": "랜드마크",
    "990098": "騎士團徽章",
    "990099": "무한공격 더미",
    "990100": "餅乾帳蓬",
    "990101": "測試人偶 A類型",
    "990102": "小丑人偶",
    "990103": "小丑人偶",
    "990104": "小丑人偶",
    "990105": "小丑人偶",
    "990106": "人偶師的好友",
    "990107": "小丑人偶",
    "990108": "小丑人偶",
    "990109": "鋼琴",
    "990110": "刺菇菇",
    "990111": "綠菇菇",
    "990112": "雪吉拉",
    "990113": "企鵝王",
    "990114": "皮卡啾",
    "990115": "밀키웨이 피아노",
    "990116": "밀키웨이 첼로 의자",
    "990117": "廢棄的宅邸",
    "990118": "公演宣傳小幫手",
    "990121": "小丑人偶",
    "990123": "出現的棺",
    "990124": "吉拉克人偶",
    "990125": "墮落者的小丑人偶",
    "990126": "演唱會場紅龍",
    "990127": "爵士鼓",
    "990128": "排行表",
    "990130": "帕迪亞露露",
    "990131": "帕迪亞露露",
    "990132": "帕迪亞露露",
    "990133": "塔爾洛斯",
    "990134": "泰因奈",
    "990135": "加歐斯",
    "990136": "艾許卡",
    "990137": "索拉斯",
    "990138": "奧希德",
    "990140": "綠寶石巨魔像",
    "990141": "布魯森香水瓶",
    "990142": "布魯森香水瓶",
    "990143": "毒王蛇",
    "990144": "毒王蛇",
    "990145": "狗雪橇",
    "990146": "運送用駱駝",
    "990147": "運送用漂浮船",
    "990148": "狗雪橇",
    "990149": "[夥伴] 狗雪橇",
    "990150": "[夥伴] 運送用駱駝",
    "990151": "[夥伴] 運送用漂浮船",
    "990152": "[夥伴] 狗雪橇",
    "990153": "狗雪橇",
    "990154": "運送用高級駱駝",
    "990155": "運送用高級漂浮船",
    "990156": "高級狗雪橇",
    "990157": "[夥伴] 高級狗雪橇",
    "990158": "[夥伴] 運送用高級駱駝",
    "990159": "[夥伴] 運送用高級漂浮船",
    "990160": "[夥伴] 高級狗雪橇",
    "990161": "[活動]加奈芃的露營車",
    "990162": "[活動]貿易加奈芃的露營車",
    "990163": "[活動]逃跑芃的露營車",
    "990164": "[公會]狗雪橇",
    "990165": "[公會]駱駝",
    "990166": "[公會]漂浮船",
    "990167": "[公會]狗雪橇",
    "990168": "[公會][夥伴]狗雪橇",
    "990169": "[公會][夥伴]駱駝",
    "990170": "[公會][夥伴]漂浮船",
    "990171": "[公會][夥伴]狗雪橇",
    "990172": "夜之誓約小丑人偶",
    "990173": "妖魔小丑人偶",
    "990174": "靈魂解放者小丑人偶",
    "990175": "暗夜使者鳶尾花的眼淚",
    "990201": "測試人偶 B類型",
    "990202": "巨像人偶",
    "990203": "巨像人偶",
    "990204": "巨像人偶",
    "990205": "巨像人偶",
    "990206": "人偶師的作品",
    "990207": "巨像人偶",
    "990208": "巨像人偶",
    "990209": "움직이는 머리띠",
    "990210": "熊巨像人偶",
    "990211": "靈魂解放者巨像人偶",
    "990300": "무한궁술 더미",
    "990301": "무한마법 더미",
    "990302": "세룰리안 퀘스트 보드",
    "990303": "세룰리안 수정 구슬",
    "990304": "세룰리안 관람경",
    "990305": "가방의 모자",
    "990306": "자파리 빵",
    "990307": "럭키 비스트",
    "990308": "록호퍼 펭귄 등신대",
    "990309": "훔볼트 펭귄 등신대",
    "990310": "로열 펭귄 등신대",
    "990311": "황제 펭귄 등신대",
    "990312": "젠투 펭귄 등신대",
    "990313": "士官學校黑馬",
    "990314": "士官學校白馬",
    "990315": "馬夫",
    "990316": "페르시안",
    "990317": "페르시안",
    "990318": "玻璃燭台",
    "990319": "花之燈籠",
    "990320": "六角燈籠",
    "990321": "小雞燈籠",
    "990322": "轎夫",
    "990324": "繡球花大型籃子",
    "990325": "繡球花中型籃子",
    "990326": "繡球花束",
    "990327": "繡球花腳踏車",
    "990328": "亞蕾",
    "990329": "莫里提",
    "990330": "黑虎",
    "990331": "幼年黑虎",
    "990332": "黑虎",
    "990333": "兔子",
    "990334": "貓咪",
    "990335": "兔子",
    "990336": "貓咪",
    "990337": "精靈龍",
    "990338": "精靈龍",
    "990339": "精靈龍",
    "990340": "精靈龍",
    "990341": "精靈龍",
    "990342": "精靈龍",
    "990345": "記憶之鐘",
    "990352": "裝飾的短馬鞭",
    "990353": "鷹",
    "990354": "角鴞",
    "990355": "雪鴞",
    "990357": "角鴞",
    "990358": "雪鴞",
    "990359": "迷你的白貴賓狗迷你寵物",
    "990360": "迷你的暹羅貓迷你寵物",
    "990361": "迷你的梅花鹿迷你寵物",
    "990362": "迷你的棕狐狸迷你寵物",
    "990363": "蹭蹭喵醬",
    "990364": "踏踏喵醬",
    "990365": "狗狗雪橇",
    "990366": "運送用駱駝",
    "990367": "運送用漂浮船",
    "990368": "狗雪橇",
    "990369": "[夥伴]狗雪橇",
    "990370": "[夥伴]運送用駱駝",
    "990371": "[夥伴]運送用漂浮船",
    "990372": "[夥伴]狗雪橇",
    "990373": "幽靈貓",
    "990384": "蹭蹭喵醬模型",
    "990385": "哈士奇模型",
    "990386": "駱駝模型",
    "990387": "探險家小象模型",
    "990389": "聰明的貓咪",
    "990390": "聰明的貓咪",
    "990391": "一朵玫瑰",
    "990392": "犬靈",
    "990393": "守護的犬靈",
    "990394": "審判的犬靈",
    "990399": "貓咪村莊貓輪",
    "990400": "貓咪村莊旋轉木馬",
    "990401": "貓咪村莊溜滑梯",
    "990408": "拜克",
    "990409": "拜克",
    "990410": "害羞兔寶",
    "990411": "搞怪兔寶",
    "990412": "傲慢兔寶",
    "990413": "沉穩兔寶",
    "990420": "命運華爾滋小丑人偶",
    "990422": "일렁이는 푸른 늑대",
    "990423": "흰올빼미",
    "990424": "밤의 빗자루",
    "999996": "神秘的卡魯森林遺跡",
    "999997": "休威爾",
    "999998": "尼普雷",
    "999999": "納克",
};
